/* tslint:disable */
/* eslint-disable */
/**
 * AcctV2
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccountContact
 */
export interface AccountContact {
    /**
     * 
     * @type {number}
     * @memberof AccountContact
     */
    'contactId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountContact
     */
    'userId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AccountContact
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountContact
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountContact
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountContact
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountContact
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContact
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContact
     */
    'isPrimary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContact
     */
    'receivesAllEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContact
     */
    'receivesBillingEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContact
     */
    'receivesAccountAlertEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContact
     */
    'receivesIntegrationEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContact
     */
    'userIsArchived'?: boolean;
}
/**
 * 
 * @export
 * @interface AccountContactForStoreDto
 */
export interface AccountContactForStoreDto {
    /**
     * 
     * @type {number}
     * @memberof AccountContactForStoreDto
     */
    'userId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountContactForStoreDto
     */
    'contactId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContactForStoreDto
     */
    'isContactOnly'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountContactForStoreDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountContactForStoreDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountContactForStoreDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountContactForStoreDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContactForStoreDto
     */
    'isPrimaryContact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContactForStoreDto
     */
    'shouldReceiveAllEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContactForStoreDto
     */
    'shouldReceiveAccountAlertEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContactForStoreDto
     */
    'shouldReceiveBillingEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContactForStoreDto
     */
    'shouldReceiveIntegrationEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountContactForStoreDto
     */
    'isUserArchived'?: boolean | null;
    /**
     * 
     * @type {Array<AppAccess>}
     * @memberof AccountContactForStoreDto
     */
    'userAppAccess'?: Array<AppAccess> | null;
}
/**
 * 
 * @export
 * @interface AccountContactForStoreDtoArrayGenericResponse
 */
export interface AccountContactForStoreDtoArrayGenericResponse {
    /**
     * 
     * @type {Array<AccountContactForStoreDto>}
     * @memberof AccountContactForStoreDtoArrayGenericResponse
     */
    'data'?: Array<AccountContactForStoreDto> | null;
    /**
     * 
     * @type {object}
     * @memberof AccountContactForStoreDtoArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof AccountContactForStoreDtoArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof AccountContactForStoreDtoArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface AccountContactForStoreDtoGenericResponse
 */
export interface AccountContactForStoreDtoGenericResponse {
    /**
     * 
     * @type {AccountContactForStoreDto}
     * @memberof AccountContactForStoreDtoGenericResponse
     */
    'data'?: AccountContactForStoreDto;
    /**
     * 
     * @type {object}
     * @memberof AccountContactForStoreDtoGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof AccountContactForStoreDtoGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof AccountContactForStoreDtoGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface AccountContactGenericResponse
 */
export interface AccountContactGenericResponse {
    /**
     * 
     * @type {AccountContact}
     * @memberof AccountContactGenericResponse
     */
    'data'?: AccountContact;
    /**
     * 
     * @type {object}
     * @memberof AccountContactGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof AccountContactGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof AccountContactGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'locality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'currencyId'?: number | null;
}
/**
 * 
 * @export
 * @interface AdminCreateTrafficRouteCommand
 */
export interface AdminCreateTrafficRouteCommand {
    /**
     * 
     * @type {number}
     * @memberof AdminCreateTrafficRouteCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateTrafficRouteCommand
     */
    'setId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateTrafficRouteCommand
     */
    'name': string;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof AdminCreateTrafficRouteCommand
     */
    'start': TrafficPointDto;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof AdminCreateTrafficRouteCommand
     */
    'end': TrafficPointDto;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateTrafficRouteCommand
     */
    'startAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateTrafficRouteCommand
     */
    'endAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateTrafficRouteCommand
     */
    'roadIcon'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminDeleteTrafficRouteCommand
 */
export interface AdminDeleteTrafficRouteCommand {
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteTrafficRouteCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteTrafficRouteCommand
     */
    'routeId': number;
}
/**
 * 
 * @export
 * @interface AdminUpdateTrafficRouteCommand
 */
export interface AdminUpdateTrafficRouteCommand {
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateTrafficRouteCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateTrafficRouteCommand
     */
    'routeId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateTrafficRouteCommand
     */
    'setId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateTrafficRouteCommand
     */
    'name': string;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof AdminUpdateTrafficRouteCommand
     */
    'start': TrafficPointDto;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof AdminUpdateTrafficRouteCommand
     */
    'end': TrafficPointDto;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateTrafficRouteCommand
     */
    'startAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateTrafficRouteCommand
     */
    'endAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateTrafficRouteCommand
     */
    'roadIcon'?: string | null;
}
/**
 * 
 * @export
 * @interface AirportInfo
 */
export interface AirportInfo {
    /**
     * 
     * @type {string}
     * @memberof AirportInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AirportInfo
     */
    'iataCode': string;
    /**
     * 
     * @type {string}
     * @memberof AirportInfo
     */
    'icaoCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AirportInfo
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AirportInfo
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof AirportInfo
     */
    'popularity': number;
}
/**
 * 
 * @export
 * @interface AirportInfoArrayGenericResponse
 */
export interface AirportInfoArrayGenericResponse {
    /**
     * 
     * @type {Array<AirportInfo>}
     * @memberof AirportInfoArrayGenericResponse
     */
    'data'?: Array<AirportInfo> | null;
    /**
     * 
     * @type {object}
     * @memberof AirportInfoArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof AirportInfoArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof AirportInfoArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface AppAccess
 */
export interface AppAccess {
    /**
     * 
     * @type {number}
     * @memberof AppAccess
     */
    'appId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AppAccess
     */
    'appName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppAccess
     */
    'hasAccess'?: boolean;
}
/**
 * 
 * @export
 * @interface ArchiveCustomerRequest
 */
export interface ArchiveCustomerRequest {
    /**
     * 
     * @type {number}
     * @memberof ArchiveCustomerRequest
     */
    'customerAccountId'?: number;
}
/**
 * 
 * @export
 * @interface ArchiveCustomerResponseGenericResponse
 */
export interface ArchiveCustomerResponseGenericResponse {
    /**
     * 
     * @type {object}
     * @memberof ArchiveCustomerResponseGenericResponse
     */
    'data'?: object;
    /**
     * 
     * @type {object}
     * @memberof ArchiveCustomerResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ArchiveCustomerResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ArchiveCustomerResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ArchiveUserCommand
 */
export interface ArchiveUserCommand {
    /**
     * 
     * @type {number}
     * @memberof ArchiveUserCommand
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ArchiveUserCommand
     */
    'newOwnerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArchiveUserCommand
     */
    'isArchived'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ArchiveUserCommand
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface ArchiveUserCommandGenericResponse
 */
export interface ArchiveUserCommandGenericResponse {
    /**
     * 
     * @type {ArchiveUserCommand}
     * @memberof ArchiveUserCommandGenericResponse
     */
    'data'?: ArchiveUserCommand;
    /**
     * 
     * @type {object}
     * @memberof ArchiveUserCommandGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ArchiveUserCommandGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ArchiveUserCommandGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @enum {string}
 */

export type AuthType = "None" | "ApiKey" | "AccessKey" | "OAuth2";


/**
 * 
 * @export
 * @interface Authentication
 */
export interface Authentication {
    /**
     * 
     * @type {AuthType}
     * @memberof Authentication
     */
    'type'?: AuthType;
    /**
     * 
     * @type {string}
     * @memberof Authentication
     */
    'endpoint'?: string | null;
}


/**
 * 
 * @export
 * @interface Authorization
 */
export interface Authorization {
    /**
     * 
     * @type {number}
     * @memberof Authorization
     */
    'providerAuthId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Authorization
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Authorization
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface AuthorizationIEnumerableGenericResponse
 */
export interface AuthorizationIEnumerableGenericResponse {
    /**
     * 
     * @type {Array<Authorization>}
     * @memberof AuthorizationIEnumerableGenericResponse
     */
    'data'?: Array<Authorization> | null;
    /**
     * 
     * @type {object}
     * @memberof AuthorizationIEnumerableGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof AuthorizationIEnumerableGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof AuthorizationIEnumerableGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface Bill
 */
export interface Bill {
    /**
     * 
     * @type {number}
     * @memberof Bill
     */
    'billId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Bill
     */
    'currencyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'dueOn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'orderDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'paidOn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'licensedUntil'?: string;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {Array<Payment>}
     * @memberof Bill
     */
    'payments'?: Array<Payment> | null;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'status'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Bill
     */
    'totalDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Bill
     */
    'totalPayments'?: number;
    /**
     * 
     * @type {number}
     * @memberof Bill
     */
    'balance'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Bill
     */
    'isPaidInFull'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Bill
     */
    'isPaidInPart'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Bill
     */
    'isOverdue'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Bill
     */
    'daysOverdue'?: number;
}
/**
 * 
 * @export
 * @interface BillItem
 */
export interface BillItem {
    /**
     * 
     * @type {number}
     * @memberof BillItem
     */
    'billItemId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BillItem
     */
    'packageName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BillItem
     */
    'packageId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BillItem
     */
    'numberOfLicenses'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillItem
     */
    'cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillItem
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface BillingSettings
 */
export interface BillingSettings {
    /**
     * 
     * @type {string}
     * @memberof BillingSettings
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingSettings
     */
    'frequency'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BillingSettings
     */
    'frequencyMultiplier'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillingSettings
     */
    'discount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillingSettings
     */
    'terms'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillingSettings
     */
    'day'?: number;
    /**
     * 
     * @type {CreditCard}
     * @memberof BillingSettings
     */
    'card'?: CreditCard;
    /**
     * 
     * @type {InvoiceSettings}
     * @memberof BillingSettings
     */
    'invoiceSettings'?: InvoiceSettings;
    /**
     * 
     * @type {Array<string>}
     * @memberof BillingSettings
     */
    'emailRecipients'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface BrandedMenuInfo
 */
export interface BrandedMenuInfo {
    /**
     * 
     * @type {string}
     * @memberof BrandedMenuInfo
     */
    'subdomain'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrandedMenuInfo
     */
    'logoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrandedMenuInfo
     */
    'bannerColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrandedMenuInfo
     */
    'accentColor'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BrandedMenuInfo
     */
    'hiddenPackageIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export type CalendarAccessRole = "FreeBusyReader" | "Owner" | "Reader" | "Writer";


/**
 * 
 * @export
 * @interface CalendarDto
 */
export interface CalendarDto {
    /**
     * 
     * @type {string}
     * @memberof CalendarDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarDto
     */
    'summary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarDto
     */
    'backgroundColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarDto
     */
    'foregroundColor'?: string | null;
}
/**
 * 
 * @export
 * @interface CalendarListDto
 */
export interface CalendarListDto {
    /**
     * 
     * @type {number}
     * @memberof CalendarListDto
     */
    'providerAuthId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CalendarListDto
     */
    'nextPageToken'?: string | null;
    /**
     * 
     * @type {Array<CalendarDto>}
     * @memberof CalendarListDto
     */
    'calendars'?: Array<CalendarDto> | null;
}
/**
 * 
 * @export
 * @interface CalendarListDtoGenericResponse
 */
export interface CalendarListDtoGenericResponse {
    /**
     * 
     * @type {CalendarListDto}
     * @memberof CalendarListDtoGenericResponse
     */
    'data'?: CalendarListDto;
    /**
     * 
     * @type {object}
     * @memberof CalendarListDtoGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof CalendarListDtoGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof CalendarListDtoGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface CancelSubscriptionFeedback
 */
export interface CancelSubscriptionFeedback {
    /**
     * 
     * @type {string}
     * @memberof CancelSubscriptionFeedback
     */
    'reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CancelSubscriptionFeedback
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface CategoryItem
 */
export interface CategoryItem {
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    'label'?: string | null;
}
/**
 * 
 * @export
 * @interface CategoryItemArrayGenericResponse
 */
export interface CategoryItemArrayGenericResponse {
    /**
     * 
     * @type {Array<CategoryItem>}
     * @memberof CategoryItemArrayGenericResponse
     */
    'data'?: Array<CategoryItem> | null;
    /**
     * 
     * @type {object}
     * @memberof CategoryItemArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof CategoryItemArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof CategoryItemArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ChannelInfo
 */
export interface ChannelInfo {
    /**
     * 
     * @type {number}
     * @memberof ChannelInfo
     */
    'channelId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChannelInfo
     */
    'isSelected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChannelInfo
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChannelInfo
     */
    'itemCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChannelInfo
     */
    'maxAllowed'?: number | null;
}
/**
 * 
 * @export
 * @interface ChannelSelectingSelectListItem
 */
export interface ChannelSelectingSelectListItem {
    /**
     * 
     * @type {string}
     * @memberof ChannelSelectingSelectListItem
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChannelSelectingSelectListItem
     */
    'value'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChannelSelectingSelectListItem
     */
    'channelIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChannelSelectingSelectListItem
     */
    'customizable'?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: object | null; }}
     * @memberof ChannelSelectingSelectListItem
     */
    'defaultValues'?: { [key: string]: object | null; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChannelSelectingSelectListItem
     */
    'deprecated'?: boolean | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChannelSelectingSelectListItem
     */
    'allowedFormatIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ClientAuthModelDto
 */
export interface ClientAuthModelDto {
    /**
     * 
     * @type {string}
     * @memberof ClientAuthModelDto
     */
    'oAuthEndpoint'?: string | null;
}
/**
 * 
 * @export
 * @interface ClientAuthModelDtoGenericResponse
 */
export interface ClientAuthModelDtoGenericResponse {
    /**
     * 
     * @type {ClientAuthModelDto}
     * @memberof ClientAuthModelDtoGenericResponse
     */
    'data'?: ClientAuthModelDto;
    /**
     * 
     * @type {object}
     * @memberof ClientAuthModelDtoGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ClientAuthModelDtoGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ClientAuthModelDtoGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface CloneFeedCommand
 */
export interface CloneFeedCommand {
    /**
     * 
     * @type {number}
     * @memberof CloneFeedCommand
     */
    'feedId': number;
    /**
     * 
     * @type {string}
     * @memberof CloneFeedCommand
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface CloneFeedCommandResponse
 */
export interface CloneFeedCommandResponse {
    /**
     * 
     * @type {number}
     * @memberof CloneFeedCommandResponse
     */
    'feedId': number;
    /**
     * 
     * @type {string}
     * @memberof CloneFeedCommandResponse
     */
    'feedUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CloneFeedCommandResponse
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof CloneFeedCommandResponse
     */
    'deliveryMethod': string;
    /**
     * 
     * @type {number}
     * @memberof CloneFeedCommandResponse
     */
    'actualWidth'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CloneFeedCommandResponse
     */
    'actualHeight'?: number | null;
    /**
     * 
     * @type {FeedModerationMethod}
     * @memberof CloneFeedCommandResponse
     */
    'moderationMethod'?: FeedModerationMethod;
    /**
     * 
     * @type {boolean}
     * @memberof CloneFeedCommandResponse
     */
    'canModerate'?: boolean;
}


/**
 * 
 * @export
 * @interface CloneFeedCommandResponseGenericResponse
 */
export interface CloneFeedCommandResponseGenericResponse {
    /**
     * 
     * @type {CloneFeedCommandResponse}
     * @memberof CloneFeedCommandResponseGenericResponse
     */
    'data'?: CloneFeedCommandResponse;
    /**
     * 
     * @type {object}
     * @memberof CloneFeedCommandResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof CloneFeedCommandResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof CloneFeedCommandResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface Connection
 */
export interface Connection {
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'authUsername'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'source'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Connection
     */
    'isFaulted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'faultCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'faultMessage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Connection
     */
    'providerAuthId'?: number | null;
    /**
     * 
     * @type {Provider}
     * @memberof Connection
     */
    'provider'?: Provider;
    /**
     * 
     * @type {Array<ConnectionOption>}
     * @memberof Connection
     */
    'options'?: Array<ConnectionOption> | null;
}
/**
 * 
 * @export
 * @interface ConnectionContext
 */
export interface ConnectionContext {
    /**
     * 
     * @type {string}
     * @memberof ConnectionContext
     */
    'connectedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionContext
     */
    'userAgent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectionContext
     */
    'ipAddress'?: string | null;
}
/**
 * 
 * @export
 * @interface ConnectionContextGenericResponse
 */
export interface ConnectionContextGenericResponse {
    /**
     * 
     * @type {ConnectionContext}
     * @memberof ConnectionContextGenericResponse
     */
    'data'?: ConnectionContext;
    /**
     * 
     * @type {object}
     * @memberof ConnectionContextGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ConnectionContextGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ConnectionContextGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ConnectionMetrics
 */
export interface ConnectionMetrics {
    /**
     * 
     * @type {number}
     * @memberof ConnectionMetrics
     */
    'totalChannels'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectionMetrics
     */
    'totalConnections'?: number;
    /**
     * 
     * @type {{ [key: string]: number | null; }}
     * @memberof ConnectionMetrics
     */
    'connectionsPerChannel'?: { [key: string]: number | null; } | null;
    /**
     * 
     * @type {{ [key: string]: Array<string> | null; }}
     * @memberof ConnectionMetrics
     */
    'connectionsToChannel'?: { [key: string]: Array<string> | null; } | null;
    /**
     * 
     * @type {number}
     * @memberof ConnectionMetrics
     */
    'totalContexts'?: number;
}
/**
 * 
 * @export
 * @interface ConnectionMetricsGenericResponse
 */
export interface ConnectionMetricsGenericResponse {
    /**
     * 
     * @type {ConnectionMetrics}
     * @memberof ConnectionMetricsGenericResponse
     */
    'data'?: ConnectionMetrics;
    /**
     * 
     * @type {object}
     * @memberof ConnectionMetricsGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ConnectionMetricsGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ConnectionMetricsGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ConnectionOption
 */
export interface ConnectionOption {
    /**
     * 
     * @type {string}
     * @memberof ConnectionOption
     */
    'name'?: string | null;
    /**
     * 
     * @type {ConnectionOptionType}
     * @memberof ConnectionOption
     */
    'type'?: ConnectionOptionType;
    /**
     * 
     * @type {string}
     * @memberof ConnectionOption
     */
    'value'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export type ConnectionOptionType = "Method" | "Header" | "Parameter" | "Body" | "Config";


/**
 * 
 * @export
 * @interface ConnectionProvider
 */
export interface ConnectionProvider {
    /**
     * 
     * @type {string}
     * @memberof ConnectionProvider
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectionProvider
     */
    'slug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectionProvider
     */
    'provisionMethod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectionProvider
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectionProvider
     */
    'displayDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectionProvider
     */
    'isRefreshable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectionProvider
     */
    'canModerate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConnectionProvider
     */
    'iconUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectionProvider
     */
    'supportArticleUrl'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConnectionProvider
     */
    'setupSteps'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: string | null; }}
     * @memberof ConnectionProvider
     */
    'setupProperties'?: { [key: string]: string | null; } | null;
    /**
     * 
     * @type {SchemaType}
     * @memberof ConnectionProvider
     */
    'schemaType'?: SchemaType;
    /**
     * 
     * @type {Array<SetupStep>}
     * @memberof ConnectionProvider
     */
    'setupStepsV2'?: Array<SetupStep> | null;
    /**
     * 
     * @type {number}
     * @memberof ConnectionProvider
     */
    'providerDefinitionVersion'?: number | null;
    /**
     * 
     * @type {Documentation}
     * @memberof ConnectionProvider
     */
    'documentation'?: Documentation;
    /**
     * 
     * @type {Array<number>}
     * @memberof ConnectionProvider
     */
    'accountIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectionProvider
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectionProvider
     */
    'isConnectDataSource'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectionProvider
     */
    'isFeedConfigDataSource'?: boolean;
}


/**
 * 
 * @export
 * @interface ConnectionProviderArrayGenericResponse
 */
export interface ConnectionProviderArrayGenericResponse {
    /**
     * 
     * @type {Array<ConnectionProvider>}
     * @memberof ConnectionProviderArrayGenericResponse
     */
    'data'?: Array<ConnectionProvider> | null;
    /**
     * 
     * @type {object}
     * @memberof ConnectionProviderArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ConnectionProviderArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ConnectionProviderArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'contactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'locality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'postCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface ContentItem
 */
export interface ContentItem {
    /**
     * 
     * @type {string}
     * @memberof ContentItem
     */
    'contentId'?: string | null;
    /**
     * 
     * @type {ContentModerationStatus}
     * @memberof ContentItem
     */
    'moderationStatus'?: ContentModerationStatus;
    /**
     * 
     * @type {string}
     * @memberof ContentItem
     */
    'published'?: string | null;
    /**
     * 
     * @type {NewsItem}
     * @memberof ContentItem
     */
    'newsItem'?: NewsItem;
}


/**
 * 
 * @export
 * @enum {string}
 */

export type ContentModerationStatus = "Approved" | "Removed" | "Undecided";


/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof Country
     */
    'currencies'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CreateAccountBillingEmailRequest
 */
export interface CreateAccountBillingEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateAccountBillingEmailRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountBillingEmailRequest
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateAccountFromAccountCommand
 */
export interface CreateAccountFromAccountCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountFromAccountCommand
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountFromAccountCommand
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountFromAccountCommand
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountFromAccountCommand
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountFromAccountCommand
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountFromAccountCommand
     */
    'referrer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountFromAccountCommand
     */
    'contactName'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateAccountFromAccountResult
 */
export interface CreateAccountFromAccountResult {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountFromAccountResult
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountFromAccountResult
     */
    'accountGuid'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateAccountFromAccountResultGenericResponse
 */
export interface CreateAccountFromAccountResultGenericResponse {
    /**
     * 
     * @type {CreateAccountFromAccountResult}
     * @memberof CreateAccountFromAccountResultGenericResponse
     */
    'data'?: CreateAccountFromAccountResult;
    /**
     * 
     * @type {object}
     * @memberof CreateAccountFromAccountResultGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof CreateAccountFromAccountResultGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof CreateAccountFromAccountResultGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface CreateChildAccountFromStoreCommand
 */
export interface CreateChildAccountFromStoreCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'contactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'locality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'postCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChildAccountFromStoreCommand
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateChildAccountResponse
 */
export interface CreateChildAccountResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateChildAccountResponse
     */
    'accountId'?: number;
}
/**
 * 
 * @export
 * @interface CreateChildAccountResponseGenericResponse
 */
export interface CreateChildAccountResponseGenericResponse {
    /**
     * 
     * @type {CreateChildAccountResponse}
     * @memberof CreateChildAccountResponseGenericResponse
     */
    'data'?: CreateChildAccountResponse;
    /**
     * 
     * @type {object}
     * @memberof CreateChildAccountResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof CreateChildAccountResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof CreateChildAccountResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface CreateFeedConnection
 */
export interface CreateFeedConnection {
    /**
     * 
     * @type {number}
     * @memberof CreateFeedConnection
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedConnection
     */
    'slug'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof CreateFeedConnection
     */
    'model'?: object | null;
}
/**
 * 
 * @export
 * @interface CreateFeedConnectionResponse
 */
export interface CreateFeedConnectionResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateFeedConnectionResponse
     */
    'connectionUuid'?: string;
}
/**
 * 
 * @export
 * @interface CreateFeedConnectionResponseGenericResponse
 */
export interface CreateFeedConnectionResponseGenericResponse {
    /**
     * 
     * @type {CreateFeedConnectionResponse}
     * @memberof CreateFeedConnectionResponseGenericResponse
     */
    'data'?: CreateFeedConnectionResponse;
    /**
     * 
     * @type {object}
     * @memberof CreateFeedConnectionResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof CreateFeedConnectionResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof CreateFeedConnectionResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface CreateFeedRequest
 */
export interface CreateFeedRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateFeedRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateFeedRequest
     */
    'packageId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateFeedRequest
     */
    'formatId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedRequest
     */
    'name': string;
    /**
     * 
     * @type {FeedDeliveryMethod}
     * @memberof CreateFeedRequest
     */
    'deliveryMethod'?: FeedDeliveryMethod;
    /**
     * 
     * @type {FeedModerationMethod}
     * @memberof CreateFeedRequest
     */
    'moderationMethod'?: FeedModerationMethod;
    /**
     * 
     * @type {Array<ChannelInfo>}
     * @memberof CreateFeedRequest
     */
    'channels'?: Array<ChannelInfo> | null;
    /**
     * 
     * @type {Array<DataConnection>}
     * @memberof CreateFeedRequest
     */
    'connections'?: Array<DataConnection> | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateFeedRequest
     */
    'options'?: { [key: string]: string; } | null;
}


/**
 * 
 * @export
 * @interface CreateFeedResponse
 */
export interface CreateFeedResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateFeedResponse
     */
    'feedId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateFeedResponse
     */
    'packageId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'packageName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'accessKey': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'feedUuid': string;
    /**
     * 
     * @type {number}
     * @memberof CreateFeedResponse
     */
    'actualWidth'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateFeedResponse
     */
    'actualHeight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'deliveryMethod': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'url': string;
    /**
     * 
     * @type {FeedModerationMethod}
     * @memberof CreateFeedResponse
     */
    'moderationMethod'?: FeedModerationMethod;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFeedResponse
     */
    'requiresSetup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFeedResponse
     */
    'canModerate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'playerAuthMode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'playerSoftware'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'playlistUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'pluginDownloadUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedResponse
     */
    'triggerUrl'?: string | null;
}


/**
 * 
 * @export
 * @interface CreateFeedResponseGenericResponse
 */
export interface CreateFeedResponseGenericResponse {
    /**
     * 
     * @type {CreateFeedResponse}
     * @memberof CreateFeedResponseGenericResponse
     */
    'data'?: CreateFeedResponse;
    /**
     * 
     * @type {object}
     * @memberof CreateFeedResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof CreateFeedResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof CreateFeedResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface CreateProviderAuthMagicLinkCommand
 */
export interface CreateProviderAuthMagicLinkCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateProviderAuthMagicLinkCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProviderAuthMagicLinkCommand
     */
    'providerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProviderAuthMagicLinkCommand
     */
    'providerAuthId'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProviderAuthMagicLinkCommand
     */
    'emailAddresses'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProviderAuthMagicLinkCommand
     */
    'shouldSendInviteEmail'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateProviderAuthMagicLinkResult
 */
export interface CreateProviderAuthMagicLinkResult {
    /**
     * 
     * @type {string}
     * @memberof CreateProviderAuthMagicLinkResult
     */
    'lifetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderAuthMagicLinkResult
     */
    'link'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateProviderAuthMagicLinkResultGenericResponse
 */
export interface CreateProviderAuthMagicLinkResultGenericResponse {
    /**
     * 
     * @type {CreateProviderAuthMagicLinkResult}
     * @memberof CreateProviderAuthMagicLinkResultGenericResponse
     */
    'data'?: CreateProviderAuthMagicLinkResult;
    /**
     * 
     * @type {object}
     * @memberof CreateProviderAuthMagicLinkResultGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof CreateProviderAuthMagicLinkResultGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof CreateProviderAuthMagicLinkResultGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface CreateProviderSchemaCommand
 */
export interface CreateProviderSchemaCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateProviderSchemaCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderSchemaCommand
     */
    'slug'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof CreateProviderSchemaCommand
     */
    'model'?: object | null;
}
/**
 * 
 * @export
 * @interface CreateSocialSearchCommand
 */
export interface CreateSocialSearchCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateSocialSearchCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSocialSearchCommand
     */
    'externalCustomerId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSocialSearchCommand
     */
    'providerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSocialSearchCommand
     */
    'authId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSocialSearchCommand
     */
    'query'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSocialSearchCommand
     */
    'displayName'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateTrafficRegionCommand
 */
export interface CreateTrafficRegionCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateTrafficRegionCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTrafficRegionCommand
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateTrafficRouteCommand
 */
export interface CreateTrafficRouteCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateTrafficRouteCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTrafficRouteCommand
     */
    'name': string;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof CreateTrafficRouteCommand
     */
    'start': TrafficPointDto;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof CreateTrafficRouteCommand
     */
    'end': TrafficPointDto;
    /**
     * 
     * @type {string}
     * @memberof CreateTrafficRouteCommand
     */
    'startAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrafficRouteCommand
     */
    'endAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrafficRouteCommand
     */
    'roadIcon'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateTrafficSetCommand
 */
export interface CreateTrafficSetCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateTrafficSetCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTrafficSetCommand
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTrafficSetCommand
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrafficSetCommand
     */
    'regionId': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTrafficSetCommand
     */
    'private'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateTrafficSetCommand
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrafficSetCommand
     */
    'longitude'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateTrialSubscriptionFromAcctCommand
 */
export interface CreateTrialSubscriptionFromAcctCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateTrialSubscriptionFromAcctCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrialSubscriptionFromAcctCommand
     */
    'packageId'?: number;
}
/**
 * 
 * @export
 * @interface CreateUserFromStoreCommand
 */
export interface CreateUserFromStoreCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateUserFromStoreCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserFromStoreCommand
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserFromStoreCommand
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserFromStoreCommand
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserFromStoreCommand
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserFromStoreCommand
     */
    'password'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserFromStoreCommand
     */
    'isPrimaryContact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserFromStoreCommand
     */
    'shouldReceiveAllEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserFromStoreCommand
     */
    'shouldReceiveAccountAlertEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserFromStoreCommand
     */
    'shouldReceiveBillingEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserFromStoreCommand
     */
    'shouldReceiveIntegrationEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserFromStoreCommand
     */
    'shouldSendInviteEmail'?: boolean;
    /**
     * 
     * @type {Array<AppAccess>}
     * @memberof CreateUserFromStoreCommand
     */
    'appAccess'?: Array<AppAccess> | null;
}
/**
 * 
 * @export
 * @interface CreateUserMagicInviteLinkCommand
 */
export interface CreateUserMagicInviteLinkCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateUserMagicInviteLinkCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUserMagicInviteLinkCommand
     */
    'userId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserMagicInviteLinkCommand
     */
    'shouldSendInviteEmail'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateUserMagicLinkInviteResult
 */
export interface CreateUserMagicLinkInviteResult {
    /**
     * 
     * @type {string}
     * @memberof CreateUserMagicLinkInviteResult
     */
    'lifetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserMagicLinkInviteResult
     */
    'link'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateUserMagicLinkInviteResultGenericResponse
 */
export interface CreateUserMagicLinkInviteResultGenericResponse {
    /**
     * 
     * @type {CreateUserMagicLinkInviteResult}
     * @memberof CreateUserMagicLinkInviteResultGenericResponse
     */
    'data'?: CreateUserMagicLinkInviteResult;
    /**
     * 
     * @type {object}
     * @memberof CreateUserMagicLinkInviteResultGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof CreateUserMagicLinkInviteResultGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof CreateUserMagicLinkInviteResultGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface CreditCard
 */
export interface CreditCard {
    /**
     * 
     * @type {number}
     * @memberof CreditCard
     */
    'creditCardId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreditCard
     */
    'cardType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreditCard
     */
    'billToName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreditCard
     */
    'lastFour'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreditCard
     */
    'expireMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreditCard
     */
    'expireYear'?: number;
    /**
     * 
     * @type {Address}
     * @memberof CreditCard
     */
    'billingAddress'?: Address;
}
/**
 * 
 * @export
 * @interface Currency
 */
export interface Currency {
    /**
     * 
     * @type {number}
     * @memberof Currency
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Currency
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Currency
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Currency
     */
    'symbol'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Currency
     */
    'listOrder'?: number;
}
/**
 * 
 * @export
 * @interface Customer
 */
export interface Customer {
    /**
     * 
     * @type {number}
     * @memberof Customer
     */
    'accountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    'isArchived'?: boolean;
}
/**
 * 
 * @export
 * @interface DataConnection
 */
export interface DataConnection {
    /**
     * 
     * @type {string}
     * @memberof DataConnection
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface DeactivateSubscriptionFromAcctCommand
 */
export interface DeactivateSubscriptionFromAcctCommand {
    /**
     * 
     * @type {number}
     * @memberof DeactivateSubscriptionFromAcctCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeactivateSubscriptionFromAcctCommand
     */
    'subscriptionUuid'?: string | null;
    /**
     * 
     * @type {Array<CancelSubscriptionFeedback>}
     * @memberof DeactivateSubscriptionFromAcctCommand
     */
    'feedback'?: Array<CancelSubscriptionFeedback> | null;
}
/**
 * 
 * @export
 * @interface DefineSchemaStep
 */
export interface DefineSchemaStep {
    /**
     * 
     * @type {number}
     * @memberof DefineSchemaStep
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof DefineSchemaStep
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DefineSchemaStep
     */
    'clientComponentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DefineSchemaStep
     */
    'displayNameI18nKey'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DefineSchemaStep
     */
    'shouldPersistConnection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefineSchemaStep
     */
    'shouldShowInNavigation'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DefineSchemaStep
     */
    'model'?: Array<string> | null;
    /**
     * 
     * @type {DefineSchemaType}
     * @memberof DefineSchemaStep
     */
    'type'?: DefineSchemaType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export type DefineSchemaType = "Tabular" | "Tree" | "Manual" | "Calendar";


/**
 * 
 * @export
 * @interface DeleteProviderAuthCommand
 */
export interface DeleteProviderAuthCommand {
    /**
     * 
     * @type {number}
     * @memberof DeleteProviderAuthCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteProviderAuthCommand
     */
    'providerAuthId'?: number;
}
/**
 * 
 * @export
 * @interface DeleteProviderAuthCommandGenericResponse
 */
export interface DeleteProviderAuthCommandGenericResponse {
    /**
     * 
     * @type {DeleteProviderAuthCommand}
     * @memberof DeleteProviderAuthCommandGenericResponse
     */
    'data'?: DeleteProviderAuthCommand;
    /**
     * 
     * @type {object}
     * @memberof DeleteProviderAuthCommandGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof DeleteProviderAuthCommandGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof DeleteProviderAuthCommandGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface DeleteTrafficRegionCommand
 */
export interface DeleteTrafficRegionCommand {
    /**
     * 
     * @type {number}
     * @memberof DeleteTrafficRegionCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteTrafficRegionCommand
     */
    'regionId': number;
}
/**
 * 
 * @export
 * @interface DeleteTrafficRouteCommand
 */
export interface DeleteTrafficRouteCommand {
    /**
     * 
     * @type {number}
     * @memberof DeleteTrafficRouteCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteTrafficRouteCommand
     */
    'routeId': number;
}
/**
 * 
 * @export
 * @interface DeleteTrafficRouteResponse
 */
export interface DeleteTrafficRouteResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof DeleteTrafficRouteResponse
     */
    'referencingFeedIds': Array<number>;
}
/**
 * 
 * @export
 * @interface DeleteTrafficRouteResponseGenericResponse
 */
export interface DeleteTrafficRouteResponseGenericResponse {
    /**
     * 
     * @type {DeleteTrafficRouteResponse}
     * @memberof DeleteTrafficRouteResponseGenericResponse
     */
    'data'?: DeleteTrafficRouteResponse;
    /**
     * 
     * @type {object}
     * @memberof DeleteTrafficRouteResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof DeleteTrafficRouteResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof DeleteTrafficRouteResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface DeleteTrafficSetCommand
 */
export interface DeleteTrafficSetCommand {
    /**
     * 
     * @type {number}
     * @memberof DeleteTrafficSetCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteTrafficSetCommand
     */
    'setId': number;
}
/**
 * 
 * @export
 * @interface DeliveryMethodsConfig
 */
export interface DeliveryMethodsConfig {
    /**
     * 
     * @type {FeedDeliveryMethod}
     * @memberof DeliveryMethodsConfig
     */
    'defaultDeliveryMethod'?: FeedDeliveryMethod;
    /**
     * 
     * @type {Array<FeedDeliveryMethod>}
     * @memberof DeliveryMethodsConfig
     */
    'deliveryMethodOrder'?: Array<FeedDeliveryMethod> | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryMethodsConfig
     */
    'additionalMessage'?: string | null;
}


/**
 * 
 * @export
 * @interface Documentation
 */
export interface Documentation {
    /**
     * 
     * @type {string}
     * @memberof Documentation
     */
    'clientComponentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Documentation
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface EmbedObjectDto
 */
export interface EmbedObjectDto {
    /**
     * 
     * @type {string}
     * @memberof EmbedObjectDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmbedObjectDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmbedObjectDto
     */
    'embedUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmbedObjectDto
     */
    'webUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface EmbedObjectDtoIEnumerableGenericResponse
 */
export interface EmbedObjectDtoIEnumerableGenericResponse {
    /**
     * 
     * @type {Array<EmbedObjectDto>}
     * @memberof EmbedObjectDtoIEnumerableGenericResponse
     */
    'data'?: Array<EmbedObjectDto> | null;
    /**
     * 
     * @type {object}
     * @memberof EmbedObjectDtoIEnumerableGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof EmbedObjectDtoIEnumerableGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof EmbedObjectDtoIEnumerableGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface EmptyResponseGenericResponse
 */
export interface EmptyResponseGenericResponse {
    /**
     * 
     * @type {object}
     * @memberof EmptyResponseGenericResponse
     */
    'data'?: object;
    /**
     * 
     * @type {object}
     * @memberof EmptyResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof EmptyResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof EmptyResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ErrorDetail
 */
export interface ErrorDetail {
    /**
     * 
     * @type {string}
     * @memberof ErrorDetail
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetail
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface ExchangeCodeCommand
 */
export interface ExchangeCodeCommand {
    /**
     * 
     * @type {string}
     * @memberof ExchangeCodeCommand
     */
    'code'?: string | null;
}
/**
 * 
 * @export
 * @interface ExchangeCodeResult
 */
export interface ExchangeCodeResult {
    /**
     * 
     * @type {string}
     * @memberof ExchangeCodeResult
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeCodeResult
     */
    'accountGuid'?: string | null;
}
/**
 * 
 * @export
 * @interface ExchangeCodeResultGenericResponse
 */
export interface ExchangeCodeResultGenericResponse {
    /**
     * 
     * @type {ExchangeCodeResult}
     * @memberof ExchangeCodeResultGenericResponse
     */
    'data'?: ExchangeCodeResult;
    /**
     * 
     * @type {object}
     * @memberof ExchangeCodeResultGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ExchangeCodeResultGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ExchangeCodeResultGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ExpiringTrialsResponse
 */
export interface ExpiringTrialsResponse {
    /**
     * 
     * @type {Array<TrialSubscriptions>}
     * @memberof ExpiringTrialsResponse
     */
    'trials'?: Array<TrialSubscriptions> | null;
}
/**
 * 
 * @export
 * @interface ExpiringTrialsResponseGenericResponse
 */
export interface ExpiringTrialsResponseGenericResponse {
    /**
     * 
     * @type {ExpiringTrialsResponse}
     * @memberof ExpiringTrialsResponseGenericResponse
     */
    'data'?: ExpiringTrialsResponse;
    /**
     * 
     * @type {object}
     * @memberof ExpiringTrialsResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ExpiringTrialsResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ExpiringTrialsResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ExternalFeed
 */
export interface ExternalFeed {
    /**
     * 
     * @type {number}
     * @memberof ExternalFeed
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ExternalFeed
     */
    'providerSlug': string;
    /**
     * 
     * @type {string}
     * @memberof ExternalFeed
     */
    'providerDisplayName': string;
    /**
     * 
     * @type {ExternalFeedStatus}
     * @memberof ExternalFeed
     */
    'status': ExternalFeedStatus;
    /**
     * 
     * @type {ExternalFeedErrorCode}
     * @memberof ExternalFeed
     */
    'errorCode'?: ExternalFeedErrorCode;
    /**
     * 
     * @type {string}
     * @memberof ExternalFeed
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalFeed
     */
    'updatedOnUtc'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export type ExternalFeedErrorCode = "None" | "Unknown" | "Conflict" | "Unauthorized" | "HttpTimeout" | "HttpException";


/**
 * 
 * @export
 * @enum {string}
 */

export type ExternalFeedStatus = "Pending" | "Published" | "Error" | "None" | "Deleted";


/**
 * 
 * @export
 * @interface Feed
 */
export interface Feed {
    /**
     * 
     * @type {number}
     * @memberof Feed
     */
    'feedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Feed
     */
    'accessKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Feed
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Feed
     */
    'actualWidth'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Feed
     */
    'actualHeight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Feed
     */
    'deliveryMethod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Feed
     */
    'url'?: string | null;
    /**
     * 
     * @type {FeedModerationMethod}
     * @memberof Feed
     */
    'moderationMethod'?: FeedModerationMethod;
    /**
     * 
     * @type {boolean}
     * @memberof Feed
     */
    'requiresSetup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Feed
     */
    'formatName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Feed
     */
    'theme'?: string | null;
}


/**
 * 
 * @export
 * @interface FeedCreationChannel
 */
export interface FeedCreationChannel {
    /**
     * 
     * @type {number}
     * @memberof FeedCreationChannel
     */
    'channelId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeedCreationChannel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedCreationChannel
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCreationChannel
     */
    'itemCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCreationChannel
     */
    'maxAllowed'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FeedCreationChannel
     */
    'isSelected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FeedCreationChannel
     */
    'culture'?: string | null;
}
/**
 * 
 * @export
 * @interface FeedCreationFormat
 */
export interface FeedCreationFormat {
    /**
     * 
     * @type {number}
     * @memberof FeedCreationFormat
     */
    'formatId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeedCreationFormat
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedCreationFormat
     */
    'aspectRatio'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCreationFormat
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedCreationFormat
     */
    'height'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FeedCreationFormat
     */
    'channelIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface FeedCreationOption
 */
export interface FeedCreationOption {
    /**
     * 
     * @type {object}
     * @memberof FeedCreationOption
     */
    'defaultValue'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof FeedCreationOption
     */
    'required'?: boolean | null;
    /**
     * 
     * @type {Array<SelectListItem>}
     * @memberof FeedCreationOption
     */
    'selectList'?: Array<SelectListItem> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FeedCreationOption
     */
    'onlyForChannelIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface FeedCreationOptions
 */
export interface FeedCreationOptions {
    /**
     * 
     * @type {Array<number>}
     * @memberof FeedCreationOptions
     */
    'channelIds'?: Array<number> | null;
    /**
     * 
     * @type {{ [key: string]: FeedCreationOption; }}
     * @memberof FeedCreationOptions
     */
    'options'?: { [key: string]: FeedCreationOption; } | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export type FeedDeliveryMethod = "MediaRss" | "Html" | "DirectUrl" | "Flash" | "Json" | "Xml";


/**
 * 
 * @export
 * @interface FeedInfo
 */
export interface FeedInfo {
    /**
     * 
     * @type {number}
     * @memberof FeedInfo
     */
    'feedId': number;
    /**
     * 
     * @type {string}
     * @memberof FeedInfo
     */
    'feedUuid': string;
    /**
     * 
     * @type {number}
     * @memberof FeedInfo
     */
    'packageId': number;
    /**
     * 
     * @type {string}
     * @memberof FeedInfo
     */
    'packageName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedInfo
     */
    'packageSlug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedInfo
     */
    'accessKey': string;
    /**
     * 
     * @type {string}
     * @memberof FeedInfo
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof FeedInfo
     */
    'actualWidth'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedInfo
     */
    'actualHeight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FeedInfo
     */
    'deliveryMethod': string;
    /**
     * 
     * @type {string}
     * @memberof FeedInfo
     */
    'url': string;
    /**
     * 
     * @type {FeedModerationMethod}
     * @memberof FeedInfo
     */
    'moderationMethod': FeedModerationMethod;
    /**
     * 
     * @type {string}
     * @memberof FeedInfo
     */
    'formatName': string;
    /**
     * 
     * @type {string}
     * @memberof FeedInfo
     */
    'theme': string;
    /**
     * 
     * @type {Array<ExternalFeed>}
     * @memberof FeedInfo
     */
    'externalFeeds'?: Array<ExternalFeed> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FeedInfo
     */
    'canModerate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FeedInfo
     */
    'productSlug'?: string | null;
}


/**
 * 
 * @export
 * @interface FeedInfoArrayGenericResponse
 */
export interface FeedInfoArrayGenericResponse {
    /**
     * 
     * @type {Array<FeedInfo>}
     * @memberof FeedInfoArrayGenericResponse
     */
    'data'?: Array<FeedInfo> | null;
    /**
     * 
     * @type {object}
     * @memberof FeedInfoArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof FeedInfoArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof FeedInfoArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @enum {string}
 */

export type FeedModerationMethod = "Approve" | "Remove" | "None";


/**
 * 
 * @export
 * @interface GenericApiResponseBase
 */
export interface GenericApiResponseBase {
    /**
     * 
     * @type {{ [key: string]: object | null; }}
     * @memberof GenericApiResponseBase
     */
    'meta'?: { [key: string]: object | null; } | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GenericApiResponseBase
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GenericApiResponseBase
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GenericResponse
 */
export interface GenericResponse {
    /**
     * 
     * @type {object}
     * @memberof GenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GenericResponse1
 */
export interface GenericResponse1 {
    /**
     * 
     * @type {object}
     * @memberof GenericResponse1
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GenericResponse1
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GenericResponse1
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetAccountContactsForStoreQuery
 */
export interface GetAccountContactsForStoreQuery {
    /**
     * 
     * @type {number}
     * @memberof GetAccountContactsForStoreQuery
     */
    'accountId'?: number;
}
/**
 * 
 * @export
 * @interface GetAccountPrimaryContactQuery
 */
export interface GetAccountPrimaryContactQuery {
    /**
     * 
     * @type {number}
     * @memberof GetAccountPrimaryContactQuery
     */
    'accountId'?: number;
}
/**
 * 
 * @export
 * @interface GetAccountRequest
 */
export interface GetAccountRequest {
    /**
     * 
     * @type {number}
     * @memberof GetAccountRequest
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetAccountResponse
 */
export interface GetAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAccountResponse
     */
    'guid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAccountResponse
     */
    'accountType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAccountResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetAccountResponse
     */
    'currencyId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountResponse
     */
    'isArchived'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountResponse
     */
    'isSuperReseller'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountResponse
     */
    'isDelinquent'?: boolean;
    /**
     * 
     * @type {BillingSettings}
     * @memberof GetAccountResponse
     */
    'billingInfo'?: BillingSettings;
    /**
     * 
     * @type {Contact}
     * @memberof GetAccountResponse
     */
    'contactInfo'?: Contact;
    /**
     * 
     * @type {BrandedMenuInfo}
     * @memberof GetAccountResponse
     */
    'brandedMenu'?: BrandedMenuInfo;
    /**
     * 
     * @type {MetaInfo}
     * @memberof GetAccountResponse
     */
    'meta'?: MetaInfo;
    /**
     * 
     * @type {Array<Customer>}
     * @memberof GetAccountResponse
     */
    'customers'?: Array<Customer> | null;
    /**
     * 
     * @type {Array<SubscriptionInfo>}
     * @memberof GetAccountResponse
     */
    'subscriptions'?: Array<SubscriptionInfo> | null;
    /**
     * 
     * @type {Array<Feed>}
     * @memberof GetAccountResponse
     */
    'feedGroups'?: Array<Feed> | null;
    /**
     * 
     * @type {Array<Bill>}
     * @memberof GetAccountResponse
     */
    'bills'?: Array<Bill> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAccountResponse
     */
    'languageFilters'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountResponse
     */
    'hasParentAccount'?: boolean;
    /**
     * 
     * @type {Array<AppAccess>}
     * @memberof GetAccountResponse
     */
    'accountAppAccess'?: Array<AppAccess> | null;
    /**
     * 
     * @type {number}
     * @memberof GetAccountResponse
     */
    'accountId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountResponse
     */
    'hasSubscriptions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountResponse
     */
    'hasPaymentMethod'?: boolean;
}
/**
 * 
 * @export
 * @interface GetAccountResponseGenericResponse
 */
export interface GetAccountResponseGenericResponse {
    /**
     * 
     * @type {GetAccountResponse}
     * @memberof GetAccountResponseGenericResponse
     */
    'data'?: GetAccountResponse;
    /**
     * 
     * @type {object}
     * @memberof GetAccountResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetAccountResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetAccountResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetAirportAutocompleteRequest
 */
export interface GetAirportAutocompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAirportAutocompleteRequest
     */
    'query': string;
}
/**
 * 
 * @export
 * @interface GetAuthModelRequest
 */
export interface GetAuthModelRequest {
    /**
     * 
     * @type {number}
     * @memberof GetAuthModelRequest
     */
    'providerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAuthModelRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetAuthModelRequest
     */
    'clientUri'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAuthModelRequest
     */
    'providerAuthUsername'?: string | null;
}
/**
 * 
 * @export
 * @interface GetAuthModelResponse
 */
export interface GetAuthModelResponse {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetAuthModelResponse
     */
    'uiDict'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {ClientAuthModelDto}
     * @memberof GetAuthModelResponse
     */
    'authModel'?: ClientAuthModelDto;
}
/**
 * 
 * @export
 * @interface GetAuthModelResponseGenericResponse
 */
export interface GetAuthModelResponseGenericResponse {
    /**
     * 
     * @type {GetAuthModelResponse}
     * @memberof GetAuthModelResponseGenericResponse
     */
    'data'?: GetAuthModelResponse;
    /**
     * 
     * @type {object}
     * @memberof GetAuthModelResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetAuthModelResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetAuthModelResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetAuthedUsersRequest
 */
export interface GetAuthedUsersRequest {
    /**
     * 
     * @type {number}
     * @memberof GetAuthedUsersRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAuthedUsersRequest
     */
    'providerId'?: number;
}
/**
 * 
 * @export
 * @interface GetAuthorizedCurrenciesRequest
 */
export interface GetAuthorizedCurrenciesRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizedCurrenciesRequest
     */
    'ipAddress'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetAuthorizedCurrenciesRequest
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetAuthorizedCurrenciesResponse
 */
export interface GetAuthorizedCurrenciesResponse {
    /**
     * 
     * @type {Array<Currency>}
     * @memberof GetAuthorizedCurrenciesResponse
     */
    'currencies'?: Array<Currency> | null;
}
/**
 * 
 * @export
 * @interface GetAuthorizedCurrenciesResponseGenericResponse
 */
export interface GetAuthorizedCurrenciesResponseGenericResponse {
    /**
     * 
     * @type {GetAuthorizedCurrenciesResponse}
     * @memberof GetAuthorizedCurrenciesResponseGenericResponse
     */
    'data'?: GetAuthorizedCurrenciesResponse;
    /**
     * 
     * @type {object}
     * @memberof GetAuthorizedCurrenciesResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetAuthorizedCurrenciesResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetAuthorizedCurrenciesResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetBillDetailRequest
 */
export interface GetBillDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof GetBillDetailRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBillDetailRequest
     */
    'billId'?: number;
}
/**
 * 
 * @export
 * @interface GetBillDetailResponse
 */
export interface GetBillDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof GetBillDetailResponse
     */
    'currencyId'?: number;
    /**
     * 
     * @type {Array<BillItem>}
     * @memberof GetBillDetailResponse
     */
    'items'?: Array<BillItem> | null;
}
/**
 * 
 * @export
 * @interface GetBillDetailResponseGenericResponse
 */
export interface GetBillDetailResponseGenericResponse {
    /**
     * 
     * @type {GetBillDetailResponse}
     * @memberof GetBillDetailResponseGenericResponse
     */
    'data'?: GetBillDetailResponse;
    /**
     * 
     * @type {object}
     * @memberof GetBillDetailResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetBillDetailResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetBillDetailResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetBillsRequest
 */
export interface GetBillsRequest {
    /**
     * 
     * @type {number}
     * @memberof GetBillsRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetBillsRequest
     */
    'from'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBillsRequest
     */
    'to'?: string | null;
}
/**
 * 
 * @export
 * @interface GetBillsResponse
 */
export interface GetBillsResponse {
    /**
     * 
     * @type {Array<Bill>}
     * @memberof GetBillsResponse
     */
    'bills'?: Array<Bill> | null;
}
/**
 * 
 * @export
 * @interface GetBillsResponseGenericResponse
 */
export interface GetBillsResponseGenericResponse {
    /**
     * 
     * @type {GetBillsResponse}
     * @memberof GetBillsResponseGenericResponse
     */
    'data'?: GetBillsResponse;
    /**
     * 
     * @type {object}
     * @memberof GetBillsResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetBillsResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetBillsResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetCalendarsCommand
 */
export interface GetCalendarsCommand {
    /**
     * 
     * @type {number}
     * @memberof GetCalendarsCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCalendarsCommand
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCalendarsCommand
     */
    'providerAuthId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCalendarsCommand
     */
    'resultsPerPage'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCalendarsCommand
     */
    'nextPageToken'?: string | null;
    /**
     * 
     * @type {CalendarAccessRole}
     * @memberof GetCalendarsCommand
     */
    'minAccessRole'?: CalendarAccessRole;
}


/**
 * 
 * @export
 * @interface GetConnectionProviderQuery
 */
export interface GetConnectionProviderQuery {
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProviderQuery
     */
    'page'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProviderQuery
     */
    'pageSize'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProviderQuery
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetConnectionProviderQuery
     */
    'langCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConnectionProviderQuery
     */
    'slug'?: string | null;
}
/**
 * 
 * @export
 * @interface GetConnectionProvidersBaseQuery
 */
export interface GetConnectionProvidersBaseQuery {
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProvidersBaseQuery
     */
    'page'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProvidersBaseQuery
     */
    'pageSize'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProvidersBaseQuery
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetConnectionProvidersBaseQuery
     */
    'langCode'?: string | null;
}
/**
 * 
 * @export
 * @interface GetConnectionProvidersBySlugQuery
 */
export interface GetConnectionProvidersBySlugQuery {
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProvidersBySlugQuery
     */
    'page'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProvidersBySlugQuery
     */
    'pageSize'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProvidersBySlugQuery
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetConnectionProvidersBySlugQuery
     */
    'langCode'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetConnectionProvidersBySlugQuery
     */
    'slugs'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface GetConnectionProvidersQuery
 */
export interface GetConnectionProvidersQuery {
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProvidersQuery
     */
    'page'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProvidersQuery
     */
    'pageSize'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConnectionProvidersQuery
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetConnectionProvidersQuery
     */
    'langCode'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetConnectionProvidersQuery
     */
    'excludeSlugs'?: Array<string> | null;
    /**
     * 
     * @type {Array<SchemaType>}
     * @memberof GetConnectionProvidersQuery
     */
    'excludeSchemaTypes'?: Array<SchemaType> | null;
    /**
     * 
     * @type {Array<SchemaType>}
     * @memberof GetConnectionProvidersQuery
     */
    'includeSchemaTypes'?: Array<SchemaType> | null;
}
/**
 * 
 * @export
 * @interface GetContentMenuQuery
 */
export interface GetContentMenuQuery {
    /**
     * 
     * @type {number}
     * @memberof GetContentMenuQuery
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetCurrenciesResponse
 */
export interface GetCurrenciesResponse {
    /**
     * 
     * @type {Array<Currency>}
     * @memberof GetCurrenciesResponse
     */
    'currencies'?: Array<Currency> | null;
}
/**
 * 
 * @export
 * @interface GetCurrencyCountryResponse
 */
export interface GetCurrencyCountryResponse {
    /**
     * 
     * @type {Array<Currency>}
     * @memberof GetCurrencyCountryResponse
     */
    'currencies'?: Array<Currency> | null;
    /**
     * 
     * @type {Array<Country>}
     * @memberof GetCurrencyCountryResponse
     */
    'countries'?: Array<Country> | null;
}
/**
 * 
 * @export
 * @interface GetCurrencyCountryResponseGenericResponse
 */
export interface GetCurrencyCountryResponseGenericResponse {
    /**
     * 
     * @type {GetCurrencyCountryResponse}
     * @memberof GetCurrencyCountryResponseGenericResponse
     */
    'data'?: GetCurrencyCountryResponse;
    /**
     * 
     * @type {object}
     * @memberof GetCurrencyCountryResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetCurrencyCountryResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetCurrencyCountryResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetCustomersRequest
 */
export interface GetCustomersRequest {
    /**
     * 
     * @type {number}
     * @memberof GetCustomersRequest
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetCustomersResponse
 */
export interface GetCustomersResponse {
    /**
     * 
     * @type {Array<Customer>}
     * @memberof GetCustomersResponse
     */
    'customers'?: Array<Customer> | null;
}
/**
 * 
 * @export
 * @interface GetCustomersResponseGenericResponse
 */
export interface GetCustomersResponseGenericResponse {
    /**
     * 
     * @type {GetCustomersResponse}
     * @memberof GetCustomersResponseGenericResponse
     */
    'data'?: GetCustomersResponse;
    /**
     * 
     * @type {object}
     * @memberof GetCustomersResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetCustomersResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetCustomersResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetExpiringTrialsQuery
 */
export interface GetExpiringTrialsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetExpiringTrialsQuery
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetFeedConfigRequest
 */
export interface GetFeedConfigRequest {
    /**
     * 
     * @type {number}
     * @memberof GetFeedConfigRequest
     */
    'feedId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigRequest
     */
    'feedUuid'?: string | null;
}
/**
 * 
 * @export
 * @interface GetFeedConfigResponse
 */
export interface GetFeedConfigResponse {
    /**
     * 
     * @type {number}
     * @memberof GetFeedConfigResponse
     */
    'feedId': number;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetFeedConfigResponse
     */
    'formatId': number;
    /**
     * 
     * @type {number}
     * @memberof GetFeedConfigResponse
     */
    'packageId': number;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'packageName': string;
    /**
     * 
     * @type {number}
     * @memberof GetFeedConfigResponse
     */
    'productId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'productSlug': string;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'previewKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'htmlUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'dataUrl': string;
    /**
     * 
     * @type {FeedDeliveryMethod}
     * @memberof GetFeedConfigResponse
     */
    'deliveryMethod'?: FeedDeliveryMethod;
    /**
     * 
     * @type {FeedModerationMethod}
     * @memberof GetFeedConfigResponse
     */
    'moderationMethod'?: FeedModerationMethod;
    /**
     * 
     * @type {{ [key: string]: string | null; }}
     * @memberof GetFeedConfigResponse
     */
    'options'?: { [key: string]: string | null; } | null;
    /**
     * 
     * @type {Array<FeedCreationChannel>}
     * @memberof GetFeedConfigResponse
     */
    'channels'?: Array<FeedCreationChannel> | null;
    /**
     * 
     * @type {Array<FeedCreationFormat>}
     * @memberof GetFeedConfigResponse
     */
    'formats'?: Array<FeedCreationFormat> | null;
    /**
     * 
     * @type {{ [key: string]: FeedCreationOptions; }}
     * @memberof GetFeedConfigResponse
     */
    'deliveryMethods'?: { [key: string]: FeedCreationOptions; } | null;
    /**
     * 
     * @type {DeliveryMethodsConfig}
     * @memberof GetFeedConfigResponse
     */
    'deliveryMethodsConfig'?: DeliveryMethodsConfig;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'feedUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'feedUuid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetFeedConfigResponse
     */
    'defaultProviderId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'mediaUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'playerAuthMode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'playerSoftware'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'playlistUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'pluginDownloadUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedConfigResponse
     */
    'triggerUrl'?: string | null;
}


/**
 * 
 * @export
 * @interface GetFeedConfigResponseGenericResponse
 */
export interface GetFeedConfigResponseGenericResponse {
    /**
     * 
     * @type {GetFeedConfigResponse}
     * @memberof GetFeedConfigResponseGenericResponse
     */
    'data'?: GetFeedConfigResponse;
    /**
     * 
     * @type {object}
     * @memberof GetFeedConfigResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetFeedConfigResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetFeedConfigResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetFeedConnectionsResponse
 */
export interface GetFeedConnectionsResponse {
    /**
     * 
     * @type {Array<Connection>}
     * @memberof GetFeedConnectionsResponse
     */
    'feedConnections'?: Array<Connection> | null;
}
/**
 * 
 * @export
 * @interface GetFeedConnectionsResponseGenericResponse
 */
export interface GetFeedConnectionsResponseGenericResponse {
    /**
     * 
     * @type {GetFeedConnectionsResponse}
     * @memberof GetFeedConnectionsResponseGenericResponse
     */
    'data'?: GetFeedConnectionsResponse;
    /**
     * 
     * @type {object}
     * @memberof GetFeedConnectionsResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetFeedConnectionsResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetFeedConnectionsResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetFeedCreationRequest
 */
export interface GetFeedCreationRequest {
    /**
     * 
     * @type {number}
     * @memberof GetFeedCreationRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFeedCreationRequest
     */
    'packageId'?: number;
}
/**
 * 
 * @export
 * @interface GetFeedCreationResponse
 */
export interface GetFeedCreationResponse {
    /**
     * 
     * @type {string}
     * @memberof GetFeedCreationResponse
     */
    'packageName': string;
    /**
     * 
     * @type {number}
     * @memberof GetFeedCreationResponse
     */
    'productId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedCreationResponse
     */
    'productSlug': string;
    /**
     * 
     * @type {string}
     * @memberof GetFeedCreationResponse
     */
    'htmlUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetFeedCreationResponse
     */
    'dataUrl': string;
    /**
     * 
     * @type {Array<FeedCreationChannel>}
     * @memberof GetFeedCreationResponse
     */
    'channels'?: Array<FeedCreationChannel> | null;
    /**
     * 
     * @type {Array<FeedCreationFormat>}
     * @memberof GetFeedCreationResponse
     */
    'formats'?: Array<FeedCreationFormat> | null;
    /**
     * 
     * @type {{ [key: string]: FeedCreationOptions; }}
     * @memberof GetFeedCreationResponse
     */
    'deliveryMethods'?: { [key: string]: FeedCreationOptions; } | null;
    /**
     * 
     * @type {DeliveryMethodsConfig}
     * @memberof GetFeedCreationResponse
     */
    'deliveryMethodsConfig'?: DeliveryMethodsConfig;
    /**
     * 
     * @type {number}
     * @memberof GetFeedCreationResponse
     */
    'defaultProviderId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFeedCreationResponse
     */
    'mediaUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetFeedCreationResponse
     */
    'packageId'?: number;
}
/**
 * 
 * @export
 * @interface GetFeedCreationResponseGenericResponse
 */
export interface GetFeedCreationResponseGenericResponse {
    /**
     * 
     * @type {GetFeedCreationResponse}
     * @memberof GetFeedCreationResponseGenericResponse
     */
    'data'?: GetFeedCreationResponse;
    /**
     * 
     * @type {object}
     * @memberof GetFeedCreationResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetFeedCreationResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetFeedCreationResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetFeedDataConnectionsByProviderQuery
 */
export interface GetFeedDataConnectionsByProviderQuery {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFeedDataConnectionsByProviderQuery
     */
    'providerSlugs'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof GetFeedDataConnectionsByProviderQuery
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetFeedDataConnectionsQuery
 */
export interface GetFeedDataConnectionsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetFeedDataConnectionsQuery
     */
    'feedId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetFeedDataConnectionsQuery
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetFeedModerationMethodRequest
 */
export interface GetFeedModerationMethodRequest {
    /**
     * 
     * @type {number}
     * @memberof GetFeedModerationMethodRequest
     */
    'feedId'?: number;
}
/**
 * 
 * @export
 * @interface GetFeedModerationMethodResponse
 */
export interface GetFeedModerationMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof GetFeedModerationMethodResponse
     */
    'feedName'?: string | null;
    /**
     * 
     * @type {FeedModerationMethod}
     * @memberof GetFeedModerationMethodResponse
     */
    'moderationMethod'?: FeedModerationMethod;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeedModerationMethodResponse
     */
    'isModerated'?: boolean;
    /**
     * 
     * @type {ModerationContentType}
     * @memberof GetFeedModerationMethodResponse
     */
    'moderationContentType'?: ModerationContentType;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeedModerationMethodResponse
     * @deprecated
     */
    'isSocial'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeedModerationMethodResponse
     * @deprecated
     */
    'isExternal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeedModerationMethodResponse
     * @deprecated
     */
    'needsSocialSearch'?: boolean;
}


/**
 * 
 * @export
 * @interface GetFeedModerationMethodResponseGenericResponse
 */
export interface GetFeedModerationMethodResponseGenericResponse {
    /**
     * 
     * @type {GetFeedModerationMethodResponse}
     * @memberof GetFeedModerationMethodResponseGenericResponse
     */
    'data'?: GetFeedModerationMethodResponse;
    /**
     * 
     * @type {object}
     * @memberof GetFeedModerationMethodResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetFeedModerationMethodResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetFeedModerationMethodResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetFeedsQuery
 */
export interface GetFeedsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetFeedsQuery
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetFeedsQuery
     */
    'packageId'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFeedsQuery
     */
    'excludeByProductSlug'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface GetLanguageFiltersRequest
 */
export interface GetLanguageFiltersRequest {
    /**
     * 
     * @type {number}
     * @memberof GetLanguageFiltersRequest
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetLanguageFiltersResponse
 */
export interface GetLanguageFiltersResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetLanguageFiltersResponse
     */
    'phrases'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface GetLanguageFiltersResponseGenericResponse
 */
export interface GetLanguageFiltersResponseGenericResponse {
    /**
     * 
     * @type {GetLanguageFiltersResponse}
     * @memberof GetLanguageFiltersResponseGenericResponse
     */
    'data'?: GetLanguageFiltersResponse;
    /**
     * 
     * @type {object}
     * @memberof GetLanguageFiltersResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetLanguageFiltersResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetLanguageFiltersResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetMicrosoftCalendarsCommand
 */
export interface GetMicrosoftCalendarsCommand {
    /**
     * 
     * @type {number}
     * @memberof GetMicrosoftCalendarsCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMicrosoftCalendarsCommand
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMicrosoftCalendarsCommand
     */
    'providerAuthId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMicrosoftCalendarsCommand
     */
    'resultsPerPage'?: number | null;
}
/**
 * 
 * @export
 * @interface GetMindBodySitesCommand
 */
export interface GetMindBodySitesCommand {
    /**
     * 
     * @type {number}
     * @memberof GetMindBodySitesCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMindBodySitesCommand
     */
    'appName'?: string | null;
}
/**
 * 
 * @export
 * @interface GetModerationContentRequest
 */
export interface GetModerationContentRequest {
    /**
     * 
     * @type {number}
     * @memberof GetModerationContentRequest
     */
    'feedId'?: number;
    /**
     * 
     * @type {ModerationSearchStatus}
     * @memberof GetModerationContentRequest
     */
    'status'?: ModerationSearchStatus;
}


/**
 * 
 * @export
 * @interface GetModerationContentResponse
 */
export interface GetModerationContentResponse {
    /**
     * 
     * @type {Array<ContentItem>}
     * @memberof GetModerationContentResponse
     */
    'items'?: Array<ContentItem> | null;
}
/**
 * 
 * @export
 * @interface GetModerationContentResponseGenericResponse
 */
export interface GetModerationContentResponseGenericResponse {
    /**
     * 
     * @type {GetModerationContentResponse}
     * @memberof GetModerationContentResponseGenericResponse
     */
    'data'?: GetModerationContentResponse;
    /**
     * 
     * @type {object}
     * @memberof GetModerationContentResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetModerationContentResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetModerationContentResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetMomentusRoomsCommand
 */
export interface GetMomentusRoomsCommand {
    /**
     * 
     * @type {number}
     * @memberof GetMomentusRoomsCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMomentusRoomsCommand
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMomentusRoomsCommand
     */
    'venueId'?: string | null;
}
/**
 * 
 * @export
 * @interface GetMomentusVenusCommand
 */
export interface GetMomentusVenusCommand {
    /**
     * 
     * @type {number}
     * @memberof GetMomentusVenusCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMomentusVenusCommand
     */
    'clientId'?: string | null;
}
/**
 * 
 * @export
 * @interface GetOffMenuAccountPackagesQuery
 */
export interface GetOffMenuAccountPackagesQuery {
    /**
     * 
     * @type {number}
     * @memberof GetOffMenuAccountPackagesQuery
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOffMenuAccountPackagesQuery
     */
    'identityAccountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetOneTimeProviderAuthsRequestDto
 */
export interface GetOneTimeProviderAuthsRequestDto {
    /**
     * 
     * @type {number}
     * @memberof GetOneTimeProviderAuthsRequestDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOneTimeProviderAuthsRequestDto
     */
    'providerName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetOneTimeProviderAuthsRequestDto
     */
    'providerAuthId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetOneTimeProviderAuthsRequestDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOneTimeProviderAuthsRequestDto
     */
    'expireAt'?: string;
}
/**
 * 
 * @export
 * @interface GetOneTimeProviderAuthsRequestDtoArrayGenericResponse
 */
export interface GetOneTimeProviderAuthsRequestDtoArrayGenericResponse {
    /**
     * 
     * @type {Array<GetOneTimeProviderAuthsRequestDto>}
     * @memberof GetOneTimeProviderAuthsRequestDtoArrayGenericResponse
     */
    'data'?: Array<GetOneTimeProviderAuthsRequestDto> | null;
    /**
     * 
     * @type {object}
     * @memberof GetOneTimeProviderAuthsRequestDtoArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetOneTimeProviderAuthsRequestDtoArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetOneTimeProviderAuthsRequestDtoArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetOneTimeProviderAuthsRequestQuery
 */
export interface GetOneTimeProviderAuthsRequestQuery {
    /**
     * 
     * @type {number}
     * @memberof GetOneTimeProviderAuthsRequestQuery
     */
    'accountId'?: number;
}
/**
 * 
 * @export
 * @interface GetPackageFeeds
 */
export interface GetPackageFeeds {
    /**
     * 
     * @type {number}
     * @memberof GetPackageFeeds
     */
    'accountId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPackageFeeds
     */
    'excludeByProductSlug'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface GetPackagesQuery
 */
export interface GetPackagesQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPackagesQuery
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPackagesQuery
     */
    'packageIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface GetPowerBIDashboardsRequest
 */
export interface GetPowerBIDashboardsRequest {
    /**
     * 
     * @type {number}
     * @memberof GetPowerBIDashboardsRequest
     */
    'providerAuthorizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPowerBIDashboardsRequest
     */
    'workspaceId'?: string | null;
}
/**
 * 
 * @export
 * @interface GetPowerBIReportsRequest
 */
export interface GetPowerBIReportsRequest {
    /**
     * 
     * @type {number}
     * @memberof GetPowerBIReportsRequest
     */
    'providerAuthorizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPowerBIReportsRequest
     */
    'workspaceId'?: string | null;
}
/**
 * 
 * @export
 * @interface GetPowerBITilesRequest
 */
export interface GetPowerBITilesRequest {
    /**
     * 
     * @type {number}
     * @memberof GetPowerBITilesRequest
     */
    'providerAuthorizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPowerBITilesRequest
     */
    'workspaceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPowerBITilesRequest
     */
    'dashboardId'?: string | null;
}
/**
 * 
 * @export
 * @interface GetPowerBIWorkspacesRequest
 */
export interface GetPowerBIWorkspacesRequest {
    /**
     * 
     * @type {number}
     * @memberof GetPowerBIWorkspacesRequest
     */
    'providerAuthorizationId'?: number;
}
/**
 * 
 * @export
 * @interface GetProratedTotalQuery
 */
export interface GetProratedTotalQuery {
    /**
     * 
     * @type {number}
     * @memberof GetProratedTotalQuery
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {Array<PricingQuery>}
     * @memberof GetProratedTotalQuery
     */
    'changes'?: Array<PricingQuery> | null;
}
/**
 * 
 * @export
 * @interface GetProratedTotalResponse
 */
export interface GetProratedTotalResponse {
    /**
     * 
     * @type {number}
     * @memberof GetProratedTotalResponse
     */
    'cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetProratedTotalResponse
     */
    'displayCost'?: string | null;
}
/**
 * 
 * @export
 * @interface GetProratedTotalResponseGenericResponse
 */
export interface GetProratedTotalResponseGenericResponse {
    /**
     * 
     * @type {GetProratedTotalResponse}
     * @memberof GetProratedTotalResponseGenericResponse
     */
    'data'?: GetProratedTotalResponse;
    /**
     * 
     * @type {object}
     * @memberof GetProratedTotalResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetProratedTotalResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetProratedTotalResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetProviderAuthSidedoorCommand
 */
export interface GetProviderAuthSidedoorCommand {
    /**
     * 
     * @type {string}
     * @memberof GetProviderAuthSidedoorCommand
     */
    'oneTimeAccessToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProviderAuthSidedoorCommand
     */
    'clientUri'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProviderAuthSidedoorCommand
     */
    'oAuthExchangeRedirectPath'?: string | null;
}
/**
 * 
 * @export
 * @interface GetProviderAuthSidedoorResponse
 */
export interface GetProviderAuthSidedoorResponse {
    /**
     * 
     * @type {ClientAuthModelDto}
     * @memberof GetProviderAuthSidedoorResponse
     */
    'authModel'?: ClientAuthModelDto;
    /**
     * 
     * @type {string}
     * @memberof GetProviderAuthSidedoorResponse
     */
    'providerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProviderAuthSidedoorResponse
     */
    'providerIconUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProviderAuthSidedoorResponse
     */
    'authUsername'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProviderAuthSidedoorResponse
     */
    'parentAccountName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProviderAuthSidedoorResponse
     */
    'expiresInUtc'?: string | null;
}
/**
 * 
 * @export
 * @interface GetProviderAuthSidedoorResponseGenericResponse
 */
export interface GetProviderAuthSidedoorResponseGenericResponse {
    /**
     * 
     * @type {GetProviderAuthSidedoorResponse}
     * @memberof GetProviderAuthSidedoorResponseGenericResponse
     */
    'data'?: GetProviderAuthSidedoorResponse;
    /**
     * 
     * @type {object}
     * @memberof GetProviderAuthSidedoorResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetProviderAuthSidedoorResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetProviderAuthSidedoorResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetProviderAuthsQuery
 */
export interface GetProviderAuthsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetProviderAuthsQuery
     */
    'accountId'?: number;
}
/**
 * 
 * @export
 * @interface GetProviderDto
 */
export interface GetProviderDto {
    /**
     * 
     * @type {number}
     * @memberof GetProviderDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProviderDto
     */
    'providerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProviderDto
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetProviderDto
     */
    'productName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProviderDto
     */
    'providerProductName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProviderDto
     */
    'iconUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProviderDto
     */
    'authProviderName'?: string | null;
}
/**
 * 
 * @export
 * @interface GetProviderDtoArrayGenericResponse
 */
export interface GetProviderDtoArrayGenericResponse {
    /**
     * 
     * @type {Array<GetProviderDto>}
     * @memberof GetProviderDtoArrayGenericResponse
     */
    'data'?: Array<GetProviderDto> | null;
    /**
     * 
     * @type {object}
     * @memberof GetProviderDtoArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetProviderDtoArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetProviderDtoArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetProvidersQuery
 */
export interface GetProvidersQuery {
    /**
     * 
     * @type {number}
     * @memberof GetProvidersQuery
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetProvidersQuery
     */
    'includeInactive'?: boolean;
}
/**
 * 
 * @export
 * @interface GetSamsungVxtFeedRequest
 */
export interface GetSamsungVxtFeedRequest {
    /**
     * 
     * @type {string}
     * @memberof GetSamsungVxtFeedRequest
     */
    'feedUuid'?: string | null;
}
/**
 * 
 * @export
 * @interface GetSamsungVxtFeedResponse
 */
export interface GetSamsungVxtFeedResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSamsungVxtFeedResponse
     */
    'accountId'?: number;
    /**
     * 
     * @type {SamsungVxtFeed}
     * @memberof GetSamsungVxtFeedResponse
     */
    'feed'?: SamsungVxtFeed;
}
/**
 * 
 * @export
 * @interface GetSamsungVxtFeedResponseGenericResponse
 */
export interface GetSamsungVxtFeedResponseGenericResponse {
    /**
     * 
     * @type {GetSamsungVxtFeedResponse}
     * @memberof GetSamsungVxtFeedResponseGenericResponse
     */
    'data'?: GetSamsungVxtFeedResponse;
    /**
     * 
     * @type {object}
     * @memberof GetSamsungVxtFeedResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetSamsungVxtFeedResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetSamsungVxtFeedResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetSocialSearchAuthorizationsQuery
 */
export interface GetSocialSearchAuthorizationsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetSocialSearchAuthorizationsQuery
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSocialSearchAuthorizationsQuery
     */
    'externalCustomerId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetSocialSearchAuthorizationsQuery
     */
    'providers'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetSocialSearchAuthorizationsQuery
     */
    'searches'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface GetSportsLeaguesResponse
 */
export interface GetSportsLeaguesResponse {
    /**
     * 
     * @type {Array<League>}
     * @memberof GetSportsLeaguesResponse
     */
    'leagues': Array<League>;
}
/**
 * 
 * @export
 * @interface GetSportsLeaguesResponseGenericResponse
 */
export interface GetSportsLeaguesResponseGenericResponse {
    /**
     * 
     * @type {GetSportsLeaguesResponse}
     * @memberof GetSportsLeaguesResponseGenericResponse
     */
    'data'?: GetSportsLeaguesResponse;
    /**
     * 
     * @type {object}
     * @memberof GetSportsLeaguesResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetSportsLeaguesResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetSportsLeaguesResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetSportsTeamsRequest
 */
export interface GetSportsTeamsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSportsTeamsRequest
     */
    'leagues'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetSportsTeamsRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSportsTeamsRequest
     */
    'query'?: string | null;
}
/**
 * 
 * @export
 * @interface GetSportsTeamsResponse
 */
export interface GetSportsTeamsResponse {
    /**
     * 
     * @type {Array<Team>}
     * @memberof GetSportsTeamsResponse
     */
    'teams': Array<Team>;
}
/**
 * 
 * @export
 * @interface GetSportsTeamsResponseGenericResponse
 */
export interface GetSportsTeamsResponseGenericResponse {
    /**
     * 
     * @type {GetSportsTeamsResponse}
     * @memberof GetSportsTeamsResponseGenericResponse
     */
    'data'?: GetSportsTeamsResponse;
    /**
     * 
     * @type {object}
     * @memberof GetSportsTeamsResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetSportsTeamsResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetSportsTeamsResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetStockSymbolsRequest
 */
export interface GetStockSymbolsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetStockSymbolsRequest
     */
    'query': string;
    /**
     * 
     * @type {string}
     * @memberof GetStockSymbolsRequest
     */
    'exchange'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetStockSymbolsRequest
     */
    'limit'?: number | null;
}
/**
 * 
 * @export
 * @interface GetSubscribedPackagesQuery
 */
export interface GetSubscribedPackagesQuery {
    /**
     * 
     * @type {number}
     * @memberof GetSubscribedPackagesQuery
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetSubscribedPackagesResponse
 */
export interface GetSubscribedPackagesResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetSubscribedPackagesResponse
     */
    'packageIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface GetSubscribedPackagesResponseGenericResponse
 */
export interface GetSubscribedPackagesResponseGenericResponse {
    /**
     * 
     * @type {GetSubscribedPackagesResponse}
     * @memberof GetSubscribedPackagesResponseGenericResponse
     */
    'data'?: GetSubscribedPackagesResponse;
    /**
     * 
     * @type {object}
     * @memberof GetSubscribedPackagesResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetSubscribedPackagesResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetSubscribedPackagesResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetSubscriptionPricingQuery
 */
export interface GetSubscriptionPricingQuery {
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionPricingQuery
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSubscriptionPricingQuery
     */
    'includeAll'?: boolean;
    /**
     * 
     * @type {Array<PricingQuery>}
     * @memberof GetSubscriptionPricingQuery
     */
    'pricingRequests'?: Array<PricingQuery> | null;
}
/**
 * 
 * @export
 * @interface GetSubscriptionPricingResponse
 */
export interface GetSubscriptionPricingResponse {
    /**
     * 
     * @type {Array<Pricing>}
     * @memberof GetSubscriptionPricingResponse
     */
    'pricingResults'?: Array<Pricing> | null;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionPricingResponse
     */
    'persistedTotal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionPricingResponse
     */
    'displayPersistedTotal'?: string | null;
}
/**
 * 
 * @export
 * @interface GetSubscriptionPricingResponseGenericResponse
 */
export interface GetSubscriptionPricingResponseGenericResponse {
    /**
     * 
     * @type {GetSubscriptionPricingResponse}
     * @memberof GetSubscriptionPricingResponseGenericResponse
     */
    'data'?: GetSubscriptionPricingResponse;
    /**
     * 
     * @type {object}
     * @memberof GetSubscriptionPricingResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetSubscriptionPricingResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetSubscriptionPricingResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetSubscriptionsQuery
 */
export interface GetSubscriptionsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionsQuery
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetSubscriptionsResponse
 */
export interface GetSubscriptionsResponse {
    /**
     * 
     * @type {Array<SubscriptionDto>}
     * @memberof GetSubscriptionsResponse
     */
    'subscriptions'?: Array<SubscriptionDto> | null;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionsResponse
     */
    'currencyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionsResponse
     */
    'nextBillingDate'?: string | null;
}
/**
 * 
 * @export
 * @interface GetSubscriptionsResponseGenericResponse
 */
export interface GetSubscriptionsResponseGenericResponse {
    /**
     * 
     * @type {GetSubscriptionsResponse}
     * @memberof GetSubscriptionsResponseGenericResponse
     */
    'data'?: GetSubscriptionsResponse;
    /**
     * 
     * @type {object}
     * @memberof GetSubscriptionsResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetSubscriptionsResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetSubscriptionsResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetTrafficRegionsResponse
 */
export interface GetTrafficRegionsResponse {
    /**
     * 
     * @type {Array<TrafficRegionDto>}
     * @memberof GetTrafficRegionsResponse
     */
    'regions': Array<TrafficRegionDto>;
}
/**
 * 
 * @export
 * @interface GetTrafficRegionsResponseGenericResponse
 */
export interface GetTrafficRegionsResponseGenericResponse {
    /**
     * 
     * @type {GetTrafficRegionsResponse}
     * @memberof GetTrafficRegionsResponseGenericResponse
     */
    'data'?: GetTrafficRegionsResponse;
    /**
     * 
     * @type {object}
     * @memberof GetTrafficRegionsResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetTrafficRegionsResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetTrafficRegionsResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetTrafficRoutesQuery
 */
export interface GetTrafficRoutesQuery {
    /**
     * 
     * @type {number}
     * @memberof GetTrafficRoutesQuery
     */
    'accountId'?: number;
}
/**
 * 
 * @export
 * @interface GetTrafficRoutesResponse
 */
export interface GetTrafficRoutesResponse {
    /**
     * 
     * @type {Array<TrafficRouteDto>}
     * @memberof GetTrafficRoutesResponse
     */
    'ownedRoutes': Array<TrafficRouteDto>;
    /**
     * 
     * @type {Array<SharedTrafficSetDto>}
     * @memberof GetTrafficRoutesResponse
     */
    'sharedSets': Array<SharedTrafficSetDto>;
}
/**
 * 
 * @export
 * @interface GetTrafficRoutesResponseGenericResponse
 */
export interface GetTrafficRoutesResponseGenericResponse {
    /**
     * 
     * @type {GetTrafficRoutesResponse}
     * @memberof GetTrafficRoutesResponseGenericResponse
     */
    'data'?: GetTrafficRoutesResponse;
    /**
     * 
     * @type {object}
     * @memberof GetTrafficRoutesResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetTrafficRoutesResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetTrafficRoutesResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetTrafficSetsQuery
 */
export interface GetTrafficSetsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetTrafficSetsQuery
     */
    'regionId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetTrafficSetsResponse
 */
export interface GetTrafficSetsResponse {
    /**
     * 
     * @type {Array<TrafficSetDto>}
     * @memberof GetTrafficSetsResponse
     */
    'sets': Array<TrafficSetDto>;
}
/**
 * 
 * @export
 * @interface GetTrafficSetsResponseGenericResponse
 */
export interface GetTrafficSetsResponseGenericResponse {
    /**
     * 
     * @type {GetTrafficSetsResponse}
     * @memberof GetTrafficSetsResponseGenericResponse
     */
    'data'?: GetTrafficSetsResponse;
    /**
     * 
     * @type {object}
     * @memberof GetTrafficSetsResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof GetTrafficSetsResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof GetTrafficSetsResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface GetTrialHistoryQuery
 */
export interface GetTrialHistoryQuery {
    /**
     * 
     * @type {number}
     * @memberof GetTrialHistoryQuery
     */
    'accountId'?: number | null;
}
/**
 * 
 * @export
 * @interface GetValidLocationQuery
 */
export interface GetValidLocationQuery {
    /**
     * 
     * @type {number}
     * @memberof GetValidLocationQuery
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetValidLocationQuery
     */
    'location': string;
    /**
     * 
     * @type {number}
     * @memberof GetValidLocationQuery
     */
    'packageId': number;
}
/**
 * 
 * @export
 * @interface HideModerationContentRequest
 */
export interface HideModerationContentRequest {
    /**
     * 
     * @type {number}
     * @memberof HideModerationContentRequest
     */
    'feedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HideModerationContentRequest
     */
    'contentId'?: string | null;
}
/**
 * 
 * @export
 * @interface IanaTimezoneDto
 */
export interface IanaTimezoneDto {
    /**
     * 
     * @type {Array<StringStringKeyValuePair>}
     * @memberof IanaTimezoneDto
     */
    'timeZoneDisplayNameToIanaTimeZone'?: Array<StringStringKeyValuePair> | null;
}
/**
 * 
 * @export
 * @interface IanaTimezoneDtoGenericResponse
 */
export interface IanaTimezoneDtoGenericResponse {
    /**
     * 
     * @type {IanaTimezoneDto}
     * @memberof IanaTimezoneDtoGenericResponse
     */
    'data'?: IanaTimezoneDto;
    /**
     * 
     * @type {object}
     * @memberof IanaTimezoneDtoGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof IanaTimezoneDtoGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof IanaTimezoneDtoGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ImpersonatedDto
 */
export interface ImpersonatedDto {
    /**
     * 
     * @type {{ [key: string]: string | null; }}
     * @memberof ImpersonatedDto
     */
    'profile'?: { [key: string]: string | null; } | null;
}
/**
 * 
 * @export
 * @interface ImpersonatedDtoGenericResponse
 */
export interface ImpersonatedDtoGenericResponse {
    /**
     * 
     * @type {ImpersonatedDto}
     * @memberof ImpersonatedDtoGenericResponse
     */
    'data'?: ImpersonatedDto;
    /**
     * 
     * @type {object}
     * @memberof ImpersonatedDtoGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ImpersonatedDtoGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ImpersonatedDtoGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface InvoiceSettings
 */
export interface InvoiceSettings {
    /**
     * 
     * @type {string}
     * @memberof InvoiceSettings
     */
    'invoicePONumber'?: string | null;
    /**
     * 
     * @type {Address}
     * @memberof InvoiceSettings
     */
    'billingAddress'?: Address;
}
/**
 * 
 * @export
 * @interface League
 */
export interface League {
    /**
     * 
     * @type {string}
     * @memberof League
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof League
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof League
     */
    'logoUrl': string;
    /**
     * 
     * @type {string}
     * @memberof League
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof League
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof League
     */
    'start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof League
     */
    'end'?: string | null;
}
/**
 * 
 * @export
 * @interface MetaInfo
 */
export interface MetaInfo {
    /**
     * 
     * @type {number}
     * @memberof MetaInfo
     */
    'viewers'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MetaInfo
     */
    'venue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetaInfo
     */
    'dwellTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetaInfo
     */
    'software'?: string | null;
}
/**
 * 
 * @export
 * @interface MindBodyLocation
 */
export interface MindBodyLocation {
    /**
     * 
     * @type {number}
     * @memberof MindBodyLocation
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MindBodyLocation
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MindBodyLocation
     */
    'ianaTimeZone'?: string | null;
    /**
     * 
     * @type {Array<MindBodyResource>}
     * @memberof MindBodyLocation
     */
    'resources'?: Array<MindBodyResource> | null;
}
/**
 * 
 * @export
 * @interface MindBodyResource
 */
export interface MindBodyResource {
    /**
     * 
     * @type {number}
     * @memberof MindBodyResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MindBodyResource
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MindBodyResource
     */
    'siteId'?: number;
    /**
     * 
     * @type {number}
     * @memberof MindBodyResource
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MindBodyResource
     */
    'uniqueId'?: string | null;
}
/**
 * 
 * @export
 * @interface MindBodySite
 */
export interface MindBodySite {
    /**
     * 
     * @type {number}
     * @memberof MindBodySite
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MindBodySite
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<MindBodyLocation>}
     * @memberof MindBodySite
     */
    'locations'?: Array<MindBodyLocation> | null;
}
/**
 * 
 * @export
 * @interface MindBodySiteArrayGenericResponse
 */
export interface MindBodySiteArrayGenericResponse {
    /**
     * 
     * @type {Array<MindBodySite>}
     * @memberof MindBodySiteArrayGenericResponse
     */
    'data'?: Array<MindBodySite> | null;
    /**
     * 
     * @type {object}
     * @memberof MindBodySiteArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof MindBodySiteArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof MindBodySiteArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ModerateContentRequest
 */
export interface ModerateContentRequest {
    /**
     * 
     * @type {number}
     * @memberof ModerateContentRequest
     */
    'feedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModerateContentRequest
     */
    'contentId'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export type ModerationContentType = "Default" | "Community" | "TikTok";


/**
 * 
 * @export
 * @enum {string}
 */

export type ModerationSearchStatus = "All" | "Moderated" | "Undecided";


/**
 * 
 * @export
 * @interface NameStep
 */
export interface NameStep {
    /**
     * 
     * @type {number}
     * @memberof NameStep
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof NameStep
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NameStep
     */
    'clientComponentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NameStep
     */
    'displayNameI18nKey'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NameStep
     */
    'shouldPersistConnection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NameStep
     */
    'shouldShowInNavigation'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof NameStep
     */
    'model'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface NewsItem
 */
export interface NewsItem {
    /**
     * 
     * @type {string}
     * @memberof NewsItem
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsItem
     */
    'summary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsItem
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsItem
     */
    'imageUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationPayload
 */
export interface NotificationPayload {
    /**
     * 
     * @type {string}
     * @memberof NotificationPayload
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationPayload
     */
    'scope'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationPayload
     */
    'level'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationPayload
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationPayload
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationPayload
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationPayload
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationPayload
     */
    'link'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationPayload
     */
    'entityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationPayload
     */
    'entityId'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationPayloadGenericResponse
 */
export interface NotificationPayloadGenericResponse {
    /**
     * 
     * @type {NotificationPayload}
     * @memberof NotificationPayloadGenericResponse
     */
    'data'?: NotificationPayload;
    /**
     * 
     * @type {object}
     * @memberof NotificationPayloadGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof NotificationPayloadGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof NotificationPayloadGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface PackageFeed
 */
export interface PackageFeed {
    /**
     * 
     * @type {number}
     * @memberof PackageFeed
     */
    'packageId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PackageFeed
     */
    'packageName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PackageFeed
     */
    'productSlug'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PackageFeed
     */
    'isModerated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PackageFeed
     */
    'canAddFeeds'?: boolean;
    /**
     * 
     * @type {Array<FeedInfo>}
     * @memberof PackageFeed
     */
    'feeds'?: Array<FeedInfo> | null;
}
/**
 * 
 * @export
 * @interface PackageFeedArrayGenericResponse
 */
export interface PackageFeedArrayGenericResponse {
    /**
     * 
     * @type {Array<PackageFeed>}
     * @memberof PackageFeedArrayGenericResponse
     */
    'data'?: Array<PackageFeed> | null;
    /**
     * 
     * @type {object}
     * @memberof PackageFeedArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof PackageFeedArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof PackageFeedArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface PackageInfo
 */
export interface PackageInfo {
    /**
     * 
     * @type {number}
     * @memberof PackageInfo
     */
    'packageId': number;
    /**
     * 
     * @type {string}
     * @memberof PackageInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PackageInfo
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof PackageInfo
     */
    'thumbnail'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PackageInfo
     */
    'categories': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PackageInfo
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof PackageInfo
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<SpecIconWidget>}
     * @memberof PackageInfo
     */
    'widgets'?: Array<SpecIconWidget> | null;
    /**
     * 
     * @type {string}
     * @memberof PackageInfo
     */
    'sampleImageUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PackageInfo
     */
    'backgroundImageUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PackageInfo
     */
    'configDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PackageInfo
     */
    'productSlug'?: string | null;
    /**
     * 
     * @type {Array<FeedDeliveryMethod>}
     * @memberof PackageInfo
     */
    'deliveryMethods'?: Array<FeedDeliveryMethod> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PackageInfo
     */
    'isBundle'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PackageInfo
     */
    'bundlePackageIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof PackageInfo
     */
    'metaDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PackageInfo
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface PackageInfoArrayGenericResponse
 */
export interface PackageInfoArrayGenericResponse {
    /**
     * 
     * @type {Array<PackageInfo>}
     * @memberof PackageInfoArrayGenericResponse
     */
    'data'?: Array<PackageInfo> | null;
    /**
     * 
     * @type {object}
     * @memberof PackageInfoArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof PackageInfoArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof PackageInfoArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface Payment
 */
export interface Payment {
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    'paymentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'datePaid'?: string;
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'tender'?: string | null;
}
/**
 * 
 * @export
 * @interface PreviewBillRequest
 */
export interface PreviewBillRequest {
    /**
     * 
     * @type {number}
     * @memberof PreviewBillRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PreviewBillRequest
     */
    'billId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PreviewBillRequest
     */
    'pdf'?: boolean;
}
/**
 * 
 * @export
 * @interface PreviewBillResponse
 */
export interface PreviewBillResponse {
    /**
     * 
     * @type {string}
     * @memberof PreviewBillResponse
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreviewBillResponse
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreviewBillResponse
     */
    'isPdf'?: boolean;
}
/**
 * 
 * @export
 * @interface PreviewBillResponseGenericResponse
 */
export interface PreviewBillResponseGenericResponse {
    /**
     * 
     * @type {PreviewBillResponse}
     * @memberof PreviewBillResponseGenericResponse
     */
    'data'?: PreviewBillResponse;
    /**
     * 
     * @type {object}
     * @memberof PreviewBillResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof PreviewBillResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof PreviewBillResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface Pricing
 */
export interface Pricing {
    /**
     * 
     * @type {string}
     * @memberof Pricing
     */
    'subscriptionUuid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Pricing
     */
    'packageId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Pricing
     */
    'frontendRefId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Pricing
     */
    'totalPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Pricing
     */
    'displayTotalPrice'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Pricing
     */
    'unitPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Pricing
     */
    'displayUnitPrice'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Pricing
     */
    'monthlyPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Pricing
     */
    'displayMonthlyPrice'?: string | null;
}
/**
 * 
 * @export
 * @interface PricingQuery
 */
export interface PricingQuery {
    /**
     * 
     * @type {string}
     * @memberof PricingQuery
     */
    'subscriptionUuid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PricingQuery
     */
    'packageId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PricingQuery
     */
    'licenseQty'?: number;
    /**
     * 
     * @type {number}
     * @memberof PricingQuery
     */
    'monthsQty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PricingQuery
     */
    'frontendRefId'?: number | null;
}
/**
 * 
 * @export
 * @interface ProvideStep
 */
export interface ProvideStep {
    /**
     * 
     * @type {number}
     * @memberof ProvideStep
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProvideStep
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProvideStep
     */
    'clientComponentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProvideStep
     */
    'displayNameI18nKey'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProvideStep
     */
    'shouldPersistConnection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProvideStep
     */
    'shouldShowInNavigation'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProvideStep
     */
    'model'?: Array<string> | null;
    /**
     * 
     * @type {Authentication}
     * @memberof ProvideStep
     */
    'authenticator'?: Authentication;
    /**
     * 
     * @type {Array<object>}
     * @memberof ProvideStep
     */
    'inputs'?: Array<object> | null;
    /**
     * 
     * @type {string}
     * @memberof ProvideStep
     */
    'endpoint'?: string | null;
}
/**
 * 
 * @export
 * @interface Provider
 */
export interface Provider {
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'providerSlug'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Provider
     */
    'providerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'iconUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface ProviderAuthDto
 */
export interface ProviderAuthDto {
    /**
     * 
     * @type {number}
     * @memberof ProviderAuthDto
     */
    'providerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProviderAuthDto
     */
    'providerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderAuthDto
     */
    'providerIcon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProviderAuthDto
     */
    'providerAuthId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProviderAuthDto
     */
    'lastAuthorized'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderAuthDto
     */
    'expires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderAuthDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderAuthDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProviderAuthDto
     */
    'products'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ProviderAuthDtoArrayGenericResponse
 */
export interface ProviderAuthDtoArrayGenericResponse {
    /**
     * 
     * @type {Array<ProviderAuthDto>}
     * @memberof ProviderAuthDtoArrayGenericResponse
     */
    'data'?: Array<ProviderAuthDto> | null;
    /**
     * 
     * @type {object}
     * @memberof ProviderAuthDtoArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ProviderAuthDtoArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ProviderAuthDtoArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface PurchaseSubscriptionsCommand
 */
export interface PurchaseSubscriptionsCommand {
    /**
     * 
     * @type {number}
     * @memberof PurchaseSubscriptionsCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSubscriptionsCommand
     */
    'date'?: string | null;
    /**
     * 
     * @type {Array<SubscriptionPurchaseRequest>}
     * @memberof PurchaseSubscriptionsCommand
     */
    'changes'?: Array<SubscriptionPurchaseRequest> | null;
}
/**
 * 
 * @export
 * @interface ReactivateSubscriptionCommand
 */
export interface ReactivateSubscriptionCommand {
    /**
     * 
     * @type {number}
     * @memberof ReactivateSubscriptionCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReactivateSubscriptionCommand
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReactivateSubscriptionCommand
     */
    'subscriptionUuid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReactivateSubscriptionCommand
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReactivateSubscriptionCommand
     */
    'date'?: string | null;
}
/**
 * 
 * @export
 * @interface RemoveAccountBillingEmailRequest
 */
export interface RemoveAccountBillingEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof RemoveAccountBillingEmailRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RemoveAccountBillingEmailRequest
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface RemoveFeedRequest
 */
export interface RemoveFeedRequest {
    /**
     * 
     * @type {number}
     * @memberof RemoveFeedRequest
     */
    'feedId'?: number;
}
/**
 * 
 * @export
 * @interface RenameTrafficRegionCommand
 */
export interface RenameTrafficRegionCommand {
    /**
     * 
     * @type {number}
     * @memberof RenameTrafficRegionCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RenameTrafficRegionCommand
     */
    'regionId': number;
    /**
     * 
     * @type {string}
     * @memberof RenameTrafficRegionCommand
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface RequiredFeedCreationOption
 */
export interface RequiredFeedCreationOption {
    /**
     * 
     * @type {object}
     * @memberof RequiredFeedCreationOption
     */
    'defaultValue'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof RequiredFeedCreationOption
     */
    'required'?: boolean | null;
    /**
     * 
     * @type {Array<SelectListItem>}
     * @memberof RequiredFeedCreationOption
     */
    'selectList'?: Array<SelectListItem> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof RequiredFeedCreationOption
     */
    'onlyForChannelIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface Room
 */
export interface Room {
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'venueId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'group'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Room
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface RoomArrayGenericResponse
 */
export interface RoomArrayGenericResponse {
    /**
     * 
     * @type {Array<Room>}
     * @memberof RoomArrayGenericResponse
     */
    'data'?: Array<Room> | null;
    /**
     * 
     * @type {object}
     * @memberof RoomArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof RoomArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof RoomArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface SamsungVxtFeed
 */
export interface SamsungVxtFeed {
    /**
     * 
     * @type {number}
     * @memberof SamsungVxtFeed
     */
    'feedId'?: number;
    /**
     * 
     * @type {Array<DataConnection>}
     * @memberof SamsungVxtFeed
     */
    'connections'?: Array<DataConnection> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export type SchemaType = "Undefined" | "Tabular" | "Tree" | "Calendar";


/**
 * 
 * @export
 * @enum {string}
 */

export type ScreenfeedApp = "Unknown" | "Kitchen" | "RoboChef" | "BackEnd" | "OpenId" | "Ops" | "Store" | "ContentCloud" | "Oven" | "Microwave" | "Util" | "HealthInspector" | "Test" | "SwfGenerator" | "Companion" | "LoadTester" | "Connect" | "Acct" | "Integrators" | "Img" | "Yarp" | "ContentMenu" | "AcctLegacy";


/**
 * 
 * @export
 * @interface SelectListItem
 */
export interface SelectListItem {
    /**
     * 
     * @type {string}
     * @memberof SelectListItem
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SelectListItem
     */
    'value'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SelectListItem
     */
    'channelIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SelectListItem
     */
    'customizable'?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: object | null; }}
     * @memberof SelectListItem
     */
    'defaultValues'?: { [key: string]: object | null; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof SelectListItem
     */
    'deprecated'?: boolean | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SelectListItem
     */
    'allowedFormatIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface SendCreateAccountSecurityStampCommand
 */
export interface SendCreateAccountSecurityStampCommand {
    /**
     * 
     * @type {string}
     * @memberof SendCreateAccountSecurityStampCommand
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendCreateAccountSecurityStampCommand
     */
    'accountGuid'?: string | null;
}
/**
 * 
 * @export
 * @interface SendResetPasswordByEmailCommand
 */
export interface SendResetPasswordByEmailCommand {
    /**
     * 
     * @type {string}
     * @memberof SendResetPasswordByEmailCommand
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendResetPasswordByEmailCommand
     */
    'returnUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface SendVerifyCodeCommand
 */
export interface SendVerifyCodeCommand {
    /**
     * 
     * @type {number}
     * @memberof SendVerifyCodeCommand
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface SendVerifyCodeCommandGenericResponse
 */
export interface SendVerifyCodeCommandGenericResponse {
    /**
     * 
     * @type {SendVerifyCodeCommand}
     * @memberof SendVerifyCodeCommandGenericResponse
     */
    'data'?: SendVerifyCodeCommand;
    /**
     * 
     * @type {object}
     * @memberof SendVerifyCodeCommandGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof SendVerifyCodeCommandGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof SendVerifyCodeCommandGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface SetReferrerRequest
 */
export interface SetReferrerRequest {
    /**
     * 
     * @type {string}
     * @memberof SetReferrerRequest
     */
    'referrer'?: string | null;
}
/**
 * 
 * @export
 * @interface SetupStep
 */
export interface SetupStep {
    /**
     * 
     * @type {number}
     * @memberof SetupStep
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof SetupStep
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetupStep
     */
    'clientComponentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetupStep
     */
    'displayNameI18nKey'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetupStep
     */
    'shouldPersistConnection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SetupStep
     */
    'shouldShowInNavigation'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetupStep
     */
    'model'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface SharedTrafficRouteDto
 */
export interface SharedTrafficRouteDto {
    /**
     * 
     * @type {number}
     * @memberof SharedTrafficRouteDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SharedTrafficRouteDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SharedTrafficRouteDto
     */
    'roadIcon'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SharedTrafficRouteDto
     */
    'isLegacy'?: boolean;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof SharedTrafficRouteDto
     */
    'start'?: TrafficPointDto;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof SharedTrafficRouteDto
     */
    'end'?: TrafficPointDto;
    /**
     * 
     * @type {string}
     * @memberof SharedTrafficRouteDto
     */
    'startAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedTrafficRouteDto
     */
    'endAddress'?: string | null;
}
/**
 * 
 * @export
 * @interface SharedTrafficSetDto
 */
export interface SharedTrafficSetDto {
    /**
     * 
     * @type {number}
     * @memberof SharedTrafficSetDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SharedTrafficSetDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SharedTrafficSetDto
     */
    'code': string;
    /**
     * 
     * @type {Array<SharedTrafficRouteDto>}
     * @memberof SharedTrafficSetDto
     */
    'routes': Array<SharedTrafficRouteDto>;
}
/**
 * 
 * @export
 * @interface SocialAuthorization
 */
export interface SocialAuthorization {
    /**
     * 
     * @type {number}
     * @memberof SocialAuthorization
     */
    'authId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SocialAuthorization
     */
    'searchId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SocialAuthorization
     */
    'query'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SocialAuthorization
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SocialAuthorization
     */
    'providerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SocialAuthorization
     */
    'providerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SocialAuthorization
     */
    'providerUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface SocialAuthorizationGenericResponse
 */
export interface SocialAuthorizationGenericResponse {
    /**
     * 
     * @type {SocialAuthorization}
     * @memberof SocialAuthorizationGenericResponse
     */
    'data'?: SocialAuthorization;
    /**
     * 
     * @type {object}
     * @memberof SocialAuthorizationGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof SocialAuthorizationGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof SocialAuthorizationGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface SocialAuthorizationListGenericResponse
 */
export interface SocialAuthorizationListGenericResponse {
    /**
     * 
     * @type {Array<SocialAuthorization>}
     * @memberof SocialAuthorizationListGenericResponse
     */
    'data'?: Array<SocialAuthorization> | null;
    /**
     * 
     * @type {object}
     * @memberof SocialAuthorizationListGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof SocialAuthorizationListGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof SocialAuthorizationListGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface SpecIconWidget
 */
export interface SpecIconWidget {
    /**
     * 
     * @type {string}
     * @memberof SpecIconWidget
     */
    'spec'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpecIconWidget
     */
    'caption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpecIconWidget
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpecIconWidget
     */
    'content'?: string | null;
}
/**
 * 
 * @export
 * @interface StockSymbol
 */
export interface StockSymbol {
    /**
     * 
     * @type {string}
     * @memberof StockSymbol
     */
    'symbol': string;
    /**
     * 
     * @type {string}
     * @memberof StockSymbol
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StockSymbol
     */
    'exchangeSymbol': string;
}
/**
 * 
 * @export
 * @interface StockSymbolArrayGenericResponse
 */
export interface StockSymbolArrayGenericResponse {
    /**
     * 
     * @type {Array<StockSymbol>}
     * @memberof StockSymbolArrayGenericResponse
     */
    'data'?: Array<StockSymbol> | null;
    /**
     * 
     * @type {object}
     * @memberof StockSymbolArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof StockSymbolArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof StockSymbolArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface StringStringKeyValuePair
 */
export interface StringStringKeyValuePair {
    /**
     * 
     * @type {string}
     * @memberof StringStringKeyValuePair
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringStringKeyValuePair
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionDto
 */
export interface SubscriptionDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'subscriptionUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDto
     */
    'packageId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'packageName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'packageSlug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'packageThumbnail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDto
     */
    'numberOfLicenses'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDto
     */
    'numberOfMonths'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionDto
     */
    'billRecurringly'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'po'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'expireDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'startDateUtc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionDto
     */
    'isTrial'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDto
     */
    'paymentStatusId'?: number;
}
/**
 * 
 * @export
 * @interface SubscriptionDtoGenericResponse
 */
export interface SubscriptionDtoGenericResponse {
    /**
     * 
     * @type {SubscriptionDto}
     * @memberof SubscriptionDtoGenericResponse
     */
    'data'?: SubscriptionDto;
    /**
     * 
     * @type {object}
     * @memberof SubscriptionDtoGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof SubscriptionDtoGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof SubscriptionDtoGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface SubscriptionInfo
 */
export interface SubscriptionInfo {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfo
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfo
     */
    'packageId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInfo
     */
    'packageName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInfo
     */
    'packageSlug'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionInfo
     */
    'isCustomPrice'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfo
     */
    'cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfo
     */
    'numberOfLicenses'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionInfo
     */
    'billRecurringly'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInfo
     */
    'po'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInfo
     */
    'expireDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfo
     */
    'numberOfMonths'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionInfo
     */
    'isTrial'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionInfo
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfo
     */
    'paymentStatusId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfo
     */
    'currentBreakPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInfo
     */
    'packageThumbnail'?: string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionPurchaseRequest
 */
export interface SubscriptionPurchaseRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPurchaseRequest
     */
    'subscriptionId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPurchaseRequest
     */
    'subscriptionUuid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPurchaseRequest
     */
    'packageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPurchaseRequest
     */
    'numberOfPlayers'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPurchaseRequest
     */
    'billRecurringly'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPurchaseRequest
     */
    'po'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPurchaseRequest
     */
    'expireDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPurchaseRequest
     */
    'numberOfMonths'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPurchaseRequest
     */
    'isTrial'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPurchaseRequest
     */
    'shouldConvertTrial'?: boolean;
}
/**
 * 
 * @export
 * @interface SyncStep
 */
export interface SyncStep {
    /**
     * 
     * @type {number}
     * @memberof SyncStep
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof SyncStep
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncStep
     */
    'clientComponentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncStep
     */
    'displayNameI18nKey'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SyncStep
     */
    'shouldPersistConnection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SyncStep
     */
    'shouldShowInNavigation'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncStep
     */
    'model'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface Team
 */
export interface Team {
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'leagueId': string;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface ThemeSelectListItem
 */
export interface ThemeSelectListItem {
    /**
     * 
     * @type {string}
     * @memberof ThemeSelectListItem
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThemeSelectListItem
     */
    'value'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ThemeSelectListItem
     */
    'channelIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ThemeSelectListItem
     */
    'customizable'?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: object | null; }}
     * @memberof ThemeSelectListItem
     */
    'defaultValues'?: { [key: string]: object | null; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof ThemeSelectListItem
     */
    'deprecated'?: boolean | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ThemeSelectListItem
     */
    'allowedFormatIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface TrafficPointDto
 */
export interface TrafficPointDto {
    /**
     * 
     * @type {number}
     * @memberof TrafficPointDto
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof TrafficPointDto
     */
    'lon': number;
}
/**
 * 
 * @export
 * @interface TrafficRegionDto
 */
export interface TrafficRegionDto {
    /**
     * 
     * @type {number}
     * @memberof TrafficRegionDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrafficRegionDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TrafficRegionDtoGenericResponse
 */
export interface TrafficRegionDtoGenericResponse {
    /**
     * 
     * @type {TrafficRegionDto}
     * @memberof TrafficRegionDtoGenericResponse
     */
    'data'?: TrafficRegionDto;
    /**
     * 
     * @type {object}
     * @memberof TrafficRegionDtoGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof TrafficRegionDtoGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof TrafficRegionDtoGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface TrafficRouteDto
 */
export interface TrafficRouteDto {
    /**
     * 
     * @type {number}
     * @memberof TrafficRouteDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrafficRouteDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficRouteDto
     */
    'roadIcon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrafficRouteDto
     */
    'setId'?: number;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof TrafficRouteDto
     */
    'start'?: TrafficPointDto;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof TrafficRouteDto
     */
    'end'?: TrafficPointDto;
    /**
     * 
     * @type {string}
     * @memberof TrafficRouteDto
     */
    'startAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrafficRouteDto
     */
    'endAddress'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof TrafficRouteDto
     */
    'referencingFeedIds': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof TrafficRouteDto
     */
    'healthStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrafficRouteDto
     */
    'healthReason'?: string | null;
}
/**
 * 
 * @export
 * @interface TrafficRouteDtoGenericResponse
 */
export interface TrafficRouteDtoGenericResponse {
    /**
     * 
     * @type {TrafficRouteDto}
     * @memberof TrafficRouteDtoGenericResponse
     */
    'data'?: TrafficRouteDto;
    /**
     * 
     * @type {object}
     * @memberof TrafficRouteDtoGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof TrafficRouteDtoGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof TrafficRouteDtoGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface TrafficSetDto
 */
export interface TrafficSetDto {
    /**
     * 
     * @type {number}
     * @memberof TrafficSetDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrafficSetDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficSetDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof TrafficSetDto
     */
    'regionId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TrafficSetDto
     */
    'private'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrafficSetDto
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrafficSetDto
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrafficSetDto
     */
    'ownerAccountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrafficSetDto
     */
    'routeCount'?: number;
}
/**
 * 
 * @export
 * @interface TrafficSetDtoGenericResponse
 */
export interface TrafficSetDtoGenericResponse {
    /**
     * 
     * @type {TrafficSetDto}
     * @memberof TrafficSetDtoGenericResponse
     */
    'data'?: TrafficSetDto;
    /**
     * 
     * @type {object}
     * @memberof TrafficSetDtoGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof TrafficSetDtoGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof TrafficSetDtoGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface TrialHistoryResponse
 */
export interface TrialHistoryResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof TrialHistoryResponse
     */
    'packageIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface TrialHistoryResponseGenericResponse
 */
export interface TrialHistoryResponseGenericResponse {
    /**
     * 
     * @type {TrialHistoryResponse}
     * @memberof TrialHistoryResponseGenericResponse
     */
    'data'?: TrialHistoryResponse;
    /**
     * 
     * @type {object}
     * @memberof TrialHistoryResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof TrialHistoryResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof TrialHistoryResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface TrialSubscriptions
 */
export interface TrialSubscriptions {
    /**
     * 
     * @type {string}
     * @memberof TrialSubscriptions
     */
    'subscriptionUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof TrialSubscriptions
     */
    'packageId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TrialSubscriptions
     */
    'isExpired'?: boolean;
}
/**
 * 
 * @export
 * @interface TryConnectCommand
 */
export interface TryConnectCommand {
    /**
     * 
     * @type {number}
     * @memberof TryConnectCommand
     */
    'childAccountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TryConnectCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TryConnectCommand
     */
    'shouldCreateTrial'?: boolean;
}
/**
 * 
 * @export
 * @interface TryConnectResult
 */
export interface TryConnectResult {
    /**
     * 
     * @type {string}
     * @memberof TryConnectResult
     */
    'redirectUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface TryConnectResultGenericResponse
 */
export interface TryConnectResultGenericResponse {
    /**
     * 
     * @type {TryConnectResult}
     * @memberof TryConnectResultGenericResponse
     */
    'data'?: TryConnectResult;
    /**
     * 
     * @type {object}
     * @memberof TryConnectResultGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof TryConnectResultGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof TryConnectResultGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface UnarchiveCustomerRequest
 */
export interface UnarchiveCustomerRequest {
    /**
     * 
     * @type {number}
     * @memberof UnarchiveCustomerRequest
     */
    'customerAccountId'?: number;
}
/**
 * 
 * @export
 * @interface UnarchiveCustomerResponseGenericResponse
 */
export interface UnarchiveCustomerResponseGenericResponse {
    /**
     * 
     * @type {object}
     * @memberof UnarchiveCustomerResponseGenericResponse
     */
    'data'?: object;
    /**
     * 
     * @type {object}
     * @memberof UnarchiveCustomerResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof UnarchiveCustomerResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof UnarchiveCustomerResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface UnhideModerationContentRequest
 */
export interface UnhideModerationContentRequest {
    /**
     * 
     * @type {number}
     * @memberof UnhideModerationContentRequest
     */
    'feedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UnhideModerationContentRequest
     */
    'contentId'?: string | null;
}
/**
 * 
 * @export
 * @interface UnmoderateContentRequest
 */
export interface UnmoderateContentRequest {
    /**
     * 
     * @type {number}
     * @memberof UnmoderateContentRequest
     */
    'feedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UnmoderateContentRequest
     */
    'contentId'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateAccountContactCommand
 */
export interface UpdateAccountContactCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateAccountContactCommand
     */
    'contactId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountContactCommand
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountContactCommand
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountContactCommand
     */
    'phone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAccountContactCommand
     */
    'accountId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateAccountMetaInfoRequest
 */
export interface UpdateAccountMetaInfoRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateAccountMetaInfoRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAccountMetaInfoRequest
     */
    'viewers'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountMetaInfoRequest
     */
    'venue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountMetaInfoRequest
     */
    'dwellTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountMetaInfoRequest
     */
    'software'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateBillingAddressRequest
 */
export interface UpdateBillingAddressRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateBillingAddressRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBillingAddressRequest
     */
    'streetAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBillingAddressRequest
     */
    'locality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBillingAddressRequest
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBillingAddressRequest
     */
    'postcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBillingAddressRequest
     */
    'country'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateBillingAddressRequest
     */
    'currencyId'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateCompanyRequest
 */
export interface UpdateCompanyRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'locality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'postCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateConnectionAuthCommand
 */
export interface UpdateConnectionAuthCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateConnectionAuthCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateConnectionAuthCommand
     */
    'providerAuthId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateContentMenuResponse
 */
export interface UpdateContentMenuResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateContentMenuResponse
     */
    'subdomain'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContentMenuResponse
     */
    'logoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContentMenuResponse
     */
    'bannerColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContentMenuResponse
     */
    'accentColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContentMenuResponse
     */
    'textColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContentMenuResponse
     */
    'backgroundColor'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateContentMenuResponseGenericResponse
 */
export interface UpdateContentMenuResponseGenericResponse {
    /**
     * 
     * @type {UpdateContentMenuResponse}
     * @memberof UpdateContentMenuResponseGenericResponse
     */
    'data'?: UpdateContentMenuResponse;
    /**
     * 
     * @type {object}
     * @memberof UpdateContentMenuResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof UpdateContentMenuResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof UpdateContentMenuResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface UpdateCreditCardRequest
 */
export interface UpdateCreditCardRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCreditCardRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCreditCardRequest
     */
    'cardNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCreditCardRequest
     */
    'billToName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCreditCardRequest
     */
    'expireYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCreditCardRequest
     */
    'expireMonth'?: number;
    /**
     * 
     * @type {Address}
     * @memberof UpdateCreditCardRequest
     */
    'billingAddress'?: Address;
    /**
     * 
     * @type {string}
     * @memberof UpdateCreditCardRequest
     */
    'billingEmail'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateCustomerRequest
 */
export interface UpdateCustomerRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomerRequest
     */
    'customerAccountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'customerName'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateCustomerResponseGenericResponse
 */
export interface UpdateCustomerResponseGenericResponse {
    /**
     * 
     * @type {object}
     * @memberof UpdateCustomerResponseGenericResponse
     */
    'data'?: object;
    /**
     * 
     * @type {object}
     * @memberof UpdateCustomerResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof UpdateCustomerResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof UpdateCustomerResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface UpdateFeedAccessKeyCommand
 */
export interface UpdateFeedAccessKeyCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedAccessKeyCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeedAccessKeyCommand
     */
    'isUpdate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedAccessKeyCommand
     */
    'accessKey'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFeedDeliveryMethodCommand
 */
export interface UpdateFeedDeliveryMethodCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedDeliveryMethodCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedDeliveryMethodCommand
     */
    'deliveryMethod'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFeedFormatCommand
 */
export interface UpdateFeedFormatCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedFormatCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedFormatCommand
     */
    'formatId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateFeedIgnoreExpirationCommand
 */
export interface UpdateFeedIgnoreExpirationCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedIgnoreExpirationCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeedIgnoreExpirationCommand
     */
    'ignoreExpiration'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateFeedIncludeTextCommand
 */
export interface UpdateFeedIncludeTextCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedIncludeTextCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeedIncludeTextCommand
     */
    'includeText'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateFeedIsArchivedCommand
 */
export interface UpdateFeedIsArchivedCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedIsArchivedCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeedIsArchivedCommand
     */
    'isArchived'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateFeedLanguageCommand
 */
export interface UpdateFeedLanguageCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedLanguageCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedLanguageCommand
     */
    'language'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFeedLocationCommand
 */
export interface UpdateFeedLocationCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedLocationCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedLocationCommand
     */
    'location'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFeedModerationMethodRequest
 */
export interface UpdateFeedModerationMethodRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedModerationMethodRequest
     */
    'feedId'?: number;
    /**
     * 
     * @type {FeedModerationMethod}
     * @memberof UpdateFeedModerationMethodRequest
     */
    'moderationMethod'?: FeedModerationMethod;
}


/**
 * 
 * @export
 * @interface UpdateFeedNameCommand
 */
export interface UpdateFeedNameCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedNameCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedNameCommand
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFeedPropertyCommand
 */
export interface UpdateFeedPropertyCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedPropertyCommand
     */
    'feedId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateFeedRemoveMediaCommand
 */
export interface UpdateFeedRemoveMediaCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedRemoveMediaCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeedRemoveMediaCommand
     */
    'removeMedia'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateFeedRequest
 */
export interface UpdateFeedRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedRequest
     */
    'feedId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedRequest
     */
    'formatId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedRequest
     */
    'name': string;
    /**
     * 
     * @type {FeedDeliveryMethod}
     * @memberof UpdateFeedRequest
     */
    'deliveryMethod'?: FeedDeliveryMethod;
    /**
     * 
     * @type {FeedModerationMethod}
     * @memberof UpdateFeedRequest
     */
    'moderationMethod'?: FeedModerationMethod;
    /**
     * 
     * @type {Array<ChannelInfo>}
     * @memberof UpdateFeedRequest
     */
    'channels'?: Array<ChannelInfo> | null;
    /**
     * 
     * @type {Array<DataConnection>}
     * @memberof UpdateFeedRequest
     */
    'connections'?: Array<DataConnection> | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof UpdateFeedRequest
     */
    'options'?: { [key: string]: string; } | null;
}


/**
 * 
 * @export
 * @interface UpdateFeedResponse
 */
export interface UpdateFeedResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedResponse
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedResponse
     */
    'deliveryMethod': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedResponse
     */
    'feedId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedResponse
     */
    'feedUuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeedResponse
     */
    'requiresSetup': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedResponse
     */
    'playerAuthMode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedResponse
     */
    'playerSoftware'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedResponse
     */
    'playlistUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedResponse
     */
    'pluginDownloadUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedResponse
     */
    'triggerUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFeedResponseGenericResponse
 */
export interface UpdateFeedResponseGenericResponse {
    /**
     * 
     * @type {UpdateFeedResponse}
     * @memberof UpdateFeedResponseGenericResponse
     */
    'data'?: UpdateFeedResponse;
    /**
     * 
     * @type {object}
     * @memberof UpdateFeedResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof UpdateFeedResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof UpdateFeedResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface UpdateFeedThemeCommand
 */
export interface UpdateFeedThemeCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateFeedThemeCommand
     */
    'feedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeedThemeCommand
     */
    'theme'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateInvoicePONumberRequest
 */
export interface UpdateInvoicePONumberRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateInvoicePONumberRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateInvoicePONumberRequest
     */
    'pONumber'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateLanguageFiltersRequest
 */
export interface UpdateLanguageFiltersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateLanguageFiltersRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLanguageFiltersRequest
     */
    'phrases'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface UpdateLanguageFiltersResponse
 */
export interface UpdateLanguageFiltersResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLanguageFiltersResponse
     */
    'phrases'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface UpdateLanguageFiltersResponseGenericResponse
 */
export interface UpdateLanguageFiltersResponseGenericResponse {
    /**
     * 
     * @type {UpdateLanguageFiltersResponse}
     * @memberof UpdateLanguageFiltersResponseGenericResponse
     */
    'data'?: UpdateLanguageFiltersResponse;
    /**
     * 
     * @type {object}
     * @memberof UpdateLanguageFiltersResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof UpdateLanguageFiltersResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof UpdateLanguageFiltersResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface UpdateSamsungVxtFeedRequest
 */
export interface UpdateSamsungVxtFeedRequest {
    /**
     * 
     * @type {SamsungVxtFeed}
     * @memberof UpdateSamsungVxtFeedRequest
     */
    'feed'?: SamsungVxtFeed;
}
/**
 * 
 * @export
 * @interface UpdateTrafficRouteCommand
 */
export interface UpdateTrafficRouteCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateTrafficRouteCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrafficRouteCommand
     */
    'routeId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrafficRouteCommand
     */
    'name': string;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof UpdateTrafficRouteCommand
     */
    'start': TrafficPointDto;
    /**
     * 
     * @type {TrafficPointDto}
     * @memberof UpdateTrafficRouteCommand
     */
    'end': TrafficPointDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrafficRouteCommand
     */
    'startAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrafficRouteCommand
     */
    'endAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrafficRouteCommand
     */
    'roadIcon'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateTrafficSetCommand
 */
export interface UpdateTrafficSetCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateTrafficSetCommand
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrafficSetCommand
     */
    'setId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrafficSetCommand
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrafficSetCommand
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrafficSetCommand
     */
    'longitude'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateUserFromStoreCommand
 */
export interface UpdateUserFromStoreCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateUserFromStoreCommand
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserFromStoreCommand
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserFromStoreCommand
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserFromStoreCommand
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserFromStoreCommand
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserFromStoreCommand
     */
    'password'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserFromStoreCommand
     */
    'isPrimaryContact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserFromStoreCommand
     */
    'shouldReceiveAllEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserFromStoreCommand
     */
    'shouldReceiveAccountAlertEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserFromStoreCommand
     */
    'shouldReceiveBillingEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserFromStoreCommand
     */
    'shouldReceiveIntegrationEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserFromStoreCommand
     */
    'shouldSendInviteEmail'?: boolean;
    /**
     * 
     * @type {Array<AppAccess>}
     * @memberof UpdateUserFromStoreCommand
     */
    'appAccess'?: Array<AppAccess> | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserFromStoreCommand
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface UploadFeedLogoResponse
 */
export interface UploadFeedLogoResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadFeedLogoResponse
     */
    'imageUrl': string;
    /**
     * 
     * @type {number}
     * @memberof UploadFeedLogoResponse
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof UploadFeedLogoResponse
     */
    'height': number;
}
/**
 * 
 * @export
 * @interface UploadFeedLogoResponseGenericResponse
 */
export interface UploadFeedLogoResponseGenericResponse {
    /**
     * 
     * @type {UploadFeedLogoResponse}
     * @memberof UploadFeedLogoResponseGenericResponse
     */
    'data'?: UploadFeedLogoResponse;
    /**
     * 
     * @type {object}
     * @memberof UploadFeedLogoResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof UploadFeedLogoResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof UploadFeedLogoResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ValidLocation
 */
export interface ValidLocation {
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'stateFull': string;
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'nearestZip': string;
    /**
     * 
     * @type {number}
     * @memberof ValidLocation
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof ValidLocation
     */
    'lon': number;
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'timeZone': string;
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'ianaTimeZone': string;
    /**
     * 
     * @type {number}
     * @memberof ValidLocation
     */
    'timeZoneOffset': number;
    /**
     * 
     * @type {string}
     * @memberof ValidLocation
     */
    'localTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidLocation
     */
    'isUnknown': boolean;
    /**
     * 
     * @type {{ [key: string]: string | null; }}
     * @memberof ValidLocation
     */
    'options': { [key: string]: string | null; };
}
/**
 * 
 * @export
 * @interface ValidateCreateAccountFromAccountCommand
 */
export interface ValidateCreateAccountFromAccountCommand {
    /**
     * 
     * @type {string}
     * @memberof ValidateCreateAccountFromAccountCommand
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateCreateAccountFromAccountCommand
     */
    'securityStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateCreateAccountFromAccountCommand
     */
    'accountGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateCreateAccountFromAccountCommand
     */
    'returnUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface ValidateCreateAccountResult
 */
export interface ValidateCreateAccountResult {
    /**
     * 
     * @type {string}
     * @memberof ValidateCreateAccountResult
     */
    'oneTimeAccessUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface ValidateCreateAccountResultGenericResponse
 */
export interface ValidateCreateAccountResultGenericResponse {
    /**
     * 
     * @type {ValidateCreateAccountResult}
     * @memberof ValidateCreateAccountResultGenericResponse
     */
    'data'?: ValidateCreateAccountResult;
    /**
     * 
     * @type {object}
     * @memberof ValidateCreateAccountResultGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ValidateCreateAccountResultGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ValidateCreateAccountResultGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ValidateCreateAccountSecurityStampCommand
 */
export interface ValidateCreateAccountSecurityStampCommand {
    /**
     * 
     * @type {string}
     * @memberof ValidateCreateAccountSecurityStampCommand
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateCreateAccountSecurityStampCommand
     */
    'securityStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateCreateAccountSecurityStampCommand
     */
    'accountGuid'?: string | null;
}
/**
 * 
 * @export
 * @interface ValidateLocationResponse
 */
export interface ValidateLocationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateLocationResponse
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidateLocationResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ValidLocation}
     * @memberof ValidateLocationResponse
     */
    'location'?: ValidLocation;
}
/**
 * 
 * @export
 * @interface ValidateLocationResponseGenericResponse
 */
export interface ValidateLocationResponseGenericResponse {
    /**
     * 
     * @type {ValidateLocationResponse}
     * @memberof ValidateLocationResponseGenericResponse
     */
    'data'?: ValidateLocationResponse;
    /**
     * 
     * @type {object}
     * @memberof ValidateLocationResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ValidateLocationResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ValidateLocationResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface ValidateSubdomainRequest
 */
export interface ValidateSubdomainRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateSubdomainRequest
     */
    'subdomain'?: string | null;
}
/**
 * 
 * @export
 * @interface ValidateSubdomainResponse
 */
export interface ValidateSubdomainResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateSubdomainResponse
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ValidateSubdomainResponseGenericResponse
 */
export interface ValidateSubdomainResponseGenericResponse {
    /**
     * 
     * @type {ValidateSubdomainResponse}
     * @memberof ValidateSubdomainResponseGenericResponse
     */
    'data'?: ValidateSubdomainResponse;
    /**
     * 
     * @type {object}
     * @memberof ValidateSubdomainResponseGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ValidateSubdomainResponseGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof ValidateSubdomainResponseGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface Venue
 */
export interface Venue {
    /**
     * 
     * @type {string}
     * @memberof Venue
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Venue
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface VenueArrayGenericResponse
 */
export interface VenueArrayGenericResponse {
    /**
     * 
     * @type {Array<Venue>}
     * @memberof VenueArrayGenericResponse
     */
    'data'?: Array<Venue> | null;
    /**
     * 
     * @type {object}
     * @memberof VenueArrayGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof VenueArrayGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof VenueArrayGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface VerifyCodeCommand
 */
export interface VerifyCodeCommand {
    /**
     * 
     * @type {number}
     * @memberof VerifyCodeCommand
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VerifyCodeCommand
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface VerifyCodeCommandGenericResponse
 */
export interface VerifyCodeCommandGenericResponse {
    /**
     * 
     * @type {VerifyCodeCommand}
     * @memberof VerifyCodeCommandGenericResponse
     */
    'data'?: VerifyCodeCommand;
    /**
     * 
     * @type {object}
     * @memberof VerifyCodeCommandGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof VerifyCodeCommandGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof VerifyCodeCommandGenericResponse
     */
    'error'?: ErrorDetail;
}
/**
 * 
 * @export
 * @interface WorkspaceDto
 */
export interface WorkspaceDto {
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface WorkspaceDtoIEnumerableGenericResponse
 */
export interface WorkspaceDtoIEnumerableGenericResponse {
    /**
     * 
     * @type {Array<WorkspaceDto>}
     * @memberof WorkspaceDtoIEnumerableGenericResponse
     */
    'data'?: Array<WorkspaceDto> | null;
    /**
     * 
     * @type {object}
     * @memberof WorkspaceDtoIEnumerableGenericResponse
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof WorkspaceDtoIEnumerableGenericResponse
     */
    'errors'?: Array<ErrorDetail> | null;
    /**
     * 
     * @type {ErrorDetail}
     * @memberof WorkspaceDtoIEnumerableGenericResponse
     */
    'error'?: ErrorDetail;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AdminCreateTrafficRouteCommand} [adminCreateTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateTrafficRoute: async (adminCreateTrafficRouteCommand?: AdminCreateTrafficRouteCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/AdminCreateTrafficRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateTrafficRouteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminDeleteTrafficRouteCommand} [adminDeleteTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteTrafficRoute: async (adminDeleteTrafficRouteCommand?: AdminDeleteTrafficRouteCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/AdminDeleteTrafficRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminDeleteTrafficRouteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminUpdateTrafficRouteCommand} [adminUpdateTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateTrafficRoute: async (adminUpdateTrafficRouteCommand?: AdminUpdateTrafficRouteCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/AdminUpdateTrafficRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateTrafficRouteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ArchiveCustomerRequest} [archiveCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCustomer: async (archiveCustomerRequest?: ArchiveCustomerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/ArchiveCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ArchiveUserCommand} [archiveUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveUser: async (archiveUserCommand?: ArchiveUserCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/ArchiveUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeactivateSubscriptionFromAcctCommand} [deactivateSubscriptionFromAcctCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (deactivateSubscriptionFromAcctCommand?: DeactivateSubscriptionFromAcctCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CancelSubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deactivateSubscriptionFromAcctCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CloneFeedCommand} [cloneFeedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneFeed: async (cloneFeedCommand?: CloneFeedCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CloneFeed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloneFeedCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAccountFromAccountCommand} [createAccountFromAccountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: async (createAccountFromAccountCommand?: CreateAccountFromAccountCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccountFromAccountCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAccountBillingEmailRequest} [createAccountBillingEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountBillingEmail: async (createAccountBillingEmailRequest?: CreateAccountBillingEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateAccountBillingEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccountBillingEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFeedConnection} [createFeedConnection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnection: async (createFeedConnection?: CreateFeedConnection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateConnection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFeedConnection, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateChildAccountFromStoreCommand} [createChildAccountFromStoreCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: async (createChildAccountFromStoreCommand?: CreateChildAccountFromStoreCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChildAccountFromStoreCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFeedRequest} [createFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeed: async (createFeedRequest?: CreateFeedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateFeed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFeedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateProviderAuthMagicLinkCommand} [createProviderAuthMagicLinkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderAuthMagicLink: async (createProviderAuthMagicLinkCommand?: CreateProviderAuthMagicLinkCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateProviderAuthMagicLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProviderAuthMagicLinkCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSocialSearchCommand} [createSocialSearchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSocialSearch: async (createSocialSearchCommand?: CreateSocialSearchCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateSocialSearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSocialSearchCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTrafficRegionCommand} [createTrafficRegionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrafficRegion: async (createTrafficRegionCommand?: CreateTrafficRegionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateTrafficRegion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrafficRegionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTrafficRouteCommand} [createTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrafficRoute: async (createTrafficRouteCommand?: CreateTrafficRouteCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateTrafficRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrafficRouteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTrafficSetCommand} [createTrafficSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrafficSet: async (createTrafficSetCommand?: CreateTrafficSetCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateTrafficSet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrafficSetCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTrialSubscriptionFromAcctCommand} [createTrialSubscriptionFromAcctCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrialSubscription: async (createTrialSubscriptionFromAcctCommand?: CreateTrialSubscriptionFromAcctCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateTrialSubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrialSubscriptionFromAcctCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserFromStoreCommand} [createUserFromStoreCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserFromStoreCommand?: CreateUserFromStoreCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserFromStoreCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserMagicInviteLinkCommand} [createUserMagicInviteLinkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserMagicInviteLink: async (createUserMagicInviteLinkCommand?: CreateUserMagicInviteLinkCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/CreateUserMagicInviteLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserMagicInviteLinkCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteProviderAuthCommand} [deleteProviderAuthCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderAuth: async (deleteProviderAuthCommand?: DeleteProviderAuthCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/DeleteProviderAuth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteProviderAuthCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteTrafficRegionCommand} [deleteTrafficRegionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrafficRegion: async (deleteTrafficRegionCommand?: DeleteTrafficRegionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/DeleteTrafficRegion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTrafficRegionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteTrafficRouteCommand} [deleteTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrafficRoute: async (deleteTrafficRouteCommand?: DeleteTrafficRouteCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/DeleteTrafficRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTrafficRouteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteTrafficSetCommand} [deleteTrafficSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrafficSet: async (deleteTrafficSetCommand?: DeleteTrafficSetCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/DeleteTrafficSet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTrafficSetCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExchangeCodeCommand} [exchangeCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeEmaiValidationlCode: async (exchangeCodeCommand?: ExchangeCodeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/ExchangeEmaiValidationlCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeCodeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendResetPasswordByEmailCommand} [sendResetPasswordByEmailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (sendResetPasswordByEmailCommand?: SendResetPasswordByEmailCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/ForgotPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendResetPasswordByEmailCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAccountRequest} [getAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (getAccountRequest?: GetAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAccountContactsForStoreQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountContact: async (query?: GetAccountContactsForStoreQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetAccountContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAccountContactsForStoreQuery} [getAccountContactsForStoreQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountContacts: async (getAccountContactsForStoreQuery?: GetAccountContactsForStoreQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetAccountContacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAccountContactsForStoreQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPackageFeeds} [getPackageFeeds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPackageFeeds: async (getPackageFeeds?: GetPackageFeeds, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetAccountPackageFeeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPackageFeeds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAirportAutocompleteRequest} [getAirportAutocompleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAirportAutocomplete: async (getAirportAutocompleteRequest?: GetAirportAutocompleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetAirportAutocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAirportAutocompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAuthModelRequest} [getAuthModelRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthClientModel: async (getAuthModelRequest?: GetAuthModelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetAuthClientModel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAuthModelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAuthedUsersRequest} [getAuthedUsersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthedUsersForProvider: async (getAuthedUsersRequest?: GetAuthedUsersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetAuthedUsersForProvider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAuthedUsersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [providerId] 
         * @param {number} [accountId] 
         * @param {string} [clientUrl] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizationModel: async (providerId?: number, accountId?: number, clientUrl?: string, version?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetAuthorizationModel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['ProviderId'] = providerId;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['AccountId'] = accountId;
            }

            if (clientUrl !== undefined) {
                localVarQueryParameter['ClientUrl'] = clientUrl;
            }

            if (version !== undefined) {
                localVarQueryParameter['Version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAuthorizedCurrenciesRequest} [getAuthorizedCurrenciesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedCurrencies: async (getAuthorizedCurrenciesRequest?: GetAuthorizedCurrenciesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetAuthorizedCurrencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAuthorizedCurrenciesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetBillDetailRequest} [getBillDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDetail: async (getBillDetailRequest?: GetBillDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetBillDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBillDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetBillsRequest} [getBillsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBills: async (getBillsRequest?: GetBillsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetBills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBillsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionInfo: async (connectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('getConnectionInfo', 'connectionId', connectionId)
            const localVarPath = `/acct/v2/GetConnectionInfo/connection/{connectionId}`
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionMetrics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetConnectionMetrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetConnectionProvidersBySlugQuery} [getConnectionProvidersBySlugQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionProvidersBySlug: async (getConnectionProvidersBySlugQuery?: GetConnectionProvidersBySlugQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetConnectionProvidersBySlug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getConnectionProvidersBySlugQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetFeedDataConnectionsQuery} [getFeedDataConnectionsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnections: async (getFeedDataConnectionsQuery?: GetFeedDataConnectionsQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetConnections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFeedDataConnectionsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetFeedDataConnectionsByProviderQuery} [getFeedDataConnectionsByProviderQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionsByProvider: async (getFeedDataConnectionsByProviderQuery?: GetFeedDataConnectionsByProviderQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetConnectionsByProvider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFeedDataConnectionsByProviderQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [authorization] Optional Bearer token
         * @param {GetContentMenuQuery} [getContentMenuQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentMenu: async (authorization?: string, getContentMenuQuery?: GetContentMenuQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetContentMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getContentMenuQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyCountry: async (body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetCurrencyCountry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetCustomersRequest} [getCustomersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers: async (getCustomersRequest?: GetCustomersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetCustomers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCustomersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetExpiringTrialsQuery} [getExpiringTrialsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiringTrials: async (getExpiringTrialsQuery?: GetExpiringTrialsQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetExpiringTrials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getExpiringTrialsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetFeedConfigRequest} [getFeedConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedConfig: async (getFeedConfigRequest?: GetFeedConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetFeedConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFeedConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [authorization] Optional Bearer token
         * @param {GetFeedCreationRequest} [getFeedCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedCreation: async (authorization?: string, getFeedCreationRequest?: GetFeedCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetFeedCreation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFeedCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetFeedModerationMethodRequest} [getFeedModerationMethodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedModerationMethod: async (getFeedModerationMethodRequest?: GetFeedModerationMethodRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetFeedModerationMethod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFeedModerationMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetFeedsQuery} [getFeedsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeds: async (getFeedsQuery?: GetFeedsQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetFeeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFeedsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetCalendarsCommand} [getCalendarsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleCalendars: async (getCalendarsCommand?: GetCalendarsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetGoogleCalendars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCalendarsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetLanguageFiltersRequest} [getLanguageFiltersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguageFilters: async (getLanguageFiltersRequest?: GetLanguageFiltersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetLanguageFilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getLanguageFiltersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocalFavoritesCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetLocalFavoritesCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetMicrosoftCalendarsCommand} [getMicrosoftCalendarsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMicrosoftCalendars: async (getMicrosoftCalendarsCommand?: GetMicrosoftCalendarsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetMicrosoftCalendars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getMicrosoftCalendarsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetMindBodySitesCommand} [getMindBodySitesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMindBodySites: async (getMindBodySitesCommand?: GetMindBodySitesCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetMindBodySites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getMindBodySitesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetModerationContentRequest} [getModerationContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerationContent: async (getModerationContentRequest?: GetModerationContentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetModerationContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getModerationContentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetMomentusRoomsCommand} [getMomentusRoomsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMomentusRooms: async (getMomentusRoomsCommand?: GetMomentusRoomsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetMomentusRooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getMomentusRoomsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetMomentusVenusCommand} [getMomentusVenusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMomentusVenues: async (getMomentusVenusCommand?: GetMomentusVenusCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetMomentusVenues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getMomentusVenusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetOffMenuAccountPackagesQuery} [getOffMenuAccountPackagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffMenuAccountPackages: async (getOffMenuAccountPackagesQuery?: GetOffMenuAccountPackagesQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetOffMenuAccountPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOffMenuAccountPackagesQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetOneTimeProviderAuthsRequestQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneTimeAuthRequests: async (query?: GetOneTimeProviderAuthsRequestQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetOneTimeAuthRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPackagesQuery} [getPackagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackagesByIds: async (getPackagesQuery?: GetPackagesQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetPackagesByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPackagesQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerAuthenticationSecret: async (body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetPlayerAuthenticationSecret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPowerBIDashboardsRequest} [getPowerBIDashboardsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerBIDashboards: async (getPowerBIDashboardsRequest?: GetPowerBIDashboardsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetPowerBIDashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPowerBIDashboardsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPowerBIReportsRequest} [getPowerBIReportsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerBIReports: async (getPowerBIReportsRequest?: GetPowerBIReportsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetPowerBIReports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPowerBIReportsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPowerBITilesRequest} [getPowerBITilesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerBITiles: async (getPowerBITilesRequest?: GetPowerBITilesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetPowerBITiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPowerBITilesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPowerBIWorkspacesRequest} [getPowerBIWorkspacesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerBIWorkspaces: async (getPowerBIWorkspacesRequest?: GetPowerBIWorkspacesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetPowerBIWorkspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPowerBIWorkspacesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAccountPrimaryContactQuery} [getAccountPrimaryContactQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryContact: async (getAccountPrimaryContactQuery?: GetAccountPrimaryContactQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetPrimaryContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAccountPrimaryContactQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetProratedTotalQuery} [getProratedTotalQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProratedTotal: async (getProratedTotalQuery?: GetProratedTotalQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetProratedTotal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getProratedTotalQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetProviderAuthSidedoorCommand} [getProviderAuthSidedoorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAuthSidedoor: async (getProviderAuthSidedoorCommand?: GetProviderAuthSidedoorCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetProviderAuthSidedoor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getProviderAuthSidedoorCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetProviderAuthsQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAuths: async (query?: GetProviderAuthsQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetProviderAuths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetProvidersQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders: async (query?: GetProvidersQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSamsungVxtFeedRequest} [getSamsungVxtFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamsungVxtFeed: async (getSamsungVxtFeedRequest?: GetSamsungVxtFeedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetSamsungVxtFeed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSamsungVxtFeedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSocialSearchAuthorizationsQuery} [getSocialSearchAuthorizationsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialSearchAuthorizations: async (getSocialSearchAuthorizationsQuery?: GetSocialSearchAuthorizationsQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetSocialSearchAuthorizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSocialSearchAuthorizationsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSportsLeagues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetSportsLeagues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSportsTeamsRequest} [getSportsTeamsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSportsTeams: async (getSportsTeamsRequest?: GetSportsTeamsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetSportsTeams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSportsTeamsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetStockSymbolsRequest} [getStockSymbolsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockSymbols: async (getStockSymbolsRequest?: GetStockSymbolsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetStockSymbols`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getStockSymbolsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSubscribedPackagesQuery} [getSubscribedPackagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscribedPackages: async (getSubscribedPackagesQuery?: GetSubscribedPackagesQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetSubscribedPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSubscribedPackagesQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSubscriptionPricingQuery} [getSubscriptionPricingQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPricing: async (getSubscriptionPricingQuery?: GetSubscriptionPricingQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetSubscriptionPricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSubscriptionPricingQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSubscriptionsQuery} [getSubscriptionsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions: async (getSubscriptionsQuery?: GetSubscriptionsQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetSubscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSubscriptionsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimezones: async (body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetTimezones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrafficRegions: async (body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetTrafficRegions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetTrafficRoutesQuery} [getTrafficRoutesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrafficRoutes: async (getTrafficRoutesQuery?: GetTrafficRoutesQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetTrafficRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTrafficRoutesQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetTrafficSetsQuery} [getTrafficSetsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrafficSets: async (getTrafficSetsQuery?: GetTrafficSetsQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetTrafficSets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTrafficSetsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetTrialHistoryQuery} [getTrialHistoryQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialHistory: async (getTrialHistoryQuery?: GetTrialHistoryQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/GetTrialHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTrialHistoryQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {HideModerationContentRequest} [hideModerationContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideModerationContent: async (hideModerationContentRequest?: HideModerationContentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/HideModerationContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hideModerationContentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonated: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/Impersonated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ModerateContentRequest} [moderateContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moderateContent: async (moderateContentRequest?: ModerateContentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/ModerateContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moderateContentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PreviewBillRequest} [previewBillRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewBill: async (previewBillRequest?: PreviewBillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/PreviewBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewBillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PurchaseSubscriptionsCommand} [purchaseSubscriptionsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseSubscriptions: async (purchaseSubscriptionsCommand?: PurchaseSubscriptionsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/PurchaseSubscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(purchaseSubscriptionsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReactivateSubscriptionCommand} [reactivateSubscriptionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateSubscription: async (reactivateSubscriptionCommand?: ReactivateSubscriptionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/ReactivateSubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactivateSubscriptionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveAccountBillingEmailRequest} [removeAccountBillingEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAccountBillingEmail: async (removeAccountBillingEmailRequest?: RemoveAccountBillingEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/RemoveAccountBillingEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeAccountBillingEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveFeedRequest} [removeFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFeed: async (removeFeedRequest?: RemoveFeedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/RemoveFeed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeFeedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateFeedNameCommand} [updateFeedNameCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFeed: async (updateFeedNameCommand?: UpdateFeedNameCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/RenameFeed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeedNameCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RenameTrafficRegionCommand} [renameTrafficRegionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameTrafficRegion: async (renameTrafficRegionCommand?: RenameTrafficRegionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/RenameTrafficRegion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameTrafficRegionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendCreateAccountSecurityStampCommand} [sendCreateAccountSecurityStampCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendValidationEmail: async (sendCreateAccountSecurityStampCommand?: SendCreateAccountSecurityStampCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/ResendValidationEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendCreateAccountSecurityStampCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerifyCode: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/SendVerifyCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetReferrerRequest} [setReferrerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setReferrer: async (setReferrerRequest?: SetReferrerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/SetReferrer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setReferrerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateDownload: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/SimulateDownload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeAccountNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/SubscribeAccountNotifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToTestNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/SubscribeToTestNotifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeUserNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/SubscribeUserNotifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TryConnectCommand} [tryConnectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tryConnect: async (tryConnectCommand?: TryConnectCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/TryConnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tryConnectCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnarchiveCustomerRequest} [unarchiveCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveCustomer: async (unarchiveCustomerRequest?: UnarchiveCustomerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UnarchiveCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unarchiveCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnhideModerationContentRequest} [unhideModerationContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unhideModerationContent: async (unhideModerationContentRequest?: UnhideModerationContentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UnhideModerationContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unhideModerationContentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnmoderateContentRequest} [unmoderateContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmoderateContent: async (unmoderateContentRequest?: UnmoderateContentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UnmoderateContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unmoderateContentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAccountMetaInfoRequest} [updateAccountMetaInfoRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountMetaInfo: async (updateAccountMetaInfoRequest?: UpdateAccountMetaInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateAccountMetaInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountMetaInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateBillingAddressRequest} [updateBillingAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingAddress: async (updateBillingAddressRequest?: UpdateBillingAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateBillingAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBillingAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCompanyRequest} [updateCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: async (updateCompanyRequest?: UpdateCompanyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateConnectionAuthCommand} [updateConnectionAuthCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConnectionAuth: async (updateConnectionAuthCommand?: UpdateConnectionAuthCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateConnectionAuth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateConnectionAuthCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAccountContactCommand} [updateAccountContactCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact: async (updateAccountContactCommand?: UpdateAccountContactCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountContactCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {string} [subdomain] 
         * @param {File} [logoFileData] 
         * @param {string} [bannerColor] 
         * @param {string} [accentColor] 
         * @param {string} [textColor] 
         * @param {string} [backgroundColor] 
         * @param {boolean} [shouldRemoveLogo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContentMenu: async (accountId?: number, subdomain?: string, logoFileData?: File, bannerColor?: string, accentColor?: string, textColor?: string, backgroundColor?: string, shouldRemoveLogo?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateContentMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (accountId !== undefined) { 
                localVarFormParams.append('AccountId', accountId as any);
            }
    
            if (subdomain !== undefined) { 
                localVarFormParams.append('Subdomain', subdomain as any);
            }
    
            if (logoFileData !== undefined) { 
                localVarFormParams.append('LogoFileData', logoFileData as any);
            }
    
            if (bannerColor !== undefined) { 
                localVarFormParams.append('BannerColor', bannerColor as any);
            }
    
            if (accentColor !== undefined) { 
                localVarFormParams.append('AccentColor', accentColor as any);
            }
    
            if (textColor !== undefined) { 
                localVarFormParams.append('TextColor', textColor as any);
            }
    
            if (backgroundColor !== undefined) { 
                localVarFormParams.append('BackgroundColor', backgroundColor as any);
            }
    
            if (shouldRemoveLogo !== undefined) { 
                localVarFormParams.append('ShouldRemoveLogo', String(shouldRemoveLogo) as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCreditCardRequest} [updateCreditCardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCreditCard: async (updateCreditCardRequest?: UpdateCreditCardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateCreditCard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCreditCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCustomerRequest} [updateCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: async (updateCustomerRequest?: UpdateCustomerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateFeedRequest} [updateFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeed: async (updateFeedRequest?: UpdateFeedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateFeed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateFeedModerationMethodRequest} [updateFeedModerationMethodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeedModerationMethod: async (updateFeedModerationMethodRequest?: UpdateFeedModerationMethodRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateFeedModerationMethod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeedModerationMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateInvoicePONumberRequest} [updateInvoicePONumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoicePONumber: async (updateInvoicePONumberRequest?: UpdateInvoicePONumberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateInvoicePONumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInvoicePONumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateLanguageFiltersRequest} [updateLanguageFiltersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLanguageFilters: async (updateLanguageFiltersRequest?: UpdateLanguageFiltersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateLanguageFilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLanguageFiltersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSamsungVxtFeedRequest} [updateSamsungVxtFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSamsungVxtFeed: async (updateSamsungVxtFeedRequest?: UpdateSamsungVxtFeedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateSamsungVxtFeed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSamsungVxtFeedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateTrafficRouteCommand} [updateTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrafficRoute: async (updateTrafficRouteCommand?: UpdateTrafficRouteCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateTrafficRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrafficRouteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateTrafficSetCommand} [updateTrafficSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrafficSet: async (updateTrafficSetCommand?: UpdateTrafficSetCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateTrafficSet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrafficSetCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateUserFromStoreCommand} [updateUserFromStoreCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (updateUserFromStoreCommand?: UpdateUserFromStoreCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/UpdateUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserFromStoreCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file The logo file to upload
         * @param {string} [originalFileName] Original name of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo: async (file: File, originalFileName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadLogo', 'file', file)
            const localVarPath = `/acct/v2/UploadLogo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (originalFileName !== undefined) { 
                localVarFormParams.append('originalFileName', originalFileName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidateCreateAccountFromAccountCommand} [validateCreateAccountFromAccountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateAccountSecurityStamp: async (validateCreateAccountFromAccountCommand?: ValidateCreateAccountFromAccountCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/ValidateCreateAccountSecurityStamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateCreateAccountFromAccountCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [authorization] Optional Bearer token
         * @param {GetValidLocationQuery} [getValidLocationQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLocation: async (authorization?: string, getValidLocationQuery?: GetValidLocationQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/ValidateLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getValidLocationQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidateSubdomainRequest} [validateSubdomainRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSubdomain: async (validateSubdomainRequest?: ValidateSubdomainRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/ValidateSubdomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateSubdomainRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyCodeCommand} [verifyCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCode: async (verifyCodeCommand?: VerifyCodeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/acct/v2/VerifyCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyCodeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AdminCreateTrafficRouteCommand} [adminCreateTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateTrafficRoute(adminCreateTrafficRouteCommand?: AdminCreateTrafficRouteCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficRouteDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateTrafficRoute(adminCreateTrafficRouteCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminCreateTrafficRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminDeleteTrafficRouteCommand} [adminDeleteTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteTrafficRoute(adminDeleteTrafficRouteCommand?: AdminDeleteTrafficRouteCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTrafficRouteResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteTrafficRoute(adminDeleteTrafficRouteCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminDeleteTrafficRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminUpdateTrafficRouteCommand} [adminUpdateTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateTrafficRoute(adminUpdateTrafficRouteCommand?: AdminUpdateTrafficRouteCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficRouteDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateTrafficRoute(adminUpdateTrafficRouteCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminUpdateTrafficRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ArchiveCustomerRequest} [archiveCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveCustomer(archiveCustomerRequest?: ArchiveCustomerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArchiveCustomerResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveCustomer(archiveCustomerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.archiveCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ArchiveUserCommand} [archiveUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveUser(archiveUserCommand?: ArchiveUserCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArchiveUserCommandGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveUser(archiveUserCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.archiveUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeactivateSubscriptionFromAcctCommand} [deactivateSubscriptionFromAcctCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(deactivateSubscriptionFromAcctCommand?: DeactivateSubscriptionFromAcctCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(deactivateSubscriptionFromAcctCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cancelSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CloneFeedCommand} [cloneFeedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloneFeed(cloneFeedCommand?: CloneFeedCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloneFeedCommandResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloneFeed(cloneFeedCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cloneFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateAccountFromAccountCommand} [createAccountFromAccountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccount(createAccountFromAccountCommand?: CreateAccountFromAccountCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAccountFromAccountResultGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccount(createAccountFromAccountCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateAccountBillingEmailRequest} [createAccountBillingEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccountBillingEmail(createAccountBillingEmailRequest?: CreateAccountBillingEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountContactGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccountBillingEmail(createAccountBillingEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createAccountBillingEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateFeedConnection} [createFeedConnection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConnection(createFeedConnection?: CreateFeedConnection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFeedConnectionResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConnection(createFeedConnection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateChildAccountFromStoreCommand} [createChildAccountFromStoreCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomer(createChildAccountFromStoreCommand?: CreateChildAccountFromStoreCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateChildAccountResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomer(createChildAccountFromStoreCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateFeedRequest} [createFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFeed(createFeedRequest?: CreateFeedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFeedResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFeed(createFeedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateProviderAuthMagicLinkCommand} [createProviderAuthMagicLinkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProviderAuthMagicLink(createProviderAuthMagicLinkCommand?: CreateProviderAuthMagicLinkCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateProviderAuthMagicLinkResultGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProviderAuthMagicLink(createProviderAuthMagicLinkCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createProviderAuthMagicLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSocialSearchCommand} [createSocialSearchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSocialSearch(createSocialSearchCommand?: CreateSocialSearchCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SocialAuthorizationGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSocialSearch(createSocialSearchCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createSocialSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTrafficRegionCommand} [createTrafficRegionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrafficRegion(createTrafficRegionCommand?: CreateTrafficRegionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficRegionDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrafficRegion(createTrafficRegionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createTrafficRegion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTrafficRouteCommand} [createTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrafficRoute(createTrafficRouteCommand?: CreateTrafficRouteCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficRouteDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrafficRoute(createTrafficRouteCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createTrafficRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTrafficSetCommand} [createTrafficSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrafficSet(createTrafficSetCommand?: CreateTrafficSetCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficSetDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrafficSet(createTrafficSetCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createTrafficSet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTrialSubscriptionFromAcctCommand} [createTrialSubscriptionFromAcctCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrialSubscription(createTrialSubscriptionFromAcctCommand?: CreateTrialSubscriptionFromAcctCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrialSubscription(createTrialSubscriptionFromAcctCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createTrialSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUserFromStoreCommand} [createUserFromStoreCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserFromStoreCommand?: CreateUserFromStoreCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountContactForStoreDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserFromStoreCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUserMagicInviteLinkCommand} [createUserMagicInviteLinkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserMagicInviteLink(createUserMagicInviteLinkCommand?: CreateUserMagicInviteLinkCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserMagicLinkInviteResultGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserMagicInviteLink(createUserMagicInviteLinkCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createUserMagicInviteLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteProviderAuthCommand} [deleteProviderAuthCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProviderAuth(deleteProviderAuthCommand?: DeleteProviderAuthCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteProviderAuthCommandGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProviderAuth(deleteProviderAuthCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteProviderAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteTrafficRegionCommand} [deleteTrafficRegionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrafficRegion(deleteTrafficRegionCommand?: DeleteTrafficRegionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrafficRegion(deleteTrafficRegionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteTrafficRegion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteTrafficRouteCommand} [deleteTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrafficRoute(deleteTrafficRouteCommand?: DeleteTrafficRouteCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTrafficRouteResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrafficRoute(deleteTrafficRouteCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteTrafficRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteTrafficSetCommand} [deleteTrafficSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrafficSet(deleteTrafficSetCommand?: DeleteTrafficSetCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrafficSet(deleteTrafficSetCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteTrafficSet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExchangeCodeCommand} [exchangeCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeEmaiValidationlCode(exchangeCodeCommand?: ExchangeCodeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExchangeCodeResultGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeEmaiValidationlCode(exchangeCodeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exchangeEmaiValidationlCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendResetPasswordByEmailCommand} [sendResetPasswordByEmailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(sendResetPasswordByEmailCommand?: SendResetPasswordByEmailCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserMagicLinkInviteResultGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(sendResetPasswordByEmailCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.forgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAccountRequest} [getAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(getAccountRequest?: GetAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(getAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAccountContactsForStoreQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountContact(query?: GetAccountContactsForStoreQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountContactForStoreDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountContact(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAccountContactsForStoreQuery} [getAccountContactsForStoreQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountContacts(getAccountContactsForStoreQuery?: GetAccountContactsForStoreQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountContactForStoreDtoArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountContacts(getAccountContactsForStoreQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetPackageFeeds} [getPackageFeeds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountPackageFeeds(getPackageFeeds?: GetPackageFeeds, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PackageFeedArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountPackageFeeds(getPackageFeeds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountPackageFeeds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAirportAutocompleteRequest} [getAirportAutocompleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAirportAutocomplete(getAirportAutocompleteRequest?: GetAirportAutocompleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AirportInfoArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAirportAutocomplete(getAirportAutocompleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAirportAutocomplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAuthModelRequest} [getAuthModelRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthClientModel(getAuthModelRequest?: GetAuthModelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAuthModelResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthClientModel(getAuthModelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAuthClientModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAuthedUsersRequest} [getAuthedUsersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthedUsersForProvider(getAuthedUsersRequest?: GetAuthedUsersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizationIEnumerableGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthedUsersForProvider(getAuthedUsersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAuthedUsersForProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [providerId] 
         * @param {number} [accountId] 
         * @param {string} [clientUrl] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorizationModel(providerId?: number, accountId?: number, clientUrl?: string, version?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuthModelDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorizationModel(providerId, accountId, clientUrl, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAuthorizationModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAuthorizedCurrenciesRequest} [getAuthorizedCurrenciesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorizedCurrencies(getAuthorizedCurrenciesRequest?: GetAuthorizedCurrenciesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAuthorizedCurrenciesResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorizedCurrencies(getAuthorizedCurrenciesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAuthorizedCurrencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetBillDetailRequest} [getBillDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillDetail(getBillDetailRequest?: GetBillDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillDetailResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillDetail(getBillDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetBillsRequest} [getBillsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBills(getBillsRequest?: GetBillsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillsResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBills(getBillsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionInfo(connectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionContextGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionInfo(connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConnectionInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionMetrics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionMetricsGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionMetrics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConnectionMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetConnectionProvidersBySlugQuery} [getConnectionProvidersBySlugQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionProvidersBySlug(getConnectionProvidersBySlugQuery?: GetConnectionProvidersBySlugQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionProviderArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionProvidersBySlug(getConnectionProvidersBySlugQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConnectionProvidersBySlug']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetFeedDataConnectionsQuery} [getFeedDataConnectionsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnections(getFeedDataConnectionsQuery?: GetFeedDataConnectionsQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFeedConnectionsResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnections(getFeedDataConnectionsQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConnections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetFeedDataConnectionsByProviderQuery} [getFeedDataConnectionsByProviderQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionsByProvider(getFeedDataConnectionsByProviderQuery?: GetFeedDataConnectionsByProviderQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFeedConnectionsResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionsByProvider(getFeedDataConnectionsByProviderQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConnectionsByProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [authorization] Optional Bearer token
         * @param {GetContentMenuQuery} [getContentMenuQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContentMenu(authorization?: string, getContentMenuQuery?: GetContentMenuQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PackageInfoArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContentMenu(authorization, getContentMenuQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getContentMenu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrencyCountry(body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrencyCountryResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrencyCountry(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCurrencyCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetCustomersRequest} [getCustomersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomers(getCustomersRequest?: GetCustomersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomersResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomers(getCustomersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetExpiringTrialsQuery} [getExpiringTrialsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpiringTrials(getExpiringTrialsQuery?: GetExpiringTrialsQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpiringTrialsResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpiringTrials(getExpiringTrialsQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getExpiringTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetFeedConfigRequest} [getFeedConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedConfig(getFeedConfigRequest?: GetFeedConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFeedConfigResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeedConfig(getFeedConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFeedConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [authorization] Optional Bearer token
         * @param {GetFeedCreationRequest} [getFeedCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedCreation(authorization?: string, getFeedCreationRequest?: GetFeedCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFeedCreationResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeedCreation(authorization, getFeedCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFeedCreation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetFeedModerationMethodRequest} [getFeedModerationMethodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedModerationMethod(getFeedModerationMethodRequest?: GetFeedModerationMethodRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFeedModerationMethodResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeedModerationMethod(getFeedModerationMethodRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFeedModerationMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetFeedsQuery} [getFeedsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeeds(getFeedsQuery?: GetFeedsQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedInfoArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeeds(getFeedsQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFeeds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetCalendarsCommand} [getCalendarsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGoogleCalendars(getCalendarsCommand?: GetCalendarsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarListDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGoogleCalendars(getCalendarsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getGoogleCalendars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetLanguageFiltersRequest} [getLanguageFiltersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLanguageFilters(getLanguageFiltersRequest?: GetLanguageFiltersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLanguageFiltersResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLanguageFilters(getLanguageFiltersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLanguageFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocalFavoritesCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryItemArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocalFavoritesCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLocalFavoritesCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetMicrosoftCalendarsCommand} [getMicrosoftCalendarsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMicrosoftCalendars(getMicrosoftCalendarsCommand?: GetMicrosoftCalendarsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarListDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMicrosoftCalendars(getMicrosoftCalendarsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMicrosoftCalendars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetMindBodySitesCommand} [getMindBodySitesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMindBodySites(getMindBodySitesCommand?: GetMindBodySitesCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MindBodySiteArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMindBodySites(getMindBodySitesCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMindBodySites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetModerationContentRequest} [getModerationContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModerationContent(getModerationContentRequest?: GetModerationContentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetModerationContentResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModerationContent(getModerationContentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getModerationContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetMomentusRoomsCommand} [getMomentusRoomsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMomentusRooms(getMomentusRoomsCommand?: GetMomentusRoomsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMomentusRooms(getMomentusRoomsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMomentusRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetMomentusVenusCommand} [getMomentusVenusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMomentusVenues(getMomentusVenusCommand?: GetMomentusVenusCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VenueArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMomentusVenues(getMomentusVenusCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMomentusVenues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetOffMenuAccountPackagesQuery} [getOffMenuAccountPackagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffMenuAccountPackages(getOffMenuAccountPackagesQuery?: GetOffMenuAccountPackagesQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PackageInfoArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffMenuAccountPackages(getOffMenuAccountPackagesQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOffMenuAccountPackages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetOneTimeProviderAuthsRequestQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneTimeAuthRequests(query?: GetOneTimeProviderAuthsRequestQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOneTimeProviderAuthsRequestDtoArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneTimeAuthRequests(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneTimeAuthRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetPackagesQuery} [getPackagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackagesByIds(getPackagesQuery?: GetPackagesQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PackageInfoArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackagesByIds(getPackagesQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPackagesByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayerAuthenticationSecret(body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayerAuthenticationSecret(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPlayerAuthenticationSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetPowerBIDashboardsRequest} [getPowerBIDashboardsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPowerBIDashboards(getPowerBIDashboardsRequest?: GetPowerBIDashboardsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedObjectDtoIEnumerableGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPowerBIDashboards(getPowerBIDashboardsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPowerBIDashboards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetPowerBIReportsRequest} [getPowerBIReportsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPowerBIReports(getPowerBIReportsRequest?: GetPowerBIReportsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedObjectDtoIEnumerableGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPowerBIReports(getPowerBIReportsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPowerBIReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetPowerBITilesRequest} [getPowerBITilesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPowerBITiles(getPowerBITilesRequest?: GetPowerBITilesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedObjectDtoIEnumerableGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPowerBITiles(getPowerBITilesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPowerBITiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetPowerBIWorkspacesRequest} [getPowerBIWorkspacesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPowerBIWorkspaces(getPowerBIWorkspacesRequest?: GetPowerBIWorkspacesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceDtoIEnumerableGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPowerBIWorkspaces(getPowerBIWorkspacesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPowerBIWorkspaces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAccountPrimaryContactQuery} [getAccountPrimaryContactQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrimaryContact(getAccountPrimaryContactQuery?: GetAccountPrimaryContactQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountContactForStoreDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrimaryContact(getAccountPrimaryContactQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPrimaryContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetProratedTotalQuery} [getProratedTotalQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProratedTotal(getProratedTotalQuery?: GetProratedTotalQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProratedTotalResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProratedTotal(getProratedTotalQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getProratedTotal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetProviderAuthSidedoorCommand} [getProviderAuthSidedoorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderAuthSidedoor(getProviderAuthSidedoorCommand?: GetProviderAuthSidedoorCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProviderAuthSidedoorResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderAuthSidedoor(getProviderAuthSidedoorCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getProviderAuthSidedoor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetProviderAuthsQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderAuths(query?: GetProviderAuthsQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderAuthDtoArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderAuths(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getProviderAuths']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetProvidersQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviders(query?: GetProvidersQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProviderDtoArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviders(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetSamsungVxtFeedRequest} [getSamsungVxtFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSamsungVxtFeed(getSamsungVxtFeedRequest?: GetSamsungVxtFeedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSamsungVxtFeedResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSamsungVxtFeed(getSamsungVxtFeedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSamsungVxtFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetSocialSearchAuthorizationsQuery} [getSocialSearchAuthorizationsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocialSearchAuthorizations(getSocialSearchAuthorizationsQuery?: GetSocialSearchAuthorizationsQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SocialAuthorizationListGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocialSearchAuthorizations(getSocialSearchAuthorizationsQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSocialSearchAuthorizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSportsLeagues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSportsLeaguesResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSportsLeagues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSportsLeagues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetSportsTeamsRequest} [getSportsTeamsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSportsTeams(getSportsTeamsRequest?: GetSportsTeamsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSportsTeamsResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSportsTeams(getSportsTeamsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSportsTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetStockSymbolsRequest} [getStockSymbolsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockSymbols(getStockSymbolsRequest?: GetStockSymbolsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockSymbolArrayGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockSymbols(getStockSymbolsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStockSymbols']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetSubscribedPackagesQuery} [getSubscribedPackagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscribedPackages(getSubscribedPackagesQuery?: GetSubscribedPackagesQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSubscribedPackagesResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscribedPackages(getSubscribedPackagesQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSubscribedPackages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetSubscriptionPricingQuery} [getSubscriptionPricingQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionPricing(getSubscriptionPricingQuery?: GetSubscriptionPricingQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSubscriptionPricingResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionPricing(getSubscriptionPricingQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSubscriptionPricing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetSubscriptionsQuery} [getSubscriptionsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptions(getSubscriptionsQuery?: GetSubscriptionsQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSubscriptionsResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptions(getSubscriptionsQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimezones(body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IanaTimezoneDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimezones(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTimezones']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrafficRegions(body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrafficRegionsResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrafficRegions(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrafficRegions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetTrafficRoutesQuery} [getTrafficRoutesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrafficRoutes(getTrafficRoutesQuery?: GetTrafficRoutesQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrafficRoutesResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrafficRoutes(getTrafficRoutesQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrafficRoutes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetTrafficSetsQuery} [getTrafficSetsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrafficSets(getTrafficSetsQuery?: GetTrafficSetsQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrafficSetsResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrafficSets(getTrafficSetsQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrafficSets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetTrialHistoryQuery} [getTrialHistoryQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialHistory(getTrialHistoryQuery?: GetTrialHistoryQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialHistoryResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialHistory(getTrialHistoryQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrialHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {HideModerationContentRequest} [hideModerationContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hideModerationContent(hideModerationContentRequest?: HideModerationContentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericApiResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hideModerationContent(hideModerationContentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.hideModerationContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impersonated(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpersonatedDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impersonated(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.impersonated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ModerateContentRequest} [moderateContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moderateContent(moderateContentRequest?: ModerateContentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericApiResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moderateContent(moderateContentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.moderateContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PreviewBillRequest} [previewBillRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewBill(previewBillRequest?: PreviewBillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewBillResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewBill(previewBillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.previewBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PurchaseSubscriptionsCommand} [purchaseSubscriptionsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purchaseSubscriptions(purchaseSubscriptionsCommand?: PurchaseSubscriptionsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseSubscriptions(purchaseSubscriptionsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.purchaseSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReactivateSubscriptionCommand} [reactivateSubscriptionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateSubscription(reactivateSubscriptionCommand?: ReactivateSubscriptionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateSubscription(reactivateSubscriptionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reactivateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RemoveAccountBillingEmailRequest} [removeAccountBillingEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAccountBillingEmail(removeAccountBillingEmailRequest?: RemoveAccountBillingEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAccountBillingEmail(removeAccountBillingEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.removeAccountBillingEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RemoveFeedRequest} [removeFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFeed(removeFeedRequest?: RemoveFeedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFeed(removeFeedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.removeFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateFeedNameCommand} [updateFeedNameCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameFeed(updateFeedNameCommand?: UpdateFeedNameCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameFeed(updateFeedNameCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.renameFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RenameTrafficRegionCommand} [renameTrafficRegionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameTrafficRegion(renameTrafficRegionCommand?: RenameTrafficRegionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficRegionDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameTrafficRegion(renameTrafficRegionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.renameTrafficRegion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendCreateAccountSecurityStampCommand} [sendCreateAccountSecurityStampCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendValidationEmail(sendCreateAccountSecurityStampCommand?: SendCreateAccountSecurityStampCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendValidationEmail(sendCreateAccountSecurityStampCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.resendValidationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendVerifyCode(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendVerifyCodeCommandGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendVerifyCode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendVerifyCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetReferrerRequest} [setReferrerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setReferrer(setReferrerRequest?: SetReferrerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setReferrer(setReferrerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.setReferrer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simulateDownload(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simulateDownload(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.simulateDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeAccountNotifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationPayloadGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeAccountNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.subscribeAccountNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeToTestNotifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationPayloadGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeToTestNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.subscribeToTestNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeUserNotifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationPayloadGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeUserNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.subscribeUserNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TryConnectCommand} [tryConnectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tryConnect(tryConnectCommand?: TryConnectCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TryConnectResultGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tryConnect(tryConnectCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.tryConnect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UnarchiveCustomerRequest} [unarchiveCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unarchiveCustomer(unarchiveCustomerRequest?: UnarchiveCustomerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnarchiveCustomerResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unarchiveCustomer(unarchiveCustomerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.unarchiveCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UnhideModerationContentRequest} [unhideModerationContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unhideModerationContent(unhideModerationContentRequest?: UnhideModerationContentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericApiResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unhideModerationContent(unhideModerationContentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.unhideModerationContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UnmoderateContentRequest} [unmoderateContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unmoderateContent(unmoderateContentRequest?: UnmoderateContentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericApiResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unmoderateContent(unmoderateContentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.unmoderateContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateAccountMetaInfoRequest} [updateAccountMetaInfoRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountMetaInfo(updateAccountMetaInfoRequest?: UpdateAccountMetaInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountMetaInfo(updateAccountMetaInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateAccountMetaInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateBillingAddressRequest} [updateBillingAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBillingAddress(updateBillingAddressRequest?: UpdateBillingAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBillingAddress(updateBillingAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateBillingAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCompanyRequest} [updateCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompany(updateCompanyRequest?: UpdateCompanyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompany(updateCompanyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateConnectionAuthCommand} [updateConnectionAuthCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConnectionAuth(updateConnectionAuthCommand?: UpdateConnectionAuthCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConnectionAuth(updateConnectionAuthCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateConnectionAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateAccountContactCommand} [updateAccountContactCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContact(updateAccountContactCommand?: UpdateAccountContactCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContact(updateAccountContactCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {string} [subdomain] 
         * @param {File} [logoFileData] 
         * @param {string} [bannerColor] 
         * @param {string} [accentColor] 
         * @param {string} [textColor] 
         * @param {string} [backgroundColor] 
         * @param {boolean} [shouldRemoveLogo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContentMenu(accountId?: number, subdomain?: string, logoFileData?: File, bannerColor?: string, accentColor?: string, textColor?: string, backgroundColor?: string, shouldRemoveLogo?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateContentMenuResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContentMenu(accountId, subdomain, logoFileData, bannerColor, accentColor, textColor, backgroundColor, shouldRemoveLogo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateContentMenu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCreditCardRequest} [updateCreditCardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCreditCard(updateCreditCardRequest?: UpdateCreditCardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCreditCard(updateCreditCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCreditCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCustomerRequest} [updateCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomer(updateCustomerRequest?: UpdateCustomerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCustomerResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomer(updateCustomerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateFeedRequest} [updateFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeed(updateFeedRequest?: UpdateFeedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateFeedResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeed(updateFeedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateFeedModerationMethodRequest} [updateFeedModerationMethodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeedModerationMethod(updateFeedModerationMethodRequest?: UpdateFeedModerationMethodRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericApiResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeedModerationMethod(updateFeedModerationMethodRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateFeedModerationMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateInvoicePONumberRequest} [updateInvoicePONumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInvoicePONumber(updateInvoicePONumberRequest?: UpdateInvoicePONumberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInvoicePONumber(updateInvoicePONumberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateInvoicePONumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateLanguageFiltersRequest} [updateLanguageFiltersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLanguageFilters(updateLanguageFiltersRequest?: UpdateLanguageFiltersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateLanguageFiltersResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLanguageFilters(updateLanguageFiltersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateLanguageFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateSamsungVxtFeedRequest} [updateSamsungVxtFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSamsungVxtFeed(updateSamsungVxtFeedRequest?: UpdateSamsungVxtFeedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSamsungVxtFeed(updateSamsungVxtFeedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateSamsungVxtFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateTrafficRouteCommand} [updateTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrafficRoute(updateTrafficRouteCommand?: UpdateTrafficRouteCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficRouteDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrafficRoute(updateTrafficRouteCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateTrafficRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateTrafficSetCommand} [updateTrafficSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrafficSet(updateTrafficSetCommand?: UpdateTrafficSetCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficSetDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrafficSet(updateTrafficSetCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateTrafficSet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateUserFromStoreCommand} [updateUserFromStoreCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(updateUserFromStoreCommand?: UpdateUserFromStoreCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountContactForStoreDtoGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(updateUserFromStoreCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file The logo file to upload
         * @param {string} [originalFileName] Original name of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadLogo(file: File, originalFileName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFeedLogoResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLogo(file, originalFileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ValidateCreateAccountFromAccountCommand} [validateCreateAccountFromAccountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCreateAccountSecurityStamp(validateCreateAccountFromAccountCommand?: ValidateCreateAccountFromAccountCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateCreateAccountResultGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateCreateAccountSecurityStamp(validateCreateAccountFromAccountCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.validateCreateAccountSecurityStamp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [authorization] Optional Bearer token
         * @param {GetValidLocationQuery} [getValidLocationQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateLocation(authorization?: string, getValidLocationQuery?: GetValidLocationQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLocationResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateLocation(authorization, getValidLocationQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.validateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ValidateSubdomainRequest} [validateSubdomainRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSubdomain(validateSubdomainRequest?: ValidateSubdomainRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateSubdomainResponseGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSubdomain(validateSubdomainRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.validateSubdomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyCodeCommand} [verifyCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyCode(verifyCodeCommand?: VerifyCodeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyCodeCommandGenericResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyCode(verifyCodeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.verifyCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminCreateTrafficRouteCommand} [adminCreateTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateTrafficRoute(adminCreateTrafficRouteCommand?: AdminCreateTrafficRouteCommand, options?: RawAxiosRequestConfig): AxiosPromise<TrafficRouteDtoGenericResponse> {
            return localVarFp.adminCreateTrafficRoute(adminCreateTrafficRouteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminDeleteTrafficRouteCommand} [adminDeleteTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteTrafficRoute(adminDeleteTrafficRouteCommand?: AdminDeleteTrafficRouteCommand, options?: RawAxiosRequestConfig): AxiosPromise<DeleteTrafficRouteResponseGenericResponse> {
            return localVarFp.adminDeleteTrafficRoute(adminDeleteTrafficRouteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminUpdateTrafficRouteCommand} [adminUpdateTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateTrafficRoute(adminUpdateTrafficRouteCommand?: AdminUpdateTrafficRouteCommand, options?: RawAxiosRequestConfig): AxiosPromise<TrafficRouteDtoGenericResponse> {
            return localVarFp.adminUpdateTrafficRoute(adminUpdateTrafficRouteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArchiveCustomerRequest} [archiveCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCustomer(archiveCustomerRequest?: ArchiveCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArchiveCustomerResponseGenericResponse> {
            return localVarFp.archiveCustomer(archiveCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArchiveUserCommand} [archiveUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveUser(archiveUserCommand?: ArchiveUserCommand, options?: RawAxiosRequestConfig): AxiosPromise<ArchiveUserCommandGenericResponse> {
            return localVarFp.archiveUser(archiveUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeactivateSubscriptionFromAcctCommand} [deactivateSubscriptionFromAcctCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(deactivateSubscriptionFromAcctCommand?: DeactivateSubscriptionFromAcctCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.cancelSubscription(deactivateSubscriptionFromAcctCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CloneFeedCommand} [cloneFeedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneFeed(cloneFeedCommand?: CloneFeedCommand, options?: RawAxiosRequestConfig): AxiosPromise<CloneFeedCommandResponseGenericResponse> {
            return localVarFp.cloneFeed(cloneFeedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateAccountFromAccountCommand} [createAccountFromAccountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(createAccountFromAccountCommand?: CreateAccountFromAccountCommand, options?: RawAxiosRequestConfig): AxiosPromise<CreateAccountFromAccountResultGenericResponse> {
            return localVarFp.createAccount(createAccountFromAccountCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateAccountBillingEmailRequest} [createAccountBillingEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountBillingEmail(createAccountBillingEmailRequest?: CreateAccountBillingEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountContactGenericResponse> {
            return localVarFp.createAccountBillingEmail(createAccountBillingEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateFeedConnection} [createFeedConnection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnection(createFeedConnection?: CreateFeedConnection, options?: RawAxiosRequestConfig): AxiosPromise<CreateFeedConnectionResponseGenericResponse> {
            return localVarFp.createConnection(createFeedConnection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateChildAccountFromStoreCommand} [createChildAccountFromStoreCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(createChildAccountFromStoreCommand?: CreateChildAccountFromStoreCommand, options?: RawAxiosRequestConfig): AxiosPromise<CreateChildAccountResponseGenericResponse> {
            return localVarFp.createCustomer(createChildAccountFromStoreCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateFeedRequest} [createFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeed(createFeedRequest?: CreateFeedRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFeedResponseGenericResponse> {
            return localVarFp.createFeed(createFeedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateProviderAuthMagicLinkCommand} [createProviderAuthMagicLinkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderAuthMagicLink(createProviderAuthMagicLinkCommand?: CreateProviderAuthMagicLinkCommand, options?: RawAxiosRequestConfig): AxiosPromise<CreateProviderAuthMagicLinkResultGenericResponse> {
            return localVarFp.createProviderAuthMagicLink(createProviderAuthMagicLinkCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSocialSearchCommand} [createSocialSearchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSocialSearch(createSocialSearchCommand?: CreateSocialSearchCommand, options?: RawAxiosRequestConfig): AxiosPromise<SocialAuthorizationGenericResponse> {
            return localVarFp.createSocialSearch(createSocialSearchCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTrafficRegionCommand} [createTrafficRegionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrafficRegion(createTrafficRegionCommand?: CreateTrafficRegionCommand, options?: RawAxiosRequestConfig): AxiosPromise<TrafficRegionDtoGenericResponse> {
            return localVarFp.createTrafficRegion(createTrafficRegionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTrafficRouteCommand} [createTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrafficRoute(createTrafficRouteCommand?: CreateTrafficRouteCommand, options?: RawAxiosRequestConfig): AxiosPromise<TrafficRouteDtoGenericResponse> {
            return localVarFp.createTrafficRoute(createTrafficRouteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTrafficSetCommand} [createTrafficSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrafficSet(createTrafficSetCommand?: CreateTrafficSetCommand, options?: RawAxiosRequestConfig): AxiosPromise<TrafficSetDtoGenericResponse> {
            return localVarFp.createTrafficSet(createTrafficSetCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTrialSubscriptionFromAcctCommand} [createTrialSubscriptionFromAcctCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrialSubscription(createTrialSubscriptionFromAcctCommand?: CreateTrialSubscriptionFromAcctCommand, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionDtoGenericResponse> {
            return localVarFp.createTrialSubscription(createTrialSubscriptionFromAcctCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUserFromStoreCommand} [createUserFromStoreCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(createUserFromStoreCommand?: CreateUserFromStoreCommand, options?: RawAxiosRequestConfig): AxiosPromise<AccountContactForStoreDtoGenericResponse> {
            return localVarFp.createUser(createUserFromStoreCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUserMagicInviteLinkCommand} [createUserMagicInviteLinkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserMagicInviteLink(createUserMagicInviteLinkCommand?: CreateUserMagicInviteLinkCommand, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserMagicLinkInviteResultGenericResponse> {
            return localVarFp.createUserMagicInviteLink(createUserMagicInviteLinkCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteProviderAuthCommand} [deleteProviderAuthCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderAuth(deleteProviderAuthCommand?: DeleteProviderAuthCommand, options?: RawAxiosRequestConfig): AxiosPromise<DeleteProviderAuthCommandGenericResponse> {
            return localVarFp.deleteProviderAuth(deleteProviderAuthCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteTrafficRegionCommand} [deleteTrafficRegionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrafficRegion(deleteTrafficRegionCommand?: DeleteTrafficRegionCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.deleteTrafficRegion(deleteTrafficRegionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteTrafficRouteCommand} [deleteTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrafficRoute(deleteTrafficRouteCommand?: DeleteTrafficRouteCommand, options?: RawAxiosRequestConfig): AxiosPromise<DeleteTrafficRouteResponseGenericResponse> {
            return localVarFp.deleteTrafficRoute(deleteTrafficRouteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteTrafficSetCommand} [deleteTrafficSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrafficSet(deleteTrafficSetCommand?: DeleteTrafficSetCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.deleteTrafficSet(deleteTrafficSetCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExchangeCodeCommand} [exchangeCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeEmaiValidationlCode(exchangeCodeCommand?: ExchangeCodeCommand, options?: RawAxiosRequestConfig): AxiosPromise<ExchangeCodeResultGenericResponse> {
            return localVarFp.exchangeEmaiValidationlCode(exchangeCodeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendResetPasswordByEmailCommand} [sendResetPasswordByEmailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(sendResetPasswordByEmailCommand?: SendResetPasswordByEmailCommand, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserMagicLinkInviteResultGenericResponse> {
            return localVarFp.forgotPassword(sendResetPasswordByEmailCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAccountRequest} [getAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(getAccountRequest?: GetAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAccountResponseGenericResponse> {
            return localVarFp.getAccount(getAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAccountContactsForStoreQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountContact(query?: GetAccountContactsForStoreQuery, options?: RawAxiosRequestConfig): AxiosPromise<AccountContactForStoreDtoGenericResponse> {
            return localVarFp.getAccountContact(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAccountContactsForStoreQuery} [getAccountContactsForStoreQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountContacts(getAccountContactsForStoreQuery?: GetAccountContactsForStoreQuery, options?: RawAxiosRequestConfig): AxiosPromise<AccountContactForStoreDtoArrayGenericResponse> {
            return localVarFp.getAccountContacts(getAccountContactsForStoreQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPackageFeeds} [getPackageFeeds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPackageFeeds(getPackageFeeds?: GetPackageFeeds, options?: RawAxiosRequestConfig): AxiosPromise<PackageFeedArrayGenericResponse> {
            return localVarFp.getAccountPackageFeeds(getPackageFeeds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAirportAutocompleteRequest} [getAirportAutocompleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAirportAutocomplete(getAirportAutocompleteRequest?: GetAirportAutocompleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AirportInfoArrayGenericResponse> {
            return localVarFp.getAirportAutocomplete(getAirportAutocompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAuthModelRequest} [getAuthModelRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthClientModel(getAuthModelRequest?: GetAuthModelRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAuthModelResponseGenericResponse> {
            return localVarFp.getAuthClientModel(getAuthModelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAuthedUsersRequest} [getAuthedUsersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthedUsersForProvider(getAuthedUsersRequest?: GetAuthedUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizationIEnumerableGenericResponse> {
            return localVarFp.getAuthedUsersForProvider(getAuthedUsersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [providerId] 
         * @param {number} [accountId] 
         * @param {string} [clientUrl] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizationModel(providerId?: number, accountId?: number, clientUrl?: string, version?: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuthModelDtoGenericResponse> {
            return localVarFp.getAuthorizationModel(providerId, accountId, clientUrl, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAuthorizedCurrenciesRequest} [getAuthorizedCurrenciesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedCurrencies(getAuthorizedCurrenciesRequest?: GetAuthorizedCurrenciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAuthorizedCurrenciesResponseGenericResponse> {
            return localVarFp.getAuthorizedCurrencies(getAuthorizedCurrenciesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetBillDetailRequest} [getBillDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDetail(getBillDetailRequest?: GetBillDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillDetailResponseGenericResponse> {
            return localVarFp.getBillDetail(getBillDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetBillsRequest} [getBillsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBills(getBillsRequest?: GetBillsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillsResponseGenericResponse> {
            return localVarFp.getBills(getBillsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionInfo(connectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConnectionContextGenericResponse> {
            return localVarFp.getConnectionInfo(connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionMetrics(options?: RawAxiosRequestConfig): AxiosPromise<ConnectionMetricsGenericResponse> {
            return localVarFp.getConnectionMetrics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetConnectionProvidersBySlugQuery} [getConnectionProvidersBySlugQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionProvidersBySlug(getConnectionProvidersBySlugQuery?: GetConnectionProvidersBySlugQuery, options?: RawAxiosRequestConfig): AxiosPromise<ConnectionProviderArrayGenericResponse> {
            return localVarFp.getConnectionProvidersBySlug(getConnectionProvidersBySlugQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetFeedDataConnectionsQuery} [getFeedDataConnectionsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnections(getFeedDataConnectionsQuery?: GetFeedDataConnectionsQuery, options?: RawAxiosRequestConfig): AxiosPromise<GetFeedConnectionsResponseGenericResponse> {
            return localVarFp.getConnections(getFeedDataConnectionsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetFeedDataConnectionsByProviderQuery} [getFeedDataConnectionsByProviderQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionsByProvider(getFeedDataConnectionsByProviderQuery?: GetFeedDataConnectionsByProviderQuery, options?: RawAxiosRequestConfig): AxiosPromise<GetFeedConnectionsResponseGenericResponse> {
            return localVarFp.getConnectionsByProvider(getFeedDataConnectionsByProviderQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [authorization] Optional Bearer token
         * @param {GetContentMenuQuery} [getContentMenuQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentMenu(authorization?: string, getContentMenuQuery?: GetContentMenuQuery, options?: RawAxiosRequestConfig): AxiosPromise<PackageInfoArrayGenericResponse> {
            return localVarFp.getContentMenu(authorization, getContentMenuQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyCountry(body?: object, options?: RawAxiosRequestConfig): AxiosPromise<GetCurrencyCountryResponseGenericResponse> {
            return localVarFp.getCurrencyCountry(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetCustomersRequest} [getCustomersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(getCustomersRequest?: GetCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCustomersResponseGenericResponse> {
            return localVarFp.getCustomers(getCustomersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetExpiringTrialsQuery} [getExpiringTrialsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiringTrials(getExpiringTrialsQuery?: GetExpiringTrialsQuery, options?: RawAxiosRequestConfig): AxiosPromise<ExpiringTrialsResponseGenericResponse> {
            return localVarFp.getExpiringTrials(getExpiringTrialsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetFeedConfigRequest} [getFeedConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedConfig(getFeedConfigRequest?: GetFeedConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFeedConfigResponseGenericResponse> {
            return localVarFp.getFeedConfig(getFeedConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [authorization] Optional Bearer token
         * @param {GetFeedCreationRequest} [getFeedCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedCreation(authorization?: string, getFeedCreationRequest?: GetFeedCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFeedCreationResponseGenericResponse> {
            return localVarFp.getFeedCreation(authorization, getFeedCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetFeedModerationMethodRequest} [getFeedModerationMethodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedModerationMethod(getFeedModerationMethodRequest?: GetFeedModerationMethodRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFeedModerationMethodResponseGenericResponse> {
            return localVarFp.getFeedModerationMethod(getFeedModerationMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetFeedsQuery} [getFeedsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeds(getFeedsQuery?: GetFeedsQuery, options?: RawAxiosRequestConfig): AxiosPromise<FeedInfoArrayGenericResponse> {
            return localVarFp.getFeeds(getFeedsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetCalendarsCommand} [getCalendarsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleCalendars(getCalendarsCommand?: GetCalendarsCommand, options?: RawAxiosRequestConfig): AxiosPromise<CalendarListDtoGenericResponse> {
            return localVarFp.getGoogleCalendars(getCalendarsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetLanguageFiltersRequest} [getLanguageFiltersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguageFilters(getLanguageFiltersRequest?: GetLanguageFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetLanguageFiltersResponseGenericResponse> {
            return localVarFp.getLanguageFilters(getLanguageFiltersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocalFavoritesCategories(options?: RawAxiosRequestConfig): AxiosPromise<CategoryItemArrayGenericResponse> {
            return localVarFp.getLocalFavoritesCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetMicrosoftCalendarsCommand} [getMicrosoftCalendarsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMicrosoftCalendars(getMicrosoftCalendarsCommand?: GetMicrosoftCalendarsCommand, options?: RawAxiosRequestConfig): AxiosPromise<CalendarListDtoGenericResponse> {
            return localVarFp.getMicrosoftCalendars(getMicrosoftCalendarsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetMindBodySitesCommand} [getMindBodySitesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMindBodySites(getMindBodySitesCommand?: GetMindBodySitesCommand, options?: RawAxiosRequestConfig): AxiosPromise<MindBodySiteArrayGenericResponse> {
            return localVarFp.getMindBodySites(getMindBodySitesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetModerationContentRequest} [getModerationContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerationContent(getModerationContentRequest?: GetModerationContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetModerationContentResponseGenericResponse> {
            return localVarFp.getModerationContent(getModerationContentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetMomentusRoomsCommand} [getMomentusRoomsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMomentusRooms(getMomentusRoomsCommand?: GetMomentusRoomsCommand, options?: RawAxiosRequestConfig): AxiosPromise<RoomArrayGenericResponse> {
            return localVarFp.getMomentusRooms(getMomentusRoomsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetMomentusVenusCommand} [getMomentusVenusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMomentusVenues(getMomentusVenusCommand?: GetMomentusVenusCommand, options?: RawAxiosRequestConfig): AxiosPromise<VenueArrayGenericResponse> {
            return localVarFp.getMomentusVenues(getMomentusVenusCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetOffMenuAccountPackagesQuery} [getOffMenuAccountPackagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffMenuAccountPackages(getOffMenuAccountPackagesQuery?: GetOffMenuAccountPackagesQuery, options?: RawAxiosRequestConfig): AxiosPromise<PackageInfoArrayGenericResponse> {
            return localVarFp.getOffMenuAccountPackages(getOffMenuAccountPackagesQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetOneTimeProviderAuthsRequestQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneTimeAuthRequests(query?: GetOneTimeProviderAuthsRequestQuery, options?: RawAxiosRequestConfig): AxiosPromise<GetOneTimeProviderAuthsRequestDtoArrayGenericResponse> {
            return localVarFp.getOneTimeAuthRequests(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPackagesQuery} [getPackagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackagesByIds(getPackagesQuery?: GetPackagesQuery, options?: RawAxiosRequestConfig): AxiosPromise<PackageInfoArrayGenericResponse> {
            return localVarFp.getPackagesByIds(getPackagesQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerAuthenticationSecret(body?: object, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getPlayerAuthenticationSecret(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPowerBIDashboardsRequest} [getPowerBIDashboardsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerBIDashboards(getPowerBIDashboardsRequest?: GetPowerBIDashboardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmbedObjectDtoIEnumerableGenericResponse> {
            return localVarFp.getPowerBIDashboards(getPowerBIDashboardsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPowerBIReportsRequest} [getPowerBIReportsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerBIReports(getPowerBIReportsRequest?: GetPowerBIReportsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmbedObjectDtoIEnumerableGenericResponse> {
            return localVarFp.getPowerBIReports(getPowerBIReportsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPowerBITilesRequest} [getPowerBITilesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerBITiles(getPowerBITilesRequest?: GetPowerBITilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmbedObjectDtoIEnumerableGenericResponse> {
            return localVarFp.getPowerBITiles(getPowerBITilesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPowerBIWorkspacesRequest} [getPowerBIWorkspacesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPowerBIWorkspaces(getPowerBIWorkspacesRequest?: GetPowerBIWorkspacesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkspaceDtoIEnumerableGenericResponse> {
            return localVarFp.getPowerBIWorkspaces(getPowerBIWorkspacesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAccountPrimaryContactQuery} [getAccountPrimaryContactQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryContact(getAccountPrimaryContactQuery?: GetAccountPrimaryContactQuery, options?: RawAxiosRequestConfig): AxiosPromise<AccountContactForStoreDtoGenericResponse> {
            return localVarFp.getPrimaryContact(getAccountPrimaryContactQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetProratedTotalQuery} [getProratedTotalQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProratedTotal(getProratedTotalQuery?: GetProratedTotalQuery, options?: RawAxiosRequestConfig): AxiosPromise<GetProratedTotalResponseGenericResponse> {
            return localVarFp.getProratedTotal(getProratedTotalQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetProviderAuthSidedoorCommand} [getProviderAuthSidedoorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAuthSidedoor(getProviderAuthSidedoorCommand?: GetProviderAuthSidedoorCommand, options?: RawAxiosRequestConfig): AxiosPromise<GetProviderAuthSidedoorResponseGenericResponse> {
            return localVarFp.getProviderAuthSidedoor(getProviderAuthSidedoorCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetProviderAuthsQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAuths(query?: GetProviderAuthsQuery, options?: RawAxiosRequestConfig): AxiosPromise<ProviderAuthDtoArrayGenericResponse> {
            return localVarFp.getProviderAuths(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetProvidersQuery} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders(query?: GetProvidersQuery, options?: RawAxiosRequestConfig): AxiosPromise<GetProviderDtoArrayGenericResponse> {
            return localVarFp.getProviders(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSamsungVxtFeedRequest} [getSamsungVxtFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamsungVxtFeed(getSamsungVxtFeedRequest?: GetSamsungVxtFeedRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSamsungVxtFeedResponseGenericResponse> {
            return localVarFp.getSamsungVxtFeed(getSamsungVxtFeedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSocialSearchAuthorizationsQuery} [getSocialSearchAuthorizationsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialSearchAuthorizations(getSocialSearchAuthorizationsQuery?: GetSocialSearchAuthorizationsQuery, options?: RawAxiosRequestConfig): AxiosPromise<SocialAuthorizationListGenericResponse> {
            return localVarFp.getSocialSearchAuthorizations(getSocialSearchAuthorizationsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSportsLeagues(options?: RawAxiosRequestConfig): AxiosPromise<GetSportsLeaguesResponseGenericResponse> {
            return localVarFp.getSportsLeagues(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSportsTeamsRequest} [getSportsTeamsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSportsTeams(getSportsTeamsRequest?: GetSportsTeamsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSportsTeamsResponseGenericResponse> {
            return localVarFp.getSportsTeams(getSportsTeamsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetStockSymbolsRequest} [getStockSymbolsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockSymbols(getStockSymbolsRequest?: GetStockSymbolsRequest, options?: RawAxiosRequestConfig): AxiosPromise<StockSymbolArrayGenericResponse> {
            return localVarFp.getStockSymbols(getStockSymbolsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSubscribedPackagesQuery} [getSubscribedPackagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscribedPackages(getSubscribedPackagesQuery?: GetSubscribedPackagesQuery, options?: RawAxiosRequestConfig): AxiosPromise<GetSubscribedPackagesResponseGenericResponse> {
            return localVarFp.getSubscribedPackages(getSubscribedPackagesQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSubscriptionPricingQuery} [getSubscriptionPricingQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPricing(getSubscriptionPricingQuery?: GetSubscriptionPricingQuery, options?: RawAxiosRequestConfig): AxiosPromise<GetSubscriptionPricingResponseGenericResponse> {
            return localVarFp.getSubscriptionPricing(getSubscriptionPricingQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSubscriptionsQuery} [getSubscriptionsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions(getSubscriptionsQuery?: GetSubscriptionsQuery, options?: RawAxiosRequestConfig): AxiosPromise<GetSubscriptionsResponseGenericResponse> {
            return localVarFp.getSubscriptions(getSubscriptionsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimezones(body?: object, options?: RawAxiosRequestConfig): AxiosPromise<IanaTimezoneDtoGenericResponse> {
            return localVarFp.getTimezones(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrafficRegions(body?: object, options?: RawAxiosRequestConfig): AxiosPromise<GetTrafficRegionsResponseGenericResponse> {
            return localVarFp.getTrafficRegions(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetTrafficRoutesQuery} [getTrafficRoutesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrafficRoutes(getTrafficRoutesQuery?: GetTrafficRoutesQuery, options?: RawAxiosRequestConfig): AxiosPromise<GetTrafficRoutesResponseGenericResponse> {
            return localVarFp.getTrafficRoutes(getTrafficRoutesQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetTrafficSetsQuery} [getTrafficSetsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrafficSets(getTrafficSetsQuery?: GetTrafficSetsQuery, options?: RawAxiosRequestConfig): AxiosPromise<GetTrafficSetsResponseGenericResponse> {
            return localVarFp.getTrafficSets(getTrafficSetsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetTrialHistoryQuery} [getTrialHistoryQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialHistory(getTrialHistoryQuery?: GetTrialHistoryQuery, options?: RawAxiosRequestConfig): AxiosPromise<TrialHistoryResponseGenericResponse> {
            return localVarFp.getTrialHistory(getTrialHistoryQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HideModerationContentRequest} [hideModerationContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideModerationContent(hideModerationContentRequest?: HideModerationContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericApiResponseBase> {
            return localVarFp.hideModerationContent(hideModerationContentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonated(options?: RawAxiosRequestConfig): AxiosPromise<ImpersonatedDtoGenericResponse> {
            return localVarFp.impersonated(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ModerateContentRequest} [moderateContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moderateContent(moderateContentRequest?: ModerateContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericApiResponseBase> {
            return localVarFp.moderateContent(moderateContentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PreviewBillRequest} [previewBillRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewBill(previewBillRequest?: PreviewBillRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewBillResponseGenericResponse> {
            return localVarFp.previewBill(previewBillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PurchaseSubscriptionsCommand} [purchaseSubscriptionsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseSubscriptions(purchaseSubscriptionsCommand?: PurchaseSubscriptionsCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.purchaseSubscriptions(purchaseSubscriptionsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReactivateSubscriptionCommand} [reactivateSubscriptionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateSubscription(reactivateSubscriptionCommand?: ReactivateSubscriptionCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.reactivateSubscription(reactivateSubscriptionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemoveAccountBillingEmailRequest} [removeAccountBillingEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAccountBillingEmail(removeAccountBillingEmailRequest?: RemoveAccountBillingEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.removeAccountBillingEmail(removeAccountBillingEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemoveFeedRequest} [removeFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFeed(removeFeedRequest?: RemoveFeedRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.removeFeed(removeFeedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateFeedNameCommand} [updateFeedNameCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFeed(updateFeedNameCommand?: UpdateFeedNameCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.renameFeed(updateFeedNameCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RenameTrafficRegionCommand} [renameTrafficRegionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameTrafficRegion(renameTrafficRegionCommand?: RenameTrafficRegionCommand, options?: RawAxiosRequestConfig): AxiosPromise<TrafficRegionDtoGenericResponse> {
            return localVarFp.renameTrafficRegion(renameTrafficRegionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendCreateAccountSecurityStampCommand} [sendCreateAccountSecurityStampCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendValidationEmail(sendCreateAccountSecurityStampCommand?: SendCreateAccountSecurityStampCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.resendValidationEmail(sendCreateAccountSecurityStampCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerifyCode(options?: RawAxiosRequestConfig): AxiosPromise<SendVerifyCodeCommandGenericResponse> {
            return localVarFp.sendVerifyCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetReferrerRequest} [setReferrerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setReferrer(setReferrerRequest?: SetReferrerRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.setReferrer(setReferrerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateDownload(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.simulateDownload(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeAccountNotifications(options?: RawAxiosRequestConfig): AxiosPromise<NotificationPayloadGenericResponse> {
            return localVarFp.subscribeAccountNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToTestNotifications(options?: RawAxiosRequestConfig): AxiosPromise<NotificationPayloadGenericResponse> {
            return localVarFp.subscribeToTestNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeUserNotifications(options?: RawAxiosRequestConfig): AxiosPromise<NotificationPayloadGenericResponse> {
            return localVarFp.subscribeUserNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TryConnectCommand} [tryConnectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tryConnect(tryConnectCommand?: TryConnectCommand, options?: RawAxiosRequestConfig): AxiosPromise<TryConnectResultGenericResponse> {
            return localVarFp.tryConnect(tryConnectCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnarchiveCustomerRequest} [unarchiveCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveCustomer(unarchiveCustomerRequest?: UnarchiveCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnarchiveCustomerResponseGenericResponse> {
            return localVarFp.unarchiveCustomer(unarchiveCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnhideModerationContentRequest} [unhideModerationContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unhideModerationContent(unhideModerationContentRequest?: UnhideModerationContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericApiResponseBase> {
            return localVarFp.unhideModerationContent(unhideModerationContentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnmoderateContentRequest} [unmoderateContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmoderateContent(unmoderateContentRequest?: UnmoderateContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericApiResponseBase> {
            return localVarFp.unmoderateContent(unmoderateContentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAccountMetaInfoRequest} [updateAccountMetaInfoRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountMetaInfo(updateAccountMetaInfoRequest?: UpdateAccountMetaInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.updateAccountMetaInfo(updateAccountMetaInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateBillingAddressRequest} [updateBillingAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingAddress(updateBillingAddressRequest?: UpdateBillingAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.updateBillingAddress(updateBillingAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCompanyRequest} [updateCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(updateCompanyRequest?: UpdateCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.updateCompany(updateCompanyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateConnectionAuthCommand} [updateConnectionAuthCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConnectionAuth(updateConnectionAuthCommand?: UpdateConnectionAuthCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.updateConnectionAuth(updateConnectionAuthCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAccountContactCommand} [updateAccountContactCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact(updateAccountContactCommand?: UpdateAccountContactCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.updateContact(updateAccountContactCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {string} [subdomain] 
         * @param {File} [logoFileData] 
         * @param {string} [bannerColor] 
         * @param {string} [accentColor] 
         * @param {string} [textColor] 
         * @param {string} [backgroundColor] 
         * @param {boolean} [shouldRemoveLogo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContentMenu(accountId?: number, subdomain?: string, logoFileData?: File, bannerColor?: string, accentColor?: string, textColor?: string, backgroundColor?: string, shouldRemoveLogo?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<UpdateContentMenuResponseGenericResponse> {
            return localVarFp.updateContentMenu(accountId, subdomain, logoFileData, bannerColor, accentColor, textColor, backgroundColor, shouldRemoveLogo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCreditCardRequest} [updateCreditCardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCreditCard(updateCreditCardRequest?: UpdateCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.updateCreditCard(updateCreditCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCustomerRequest} [updateCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(updateCustomerRequest?: UpdateCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCustomerResponseGenericResponse> {
            return localVarFp.updateCustomer(updateCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateFeedRequest} [updateFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeed(updateFeedRequest?: UpdateFeedRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateFeedResponseGenericResponse> {
            return localVarFp.updateFeed(updateFeedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateFeedModerationMethodRequest} [updateFeedModerationMethodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeedModerationMethod(updateFeedModerationMethodRequest?: UpdateFeedModerationMethodRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericApiResponseBase> {
            return localVarFp.updateFeedModerationMethod(updateFeedModerationMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateInvoicePONumberRequest} [updateInvoicePONumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoicePONumber(updateInvoicePONumberRequest?: UpdateInvoicePONumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.updateInvoicePONumber(updateInvoicePONumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateLanguageFiltersRequest} [updateLanguageFiltersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLanguageFilters(updateLanguageFiltersRequest?: UpdateLanguageFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateLanguageFiltersResponseGenericResponse> {
            return localVarFp.updateLanguageFilters(updateLanguageFiltersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSamsungVxtFeedRequest} [updateSamsungVxtFeedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSamsungVxtFeed(updateSamsungVxtFeedRequest?: UpdateSamsungVxtFeedRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptyResponseGenericResponse> {
            return localVarFp.updateSamsungVxtFeed(updateSamsungVxtFeedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateTrafficRouteCommand} [updateTrafficRouteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrafficRoute(updateTrafficRouteCommand?: UpdateTrafficRouteCommand, options?: RawAxiosRequestConfig): AxiosPromise<TrafficRouteDtoGenericResponse> {
            return localVarFp.updateTrafficRoute(updateTrafficRouteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateTrafficSetCommand} [updateTrafficSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrafficSet(updateTrafficSetCommand?: UpdateTrafficSetCommand, options?: RawAxiosRequestConfig): AxiosPromise<TrafficSetDtoGenericResponse> {
            return localVarFp.updateTrafficSet(updateTrafficSetCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateUserFromStoreCommand} [updateUserFromStoreCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(updateUserFromStoreCommand?: UpdateUserFromStoreCommand, options?: RawAxiosRequestConfig): AxiosPromise<AccountContactForStoreDtoGenericResponse> {
            return localVarFp.updateUser(updateUserFromStoreCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} file The logo file to upload
         * @param {string} [originalFileName] Original name of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo(file: File, originalFileName?: string, options?: RawAxiosRequestConfig): AxiosPromise<UploadFeedLogoResponseGenericResponse> {
            return localVarFp.uploadLogo(file, originalFileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ValidateCreateAccountFromAccountCommand} [validateCreateAccountFromAccountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateAccountSecurityStamp(validateCreateAccountFromAccountCommand?: ValidateCreateAccountFromAccountCommand, options?: RawAxiosRequestConfig): AxiosPromise<ValidateCreateAccountResultGenericResponse> {
            return localVarFp.validateCreateAccountSecurityStamp(validateCreateAccountFromAccountCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [authorization] Optional Bearer token
         * @param {GetValidLocationQuery} [getValidLocationQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLocation(authorization?: string, getValidLocationQuery?: GetValidLocationQuery, options?: RawAxiosRequestConfig): AxiosPromise<ValidateLocationResponseGenericResponse> {
            return localVarFp.validateLocation(authorization, getValidLocationQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ValidateSubdomainRequest} [validateSubdomainRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSubdomain(validateSubdomainRequest?: ValidateSubdomainRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateSubdomainResponseGenericResponse> {
            return localVarFp.validateSubdomain(validateSubdomainRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyCodeCommand} [verifyCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCode(verifyCodeCommand?: VerifyCodeCommand, options?: RawAxiosRequestConfig): AxiosPromise<VerifyCodeCommandGenericResponse> {
            return localVarFp.verifyCode(verifyCodeCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {AdminCreateTrafficRouteCommand} [adminCreateTrafficRouteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminCreateTrafficRoute(adminCreateTrafficRouteCommand?: AdminCreateTrafficRouteCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminCreateTrafficRoute(adminCreateTrafficRouteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminDeleteTrafficRouteCommand} [adminDeleteTrafficRouteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminDeleteTrafficRoute(adminDeleteTrafficRouteCommand?: AdminDeleteTrafficRouteCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminDeleteTrafficRoute(adminDeleteTrafficRouteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminUpdateTrafficRouteCommand} [adminUpdateTrafficRouteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminUpdateTrafficRoute(adminUpdateTrafficRouteCommand?: AdminUpdateTrafficRouteCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminUpdateTrafficRoute(adminUpdateTrafficRouteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArchiveCustomerRequest} [archiveCustomerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public archiveCustomer(archiveCustomerRequest?: ArchiveCustomerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).archiveCustomer(archiveCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArchiveUserCommand} [archiveUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public archiveUser(archiveUserCommand?: ArchiveUserCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).archiveUser(archiveUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeactivateSubscriptionFromAcctCommand} [deactivateSubscriptionFromAcctCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cancelSubscription(deactivateSubscriptionFromAcctCommand?: DeactivateSubscriptionFromAcctCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cancelSubscription(deactivateSubscriptionFromAcctCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CloneFeedCommand} [cloneFeedCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cloneFeed(cloneFeedCommand?: CloneFeedCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cloneFeed(cloneFeedCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateAccountFromAccountCommand} [createAccountFromAccountCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createAccount(createAccountFromAccountCommand?: CreateAccountFromAccountCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createAccount(createAccountFromAccountCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateAccountBillingEmailRequest} [createAccountBillingEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createAccountBillingEmail(createAccountBillingEmailRequest?: CreateAccountBillingEmailRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createAccountBillingEmail(createAccountBillingEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateFeedConnection} [createFeedConnection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createConnection(createFeedConnection?: CreateFeedConnection, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createConnection(createFeedConnection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateChildAccountFromStoreCommand} [createChildAccountFromStoreCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createCustomer(createChildAccountFromStoreCommand?: CreateChildAccountFromStoreCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createCustomer(createChildAccountFromStoreCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateFeedRequest} [createFeedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createFeed(createFeedRequest?: CreateFeedRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createFeed(createFeedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateProviderAuthMagicLinkCommand} [createProviderAuthMagicLinkCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createProviderAuthMagicLink(createProviderAuthMagicLinkCommand?: CreateProviderAuthMagicLinkCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createProviderAuthMagicLink(createProviderAuthMagicLinkCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSocialSearchCommand} [createSocialSearchCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSocialSearch(createSocialSearchCommand?: CreateSocialSearchCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSocialSearch(createSocialSearchCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTrafficRegionCommand} [createTrafficRegionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTrafficRegion(createTrafficRegionCommand?: CreateTrafficRegionCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createTrafficRegion(createTrafficRegionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTrafficRouteCommand} [createTrafficRouteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTrafficRoute(createTrafficRouteCommand?: CreateTrafficRouteCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createTrafficRoute(createTrafficRouteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTrafficSetCommand} [createTrafficSetCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTrafficSet(createTrafficSetCommand?: CreateTrafficSetCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createTrafficSet(createTrafficSetCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTrialSubscriptionFromAcctCommand} [createTrialSubscriptionFromAcctCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTrialSubscription(createTrialSubscriptionFromAcctCommand?: CreateTrialSubscriptionFromAcctCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createTrialSubscription(createTrialSubscriptionFromAcctCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateUserFromStoreCommand} [createUserFromStoreCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createUser(createUserFromStoreCommand?: CreateUserFromStoreCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createUser(createUserFromStoreCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateUserMagicInviteLinkCommand} [createUserMagicInviteLinkCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createUserMagicInviteLink(createUserMagicInviteLinkCommand?: CreateUserMagicInviteLinkCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createUserMagicInviteLink(createUserMagicInviteLinkCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteProviderAuthCommand} [deleteProviderAuthCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteProviderAuth(deleteProviderAuthCommand?: DeleteProviderAuthCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteProviderAuth(deleteProviderAuthCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteTrafficRegionCommand} [deleteTrafficRegionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteTrafficRegion(deleteTrafficRegionCommand?: DeleteTrafficRegionCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteTrafficRegion(deleteTrafficRegionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteTrafficRouteCommand} [deleteTrafficRouteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteTrafficRoute(deleteTrafficRouteCommand?: DeleteTrafficRouteCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteTrafficRoute(deleteTrafficRouteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteTrafficSetCommand} [deleteTrafficSetCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteTrafficSet(deleteTrafficSetCommand?: DeleteTrafficSetCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteTrafficSet(deleteTrafficSetCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExchangeCodeCommand} [exchangeCodeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exchangeEmaiValidationlCode(exchangeCodeCommand?: ExchangeCodeCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exchangeEmaiValidationlCode(exchangeCodeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendResetPasswordByEmailCommand} [sendResetPasswordByEmailCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public forgotPassword(sendResetPasswordByEmailCommand?: SendResetPasswordByEmailCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).forgotPassword(sendResetPasswordByEmailCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAccountRequest} [getAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccount(getAccountRequest?: GetAccountRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccount(getAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAccountContactsForStoreQuery} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountContact(query?: GetAccountContactsForStoreQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountContact(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAccountContactsForStoreQuery} [getAccountContactsForStoreQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountContacts(getAccountContactsForStoreQuery?: GetAccountContactsForStoreQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountContacts(getAccountContactsForStoreQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPackageFeeds} [getPackageFeeds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountPackageFeeds(getPackageFeeds?: GetPackageFeeds, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountPackageFeeds(getPackageFeeds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAirportAutocompleteRequest} [getAirportAutocompleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAirportAutocomplete(getAirportAutocompleteRequest?: GetAirportAutocompleteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAirportAutocomplete(getAirportAutocompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAuthModelRequest} [getAuthModelRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAuthClientModel(getAuthModelRequest?: GetAuthModelRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAuthClientModel(getAuthModelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAuthedUsersRequest} [getAuthedUsersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAuthedUsersForProvider(getAuthedUsersRequest?: GetAuthedUsersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAuthedUsersForProvider(getAuthedUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [providerId] 
     * @param {number} [accountId] 
     * @param {string} [clientUrl] 
     * @param {string} [version] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAuthorizationModel(providerId?: number, accountId?: number, clientUrl?: string, version?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAuthorizationModel(providerId, accountId, clientUrl, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAuthorizedCurrenciesRequest} [getAuthorizedCurrenciesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAuthorizedCurrencies(getAuthorizedCurrenciesRequest?: GetAuthorizedCurrenciesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAuthorizedCurrencies(getAuthorizedCurrenciesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetBillDetailRequest} [getBillDetailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillDetail(getBillDetailRequest?: GetBillDetailRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillDetail(getBillDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetBillsRequest} [getBillsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBills(getBillsRequest?: GetBillsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBills(getBillsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getConnectionInfo(connectionId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConnectionInfo(connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getConnectionMetrics(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConnectionMetrics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetConnectionProvidersBySlugQuery} [getConnectionProvidersBySlugQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getConnectionProvidersBySlug(getConnectionProvidersBySlugQuery?: GetConnectionProvidersBySlugQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConnectionProvidersBySlug(getConnectionProvidersBySlugQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetFeedDataConnectionsQuery} [getFeedDataConnectionsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getConnections(getFeedDataConnectionsQuery?: GetFeedDataConnectionsQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConnections(getFeedDataConnectionsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetFeedDataConnectionsByProviderQuery} [getFeedDataConnectionsByProviderQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getConnectionsByProvider(getFeedDataConnectionsByProviderQuery?: GetFeedDataConnectionsByProviderQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConnectionsByProvider(getFeedDataConnectionsByProviderQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [authorization] Optional Bearer token
     * @param {GetContentMenuQuery} [getContentMenuQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getContentMenu(authorization?: string, getContentMenuQuery?: GetContentMenuQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getContentMenu(authorization, getContentMenuQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCurrencyCountry(body?: object, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCurrencyCountry(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetCustomersRequest} [getCustomersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCustomers(getCustomersRequest?: GetCustomersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCustomers(getCustomersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetExpiringTrialsQuery} [getExpiringTrialsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getExpiringTrials(getExpiringTrialsQuery?: GetExpiringTrialsQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getExpiringTrials(getExpiringTrialsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetFeedConfigRequest} [getFeedConfigRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFeedConfig(getFeedConfigRequest?: GetFeedConfigRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFeedConfig(getFeedConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [authorization] Optional Bearer token
     * @param {GetFeedCreationRequest} [getFeedCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFeedCreation(authorization?: string, getFeedCreationRequest?: GetFeedCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFeedCreation(authorization, getFeedCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetFeedModerationMethodRequest} [getFeedModerationMethodRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFeedModerationMethod(getFeedModerationMethodRequest?: GetFeedModerationMethodRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFeedModerationMethod(getFeedModerationMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetFeedsQuery} [getFeedsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFeeds(getFeedsQuery?: GetFeedsQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFeeds(getFeedsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetCalendarsCommand} [getCalendarsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getGoogleCalendars(getCalendarsCommand?: GetCalendarsCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGoogleCalendars(getCalendarsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetLanguageFiltersRequest} [getLanguageFiltersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLanguageFilters(getLanguageFiltersRequest?: GetLanguageFiltersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLanguageFilters(getLanguageFiltersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLocalFavoritesCategories(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLocalFavoritesCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetMicrosoftCalendarsCommand} [getMicrosoftCalendarsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMicrosoftCalendars(getMicrosoftCalendarsCommand?: GetMicrosoftCalendarsCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMicrosoftCalendars(getMicrosoftCalendarsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetMindBodySitesCommand} [getMindBodySitesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMindBodySites(getMindBodySitesCommand?: GetMindBodySitesCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMindBodySites(getMindBodySitesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetModerationContentRequest} [getModerationContentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getModerationContent(getModerationContentRequest?: GetModerationContentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getModerationContent(getModerationContentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetMomentusRoomsCommand} [getMomentusRoomsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMomentusRooms(getMomentusRoomsCommand?: GetMomentusRoomsCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMomentusRooms(getMomentusRoomsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetMomentusVenusCommand} [getMomentusVenusCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMomentusVenues(getMomentusVenusCommand?: GetMomentusVenusCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMomentusVenues(getMomentusVenusCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetOffMenuAccountPackagesQuery} [getOffMenuAccountPackagesQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOffMenuAccountPackages(getOffMenuAccountPackagesQuery?: GetOffMenuAccountPackagesQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOffMenuAccountPackages(getOffMenuAccountPackagesQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetOneTimeProviderAuthsRequestQuery} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneTimeAuthRequests(query?: GetOneTimeProviderAuthsRequestQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneTimeAuthRequests(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPackagesQuery} [getPackagesQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPackagesByIds(getPackagesQuery?: GetPackagesQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPackagesByIds(getPackagesQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPlayerAuthenticationSecret(body?: object, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPlayerAuthenticationSecret(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPowerBIDashboardsRequest} [getPowerBIDashboardsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPowerBIDashboards(getPowerBIDashboardsRequest?: GetPowerBIDashboardsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPowerBIDashboards(getPowerBIDashboardsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPowerBIReportsRequest} [getPowerBIReportsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPowerBIReports(getPowerBIReportsRequest?: GetPowerBIReportsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPowerBIReports(getPowerBIReportsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPowerBITilesRequest} [getPowerBITilesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPowerBITiles(getPowerBITilesRequest?: GetPowerBITilesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPowerBITiles(getPowerBITilesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPowerBIWorkspacesRequest} [getPowerBIWorkspacesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPowerBIWorkspaces(getPowerBIWorkspacesRequest?: GetPowerBIWorkspacesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPowerBIWorkspaces(getPowerBIWorkspacesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAccountPrimaryContactQuery} [getAccountPrimaryContactQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPrimaryContact(getAccountPrimaryContactQuery?: GetAccountPrimaryContactQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPrimaryContact(getAccountPrimaryContactQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetProratedTotalQuery} [getProratedTotalQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getProratedTotal(getProratedTotalQuery?: GetProratedTotalQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getProratedTotal(getProratedTotalQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetProviderAuthSidedoorCommand} [getProviderAuthSidedoorCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getProviderAuthSidedoor(getProviderAuthSidedoorCommand?: GetProviderAuthSidedoorCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getProviderAuthSidedoor(getProviderAuthSidedoorCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetProviderAuthsQuery} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getProviderAuths(query?: GetProviderAuthsQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getProviderAuths(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetProvidersQuery} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getProviders(query?: GetProvidersQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getProviders(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSamsungVxtFeedRequest} [getSamsungVxtFeedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSamsungVxtFeed(getSamsungVxtFeedRequest?: GetSamsungVxtFeedRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSamsungVxtFeed(getSamsungVxtFeedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSocialSearchAuthorizationsQuery} [getSocialSearchAuthorizationsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSocialSearchAuthorizations(getSocialSearchAuthorizationsQuery?: GetSocialSearchAuthorizationsQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSocialSearchAuthorizations(getSocialSearchAuthorizationsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSportsLeagues(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSportsLeagues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSportsTeamsRequest} [getSportsTeamsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSportsTeams(getSportsTeamsRequest?: GetSportsTeamsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSportsTeams(getSportsTeamsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetStockSymbolsRequest} [getStockSymbolsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStockSymbols(getStockSymbolsRequest?: GetStockSymbolsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStockSymbols(getStockSymbolsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSubscribedPackagesQuery} [getSubscribedPackagesQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSubscribedPackages(getSubscribedPackagesQuery?: GetSubscribedPackagesQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSubscribedPackages(getSubscribedPackagesQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSubscriptionPricingQuery} [getSubscriptionPricingQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSubscriptionPricing(getSubscriptionPricingQuery?: GetSubscriptionPricingQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSubscriptionPricing(getSubscriptionPricingQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSubscriptionsQuery} [getSubscriptionsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSubscriptions(getSubscriptionsQuery?: GetSubscriptionsQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSubscriptions(getSubscriptionsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTimezones(body?: object, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTimezones(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrafficRegions(body?: object, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrafficRegions(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetTrafficRoutesQuery} [getTrafficRoutesQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrafficRoutes(getTrafficRoutesQuery?: GetTrafficRoutesQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrafficRoutes(getTrafficRoutesQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetTrafficSetsQuery} [getTrafficSetsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrafficSets(getTrafficSetsQuery?: GetTrafficSetsQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrafficSets(getTrafficSetsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetTrialHistoryQuery} [getTrialHistoryQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrialHistory(getTrialHistoryQuery?: GetTrialHistoryQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrialHistory(getTrialHistoryQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HideModerationContentRequest} [hideModerationContentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public hideModerationContent(hideModerationContentRequest?: HideModerationContentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).hideModerationContent(hideModerationContentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public impersonated(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).impersonated(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ModerateContentRequest} [moderateContentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public moderateContent(moderateContentRequest?: ModerateContentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).moderateContent(moderateContentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PreviewBillRequest} [previewBillRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public previewBill(previewBillRequest?: PreviewBillRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).previewBill(previewBillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PurchaseSubscriptionsCommand} [purchaseSubscriptionsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public purchaseSubscriptions(purchaseSubscriptionsCommand?: PurchaseSubscriptionsCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).purchaseSubscriptions(purchaseSubscriptionsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReactivateSubscriptionCommand} [reactivateSubscriptionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public reactivateSubscription(reactivateSubscriptionCommand?: ReactivateSubscriptionCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reactivateSubscription(reactivateSubscriptionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemoveAccountBillingEmailRequest} [removeAccountBillingEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeAccountBillingEmail(removeAccountBillingEmailRequest?: RemoveAccountBillingEmailRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).removeAccountBillingEmail(removeAccountBillingEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemoveFeedRequest} [removeFeedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeFeed(removeFeedRequest?: RemoveFeedRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).removeFeed(removeFeedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateFeedNameCommand} [updateFeedNameCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public renameFeed(updateFeedNameCommand?: UpdateFeedNameCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).renameFeed(updateFeedNameCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RenameTrafficRegionCommand} [renameTrafficRegionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public renameTrafficRegion(renameTrafficRegionCommand?: RenameTrafficRegionCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).renameTrafficRegion(renameTrafficRegionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendCreateAccountSecurityStampCommand} [sendCreateAccountSecurityStampCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resendValidationEmail(sendCreateAccountSecurityStampCommand?: SendCreateAccountSecurityStampCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resendValidationEmail(sendCreateAccountSecurityStampCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendVerifyCode(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendVerifyCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetReferrerRequest} [setReferrerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public setReferrer(setReferrerRequest?: SetReferrerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).setReferrer(setReferrerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public simulateDownload(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).simulateDownload(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public subscribeAccountNotifications(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).subscribeAccountNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public subscribeToTestNotifications(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).subscribeToTestNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public subscribeUserNotifications(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).subscribeUserNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TryConnectCommand} [tryConnectCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public tryConnect(tryConnectCommand?: TryConnectCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).tryConnect(tryConnectCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnarchiveCustomerRequest} [unarchiveCustomerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public unarchiveCustomer(unarchiveCustomerRequest?: UnarchiveCustomerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).unarchiveCustomer(unarchiveCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnhideModerationContentRequest} [unhideModerationContentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public unhideModerationContent(unhideModerationContentRequest?: UnhideModerationContentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).unhideModerationContent(unhideModerationContentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnmoderateContentRequest} [unmoderateContentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public unmoderateContent(unmoderateContentRequest?: UnmoderateContentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).unmoderateContent(unmoderateContentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateAccountMetaInfoRequest} [updateAccountMetaInfoRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAccountMetaInfo(updateAccountMetaInfoRequest?: UpdateAccountMetaInfoRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAccountMetaInfo(updateAccountMetaInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateBillingAddressRequest} [updateBillingAddressRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateBillingAddress(updateBillingAddressRequest?: UpdateBillingAddressRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateBillingAddress(updateBillingAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCompanyRequest} [updateCompanyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCompany(updateCompanyRequest?: UpdateCompanyRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCompany(updateCompanyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateConnectionAuthCommand} [updateConnectionAuthCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateConnectionAuth(updateConnectionAuthCommand?: UpdateConnectionAuthCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateConnectionAuth(updateConnectionAuthCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateAccountContactCommand} [updateAccountContactCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateContact(updateAccountContactCommand?: UpdateAccountContactCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateContact(updateAccountContactCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [accountId] 
     * @param {string} [subdomain] 
     * @param {File} [logoFileData] 
     * @param {string} [bannerColor] 
     * @param {string} [accentColor] 
     * @param {string} [textColor] 
     * @param {string} [backgroundColor] 
     * @param {boolean} [shouldRemoveLogo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateContentMenu(accountId?: number, subdomain?: string, logoFileData?: File, bannerColor?: string, accentColor?: string, textColor?: string, backgroundColor?: string, shouldRemoveLogo?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateContentMenu(accountId, subdomain, logoFileData, bannerColor, accentColor, textColor, backgroundColor, shouldRemoveLogo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCreditCardRequest} [updateCreditCardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCreditCard(updateCreditCardRequest?: UpdateCreditCardRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCreditCard(updateCreditCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCustomerRequest} [updateCustomerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCustomer(updateCustomerRequest?: UpdateCustomerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCustomer(updateCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateFeedRequest} [updateFeedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFeed(updateFeedRequest?: UpdateFeedRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFeed(updateFeedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateFeedModerationMethodRequest} [updateFeedModerationMethodRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFeedModerationMethod(updateFeedModerationMethodRequest?: UpdateFeedModerationMethodRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFeedModerationMethod(updateFeedModerationMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateInvoicePONumberRequest} [updateInvoicePONumberRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateInvoicePONumber(updateInvoicePONumberRequest?: UpdateInvoicePONumberRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateInvoicePONumber(updateInvoicePONumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateLanguageFiltersRequest} [updateLanguageFiltersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateLanguageFilters(updateLanguageFiltersRequest?: UpdateLanguageFiltersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateLanguageFilters(updateLanguageFiltersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSamsungVxtFeedRequest} [updateSamsungVxtFeedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSamsungVxtFeed(updateSamsungVxtFeedRequest?: UpdateSamsungVxtFeedRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSamsungVxtFeed(updateSamsungVxtFeedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateTrafficRouteCommand} [updateTrafficRouteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTrafficRoute(updateTrafficRouteCommand?: UpdateTrafficRouteCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTrafficRoute(updateTrafficRouteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateTrafficSetCommand} [updateTrafficSetCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTrafficSet(updateTrafficSetCommand?: UpdateTrafficSetCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTrafficSet(updateTrafficSetCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateUserFromStoreCommand} [updateUserFromStoreCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUser(updateUserFromStoreCommand?: UpdateUserFromStoreCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUser(updateUserFromStoreCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} file The logo file to upload
     * @param {string} [originalFileName] Original name of the file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadLogo(file: File, originalFileName?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadLogo(file, originalFileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ValidateCreateAccountFromAccountCommand} [validateCreateAccountFromAccountCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public validateCreateAccountSecurityStamp(validateCreateAccountFromAccountCommand?: ValidateCreateAccountFromAccountCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).validateCreateAccountSecurityStamp(validateCreateAccountFromAccountCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [authorization] Optional Bearer token
     * @param {GetValidLocationQuery} [getValidLocationQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public validateLocation(authorization?: string, getValidLocationQuery?: GetValidLocationQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).validateLocation(authorization, getValidLocationQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ValidateSubdomainRequest} [validateSubdomainRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public validateSubdomain(validateSubdomainRequest?: ValidateSubdomainRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).validateSubdomain(validateSubdomainRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyCodeCommand} [verifyCodeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyCode(verifyCodeCommand?: VerifyCodeCommand, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyCode(verifyCodeCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



